
/* ---- js/src/00-boot.js ---- */
/**
 * Atrium — Alpine bootstrap, shared stores and helpers.
 *
 * ── HOUSE RULE: NO ES6 TEMPLATE LITERALS IN THIS FOLDER ──────────────────────
 * CubeCart minifies skin JS with JSMin (includes/smarty/plugins/minify/JSmin.php,
 * Crockford 2002), which predates backticks and does not understand them.
 * Verified by execution against this tree's own copy:
 *
 *   backtick string containing an apostrophe
 *       -> throws JSMin_UnterminatedStringException (PHP fatal, white screen
 *          for every customer on every page)
 *   backtick string containing a URL
 *       -> truncated at "http:" — the // is read as a line comment
 *   backtick string containing a block comment
 *       -> the commented span is deleted from inside the string
 *   backtick string with a space after an interpolation
 *       -> the space is silently eaten, corrupting the output
 *
 * Everything else in ES2020 is safe: arrow functions, classes, ?., ??=, spread,
 * async/await, destructuring, object shorthand.
 *
 * This bundle currently bypasses {combine}, so it would survive — but the rule
 * is kept folder-wide so nobody has to remember which files are exempt.
 * ─────────────────────────────────────────────────────────────────────────────
 *
 * Load order is handled for us: every registration below happens inside an
 * 'alpine:init' listener, and Alpine core fires that event after all deferred
 * scripts have run. So this file works regardless of where it lands in the
 * <script> order, which matters because CubeCart's auto-loader sorts js/*.js as
 * strings (10.foo.js sorts before 2.foo.js).
 */

(function () {
    'use strict';

    /** CubeCart's CSRF token. Core injects a hidden input before every </form>
     *  (GUI::display()) and rejects POSTs without it
     *  (Sanitize::checkToken()). Read it from the DOM rather than
     *  templating it in, so AJAX calls always use a current value. */
    function ccToken() {
        var el = document.querySelector('input.cc_session_token, input[name="token"]');
        return el ? el.value : '';
    }

    /** Build a storefront URL with CubeCart's query-string conventions. */
    function ccUrl(params) {
        var base = (window.CC_ROOT_PATH || '') + 'index.php';
        var qs = new URLSearchParams(params || {}).toString();
        return qs ? base + '?' + qs : base;
    }

    /** POST a form to CubeCart and return the raw response text.
     *  Endpoints such as _g=ajaxadd return HTML fragments, not JSON — that is a
     *  documented plugin API (GUI::displaySideBasket()). Do not "improve"
     *  it into JSON. */
    async function ccPost(url, formData) {
        var res = await fetch(url, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!res.ok) throw new Error('Request failed: ' + res.status);
        return res.text();
    }

    window.ccToken = ccToken;
    window.ccUrl = ccUrl;
    window.ccPost = ccPost;

    /**
 * Announce something to screen readers.
 *
 * Writes into the polite live region in main.php. Nothing in this skin used to
 * be announced at all: adding to the basket swapped the mini-basket, changed
 * the icon and played an animation, and a screen reader user heard silence.
 *
 * The text is always lifted from markup the server already rendered, never
 * built here, so it stays translated without shipping strings into JS.
 *
 * The region is cleared first: assistive tech ignores a write that is identical
 * to what is already there, so adding the same product twice would announce
 * once. The clear-then-set on the next frame makes it a fresh change.
 */
window.ccAnnounce = function (text) {
    var region = document.getElementById('cc-live');
    if (!region || !text) return;
    region.textContent = '';
    window.requestAnimationFrame(function () {
        region.textContent = String(text).replace(/\s+/g, ' ').trim();
    });
};

document.addEventListener('alpine:init', function () {
        var Alpine = window.Alpine;

        /* ── Stores ──────────────────────────────────────────────────────────
           Cross-fragment state lives here, never inside a component. The basket
           count appears in the header, the mobile drawer and the mini-basket at
           once; an AJAX call replaces only one of those fragments, so a
           component-local count would desync the other two. */
        Alpine.store('ui', {
            menuOpen: false,
            drawerOpen: false,
            searchOpen: false,
            /* Product page only: true once the real Add to Basket button has
               scrolled out of view, which reveals the sticky bar. Set by an
               IntersectionObserver in 20-product.js. */
            stickyBuy: false,

            closeAll: function () {
                this.menuOpen = false;
                this.drawerOpen = false;
                this.searchOpen = false;
            }
        });

        Alpine.store('basket', {
            /* Seeded from the server-rendered markup so the first paint is
               correct with JS disabled or slow. */
            count: 0,
            total: '',

            /** Adopt the authoritative values off a freshly injected fragment. */
            syncFrom: function (el) {
                if (!el) return;
                var c = el.getAttribute('data-basket-count');
                var t = el.getAttribute('data-basket-total');
                if (c !== null) this.count = parseInt(c, 10) || 0;
                if (t !== null) this.total = t;
            }
        });

        /* ── Components ──────────────────────────────────────────────────── */

        /** Dismissible flash message. Used by box.errors.php. */
        Alpine.data('ccAlert', function () {
            return {
                shown: true,
                dismiss: function () { this.shown = false; }
            };
        });

        /** Generic disclosure: dropdowns, accordions, the mobile nav.
         *  Closes on Escape and on click outside. */
        Alpine.data('ccDisclosure', function (initial) {
            return {
                open: initial === true,
                toggle: function () { this.open = !this.open; },
                close: function () { this.open = false; }
            };
        });

        /** Tab set. The active panel id must be declared here rather than
         *  bolted on with x-init: Alpine only makes properties reactive if they
         *  exist on the data object when the component initialises. */
        Alpine.data('ccTabs', function (initial) {
            return {
                tab: initial || '',
                select: function (id) { this.tab = id; },
                isActive: function (id) { return this.tab === id; }
            };
        });

        /** Off-canvas panel (mobile nav, mini-basket drawer).
         *  Locks body scroll while open and restores it on close — reference
         *  counted via a data attribute so two panels cannot fight over it. */
        Alpine.data('ccDrawer', function (storeKey) {
            return {
                get open() {
                    return Alpine.store('ui')[storeKey] === true;
                },
                set open(v) {
                    Alpine.store('ui')[storeKey] = v;
                },
                close: function () { this.open = false; },
                lock: function () {
                    var n = parseInt(document.body.dataset.ccLocks || '0', 10) + 1;
                    document.body.dataset.ccLocks = String(n);
                    document.body.style.overflow = 'hidden';
                },
                unlock: function () {
                    var n = Math.max(0, parseInt(document.body.dataset.ccLocks || '0', 10) - 1);
                    document.body.dataset.ccLocks = String(n);
                    if (n === 0) document.body.style.overflow = '';
                }
            };
        });
    });
})();
;

/* ---- js/src/11-search.js ---- */
/**
 * Atrium — search-as-you-type.
 *
 * HOUSE RULE: no ES6 template literals in this folder. See 00-boot.js.
 *
 * Endpoint contract, unchanged from foundation's 2.cubecart.js:
 *   GET ?_e=es&q=<term>&a=<amount>
 * returns a JSON array of {product_id, name, thumbnail}, or something that is
 * not an array when there are no matches. Only active when Elasticsearch is
 * enabled, which the template signals with the `es` class on the input —
 * exactly the flag foundation used.
 */

/* Header magnifier, below lg. The panel it reveals lives in main.php and the
   state is the shared ui store, so the drawer's closeAll() closes it too.
   Focus is moved on the next frame: x-show flips display, and an element that
   is still display:none cannot take focus. */
window.ccToggleSearch = function () {
    var store = window.Alpine.store('ui');
    store.searchOpen = !store.searchOpen;
    if (!store.searchOpen) return;
    // The drawer is positioned below a 4rem header; leaving it open while the
    // search row grows the header would leave a gap above it.
    store.menuOpen = false;
    window.requestAnimationFrame(function () {
        var el = document.getElementById('cc-search-input-mobile');
        if (el) el.focus();
    });
};

document.addEventListener('alpine:init', function () {
    window.Alpine.data('ccSearch', function (uid) {
        return {
            uid: uid || '',
            term: '',
            results: [],
            open: false,
            searched: false,
            /* Keyboard position in the result list. -1 means "in the input":
               Enter then submits the form and searches, which is what a
               customer who ignored the suggestions expects. */
            active: -1,
            /* Mirrors data-image. The template needs it so it can reserve the
               thumbnail slot even when a product has no image — 308 of the
               indexed products carry no `thumbnail` field at all, and without a
               placeholder those rows lose their 40px leading box and the text
               jumps left, breaking the column. */
            showImages: false,
            /* A newer query is in flight. Dims the stale list rather than
               blanking it, so the panel does not collapse and reflow between
               keystrokes. */
            busy: false,
            _seq: 0,

            close: function () {
                this.open = false;
                this.active = -1;
            },

            /** Stable per-row id, for aria-activedescendant. */
            optionId: function (i) {
                return 'sayt-opt' + this.uid + '-' + i;
            },

            /** Arrow keys. Wraps, so Up from the input lands on the last row. */
            move: function (delta) {
                if (!this.open || !this.results.length) return;
                var n = this.results.length;
                this.active = (this.active + delta + n) % n;
                var el = document.getElementById(this.optionId(this.active));
                // block:'nearest' keeps the panel still when the row is already visible.
                if (el) el.scrollIntoView({ block: 'nearest' });
            },

            /** Enter. Returns false when nothing is selected so the form submits. */
            choose: function () {
                var hit = this.results[this.active];
                if (this.active < 0 || !hit) return false;
                window.location = hit.url;
                return true;
            },

            /** Escape user input before it is ever put back into the DOM. */
            _escape: function (s) {
                return String(s)
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/"/g, '&quot;');
            },

            /** Bold each search word inside the (already escaped) product name. */
            _highlight: function (name, term) {
                var safe = this._escape(name);
                var words = term.split(/\s+/).filter(function (w) {
                    return w && w !== '*';
                });
                words.forEach(function (w) {
                    // Escape regex metacharacters in the user's own term.
                    var pattern = w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                    safe = safe.replace(new RegExp('(' + pattern + ')', 'ig'), '<strong>$1</strong>');
                });
                return safe;
            },

            async go() {
                var input = this.$refs.input;
                // No Elasticsearch -> no live search. Plain form submit still works.
                if (!input || !input.classList.contains('es')) return;

                var term = this.term.trim();
                if (!term) {
                    this.results = [];
                    this.searched = false;
                    this.busy = false;
                    this.open = false;
                    return;
                }

                var amount = input.getAttribute('data-amount') || 15;
                var showImages = input.getAttribute('data-image') === 'true';
                this.showImages = showImages;

                // Guard against out-of-order responses: only the newest wins.
                var seq = ++this._seq;
                this.busy = true;

                try {
                    var res = await fetch('?_e=es&q=' + encodeURIComponent(term) + '&a=' + encodeURIComponent(amount), {
                        credentials: 'same-origin'
                    });
                    var data = await res.json();
                    if (seq !== this._seq) return;

                    var self = this;
                    this.results = Array.isArray(data) ? data.map(function (p) {
                        return {
                            product_id: p.product_id,
                            name: p.name,
                            url: '?_a=product&product_id=' + encodeURIComponent(p.product_id),
                            thumbnail: showImages && p.thumbnail ? p.thumbnail : '',
                            highlighted: self._highlight(p.name, term)
                        };
                    }) : [];
                } catch (e) {
                    if (seq !== this._seq) return;
                    this.results = [];
                }

                this.busy = false;
                this.searched = true;
                this.open = true;
                this.active = -1;

                /* Announce only the empty case, and only from the markup the
                   server rendered: a bare result count would need a string this
                   skin does not have, and an untranslated one is worse than
                   silence. */
                if (!this.results.length) {
                    var empty = document.querySelector('#sayt_results, #sayt_results-mobile');
                    empty = empty && empty.parentNode ? empty.parentNode.querySelector('p') : null;
                    if (empty) window.ccAnnounce(empty.textContent);
                }
            }
        };
    });
});
;

/* ---- js/src/12-basket.js ---- */
/**
 * Atrium — add to basket.
 *
 * HOUSE RULE: no ES6 template literals in this folder. See 00-boot.js.
 *
 * ENDPOINT CONTRACT (do not change — this is core behaviour, not skin behaviour):
 *   POST <form action> + "&_g=ajaxadd&t=<timestamp>"
 *   handled by the 'ajaxadd' case in Cubecart::loadPage() -> GUI::displaySideBasket()
 *
 *   Response is one of:
 *     "Redir:<url>"  -> the store is configured to jump to the basket
 *                       (config basket_jump_to, Cart::add())
 *     <html>         -> the rendered box.basket.php fragment, to be swapped
 *                       into #mini-basket
 *
 *   It returns HTML rather than JSON, and plugins hook
 *   class.gui.display_side_basket to modify that HTML. Do not "improve" this
 *   into a JSON API — it is a published extension point.
 *
 * The CSRF token is already inside the form: core injects a hidden input before
 * every </form> (GUI::display()), and FormData picks it up, so the
 * POST satisfies Sanitize::checkToken().
 */

document.addEventListener('alpine:init', function () {
    window.Alpine.data('ccAddToBasket', function () {
        return {
            busy: false,
            added: false,

            async submit(event) {
                var form = event.target;

                // Let the browser enforce required options (a required select
                // with no choice, a required text option left empty).
                if (!form.reportValidity()) return;

                event.preventDefault();
                if (this.busy) return;
                this.busy = true;

                /* Fire the flight NOW, not after the response: it has to be
                   measured against the page the customer clicked on, and the
                   mini-basket is replaced wholesale below. The first image in
                   the form is the product one in both places this form appears
                   — the gallery is inside the form on the product page, and the
                   thumbnail is inside it on a listing. */
                if (window.ccFlyToBasket) window.ccFlyToBasket(form.querySelector('img'));

                var action = form.getAttribute('action') || window.location.href;
                action = action.replace(/\?.*/, '');
                var url = action + (action.indexOf('?') > -1 ? '&' : '?') +
                          '_g=ajaxadd&t=' + new Date().getTime();

                try {
                    var text = await window.ccPost(url, new FormData(form));

                    if (text.indexOf('Redir:') !== -1) {
                        window.location = text.split('Redir:')[1];
                        return;
                    }

                    // Swap the mini-basket. Alpine's MutationObserver
                    // initialises x-data on the inserted subtree automatically,
                    // so the replacement is live with no re-init call.
                    /* Guard against a response that is not the mini-basket
                       fragment. A rejected CSRF token, an expired session or a
                       plugin error all return a full page, and injecting one
                       into the header with outerHTML tears the DOM apart and
                       re-initialises a second copy of every component on it. */
                    if (text.indexOf('id="mini-basket"') === -1) {
                        form.submit();
                        return;
                    }

                    var host = document.getElementById('mini-basket');
                    if (host) {
                        host.outerHTML = text;
                        var fresh = document.getElementById('mini-basket');
                        if (fresh) {
                            window.Alpine.store('basket').syncFrom(fresh);
                            /* The swapped fragment carries a translated
                               "Your basket total is X" for screen readers.
                               Reuse it rather than inventing a string here. */
                            var spoken = fresh.querySelector('.cc-sr-only');
                            if (spoken) window.ccAnnounce(spoken.textContent);
                            // Settle the swapped fragment and bump the count, so
                            // the basket visibly acknowledges the add. Removed
                            // once played, or a second add would not replay it
                            // (the class would already be on the element).
                            fresh.classList.add('cc-basket-updated');
                            setTimeout(function () {
                                fresh.classList.remove('cc-basket-updated');
                            }, 400);
                        }
                    }

                    this.added = true;
                    var self = this;
                    setTimeout(function () { self.added = false; }, 2500);
                } catch (e) {
                    // Network failure: fall back to a normal form post rather
                    // than silently losing the customer's click.
                    form.submit();
                } finally {
                    this.busy = false;
                }
            }
        };
    });
});
;

/* ---- js/src/13-flight.js ---- */
/**
 * Atrium — product image flies to the basket. No template literals (00-boot.js).
 *
 * Called at click time, not after the response: both elements must be measured
 * before the mini-basket fragment is swapped out. Every guard returns rather
 * than throws — a flourish must not be able to break a purchase.
 */
window.ccFlyToBasket = function (img) {
    if (!img) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var target = document.getElementById('mini-basket');
    if (!target) return;

    var from = img.getBoundingClientRect();
    var to = target.getBoundingClientRect();
    // Not laid out, or the off-screen below-sm basket.
    if (!from.width || !to.width) return;

    var clone = document.createElement('img');
    if (!clone.animate) return;               // no Web Animations API
    clone.src = img.currentSrc || img.src;
    clone.alt = '';
    clone.setAttribute('aria-hidden', 'true');
    clone.className = 'cc-flight';
    clone.style.left = from.left + 'px';
    clone.style.top = from.top + 'px';
    clone.style.width = from.width + 'px';
    clone.style.height = from.height + 'px';
    document.body.appendChild(clone);

    var dx = (to.left + to.width / 2) - (from.left + from.width / 2);
    var dy = (to.top + to.height / 2) - (from.top + from.height / 2);

    // Lifted 70px: a straight line reads as a file transfer, the arc as a throw.
    var flight = clone.animate([
        { transform: 'translate(0px, 0px) scale(1)', opacity: 0.95 },
        { transform: 'translate(' + (dx * 0.5) + 'px, ' + ((dy * 0.5) - 70) + 'px) scale(0.55)', opacity: 0.9, offset: 0.55 },
        { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(0.12)', opacity: 0.15 }
    ], { duration: 620, easing: 'cubic-bezier(0.33, 0, 0.67, 1)' });

    function cleanup() { if (clone.parentNode) clone.remove(); }
    flight.onfinish = cleanup;
    flight.oncancel = cleanup;
    // A backgrounded tab can leave it neither finished nor cancelled.
    window.setTimeout(cleanup, 1500);
};
;

/* ---- js/src/14-controls.js ---- */
/**
 * Atrium — controls the templates cannot write themselves. No template literals
 * (00-boot.js).
 *
 * Password reveal + strength, quantity steppers, back-to-top. All progressive
 * enhancement; labels come from element.ui_strings.php so none are hardcoded.
 */
(function () {
    'use strict';

    var S = {};

    function label(el, text) {
        el.setAttribute('aria-label', text);
        el.title = text;
    }

    function icon(path, size) {
        return '<svg class="size-' + (size || 5) + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
               'stroke-width="1.75" aria-hidden="true">' + path + '</svg>';
    }

    var EYE = '<path d="M2.036 12.322a1 1 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178a1 1 0 0 1 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.964-7.178Z" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="12" r="3" stroke-linecap="round" stroke-linejoin="round"/>';
    var EYE_OFF = '<path d="M3.98 8.223A10.5 10.5 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0 1 12 4.5c4.756 0 8.774 3.162 10.066 7.5a10.5 10.5 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243" stroke-linecap="round" stroke-linejoin="round"/>';

    /* Every password field, rather than templated into four forms. */
    function password(input) {
        if (input.getAttribute('data-cc-reveal')) return;
        input.setAttribute('data-cc-reveal', '1');

        var wrap = document.createElement('div');
        wrap.className = 'relative';
        input.parentNode.insertBefore(wrap, input);
        wrap.appendChild(input);
        input.classList.add('pe-11');

        var button = document.createElement('button');
        button.type = 'button';          // these sit inside forms
        button.className = 'absolute inset-y-0 end-0 flex w-11 items-center justify-center text-ink-500 hover:text-ink-800';
        button.setAttribute('aria-pressed', 'false');
        button.innerHTML = icon(EYE);
        label(button, S.show_password || 'Show password');

        button.addEventListener('click', function () {
            var reveal = input.type === 'password';
            input.type = reveal ? 'text' : 'password';
            button.setAttribute('aria-pressed', reveal ? 'true' : 'false');
            button.innerHTML = icon(reveal ? EYE_OFF : EYE);
            label(button, reveal ? (S.hide_password || 'Hide password') : (S.show_password || 'Show password'));
            input.focus();
        });
        wrap.appendChild(button);
    }

    /* Opt-in with data-cc-stepper: a listing tile in a two-column phone grid
       has no room for two more buttons beside Add to Basket. */
    function stepper(input) {
        if (input.getAttribute('data-cc-stepped')) return;
        input.setAttribute('data-cc-stepped', '1');

        /* The buttons honour min/max, but typing does not. Clamp on change so a
           typed 50 becomes the 3 that are actually in stock, rather than being
           trimmed by core after the customer has already submitted. */
        input.addEventListener('change', function () {
            var max = parseFloat(input.max);
            var min = parseFloat(input.min);
            var value = parseFloat(input.value);
            if (isNaN(value)) return;
            if (!isNaN(max) && value > max) input.value = max;
            else if (!isNaN(min) && value < min) input.value = min;
        });

        var group = document.createElement('span');
        group.className = 'inline-flex items-center gap-1';
        input.parentNode.insertBefore(group, input);

        group.appendChild(button(-1, input));
        group.appendChild(input);
        group.appendChild(button(1, input));
    }

    function button(delta, input) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cc-btn cc-btn-secondary size-10 shrink-0 p-0 text-lg leading-none';
        b.textContent = delta < 0 ? '−' : '+';   // real minus sign, not a hyphen
        label(b, delta < 0 ? (S.quantity_decrease || 'Decrease quantity') : (S.quantity_increase || 'Increase quantity'));
        b.addEventListener('click', function () {
            var step = parseFloat(input.step) || 1;
            var min = input.min === '' ? null : parseFloat(input.min);
            var max = input.max === '' ? null : parseFloat(input.max);
            var value = (parseFloat(input.value) || 0) + (delta * step);
            if (min !== null && value < min) value = min;
            if (max !== null && !isNaN(max) && value > max) value = max;
            input.value = value;
            // Both: x-model listens for input, the basket's auto-submit for
            // change, and a scripted value fires neither.
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        return b;
    }


    /* ── Password strength ───────────────────────────────────────────────
       Length-first on purpose: 3 of 4 points are length, 1 is variety. NIST
       800-63B warns composition rules push people to "Password1!", weaker than
       three plain words. No library and no network: a breach-list lookup would
       be a third-party request on registration and checkout. */
    var COMMON = ('123456 password 123456789 12345678 12345 qwerty abc123 111111 123123 1234567890 ' +
                  '1234567 letmein monkey dragon baseball iloveyou trustno1 sunshine master welcome ' +
                  'shadow ashley football jesus michael ninja mustang password1 qwerty123 admin ' +
                  'login starwars passw0rd freedom whatever princess qazwsx superman hello charlie ' +
                  'donald aa123456 access flower hottie loveme zaq1zaq1 password123 querty').split(' ');

    function isCommon(value) {
        var v = value.toLowerCase();
        for (var i = 0; i < COMMON.length; i++) {
            if (COMMON[i] === v) return true;
        }
        return false;
    }

    /** -1 empty, 0 weak, 1 fair, 2 good, 3 strong. */
    function score(value, min) {
        if (!value) return -1;
        // Anything the form will reject reads Weak, or the meter and the
        // browser's "too short" message contradict each other.
        if (value.length < min) return 0;
        if (isCommon(value)) return 0;
        var s = 0;
        if (value.length >= 8) s++;
        if (value.length >= 12) s++;
        if (value.length >= 16) s++;
        var variety = (/[a-z]/.test(value) ? 1 : 0) + (/[A-Z]/.test(value) ? 1 : 0) +
                      (/[0-9]/.test(value) ? 1 : 0) + (/[^A-Za-z0-9]/.test(value) ? 1 : 0);
        if (variety >= 3) s++;
        return Math.min(s, 3);
    }

    var BAR = ['bg-danger-600', 'bg-warn-600', 'bg-brand-600', 'bg-success-600'];

    function meter(input) {
        if (input.getAttribute('data-cc-meter')) return;
        input.setAttribute('data-cc-meter', '1');

        var wrap = document.createElement('div');
        wrap.className = 'mt-2';
        wrap.hidden = true;

        var track = document.createElement('div');
        track.className = 'h-1 w-full overflow-hidden rounded-full bg-ink-200';
        var fill = document.createElement('div');
        fill.className = 'h-full w-0 rounded-full transition-all duration-200';
        track.appendChild(fill);

        var text = document.createElement('p');
        // polite: this updates on every keystroke.
        text.className = 'mt-1 text-xs text-ink-600';
        text.setAttribute('aria-live', 'polite');

        wrap.appendChild(track);
        wrap.appendChild(text);
        // After the reveal wrapper, so it sits under the field.
        (input.parentNode.parentNode || input.parentNode).insertBefore(wrap, input.parentNode.nextSibling);

        var min = parseInt(input.getAttribute('minlength'), 10) || 8;   // tracks core

        input.addEventListener('input', function () {
            var value = input.value;
            var s = score(value, min);
            if (s < 0) {
                wrap.hidden = true;
                return;
            }
            wrap.hidden = false;
            fill.className = 'h-full rounded-full transition-all duration-200 ' + BAR[s];
            fill.style.width = ((s + 1) * 25) + '%';

            var levels = S.pw_levels || ['Weak', 'Fair', 'Good', 'Strong'];
            var hint = '';
            if (isCommon(value)) hint = S.pw_hint_common || '';
            else if (value.length < 12) hint = S.pw_hint_length || '';
            text.textContent = (S.pw_strength || 'Password strength') + ': ' + levels[s] + (hint ? ' — ' + hint : '');
        });
    }

    /* Created here, not templated, so it exists on every layout. */
    function backToTop() {
        var button = document.createElement('button');
        button.type = 'button';
        /* Bottom-left and lifted below lg: chat widgets sit bottom-right, and
           the sticky buy bar is full-width at bottom-0. */
        button.className = 'cc-to-top cc-btn cc-btn-secondary fixed bottom-20 start-4 z-40 size-11 p-0 shadow-lg lg:bottom-4';
        button.hidden = true;
        button.innerHTML = icon('<path d="M12 19V5m0 0-7 7m7-7 7 7" stroke-linecap="round" stroke-linejoin="round"/>');
        label(button, S.back_to_top || 'Back to top');

        button.addEventListener('click', function () {
            var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
            // Or focus stays on a button that just hid itself.
            var main = document.getElementById('main_content');
            if (main) {
                main.setAttribute('tabindex', '-1');
                main.focus({ preventScroll: true });
            }
        });
        document.body.appendChild(button);

        var ticking = false;
        window.addEventListener('scroll', function () {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(function () {
                button.hidden = window.scrollY < 800;
                ticking = false;
            });
        }, { passive: true });
    }

    function init() {
        var el = document.getElementById('cc-ui-strings');
        if (el) {
            try { S = JSON.parse(el.textContent) || {}; } catch (e) { S = {}; }
        }

        var i;
        var fields = document.querySelectorAll('input[type="password"]');
        for (i = 0; i < fields.length; i++) password(fields[i]);

        // Only where a password is being CHOSEN, never on the login field.
        var setting = document.querySelectorAll('input[type="password"][autocomplete="new-password"]');
        for (i = 0; i < setting.length; i++) meter(setting[i]);

        var steppers = document.querySelectorAll('input[data-cc-stepper]');
        for (i = 0; i < steppers.length; i++) stepper(steppers[i]);

        backToTop();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
}());
;

/* ---- js/src/20-product.js ---- */
/**
 * Atrium — product page: option-driven price recalculation and image swapping.
 *
 * HOUSE RULE: no ES6 template literals in this folder. See 00-boot.js.
 *
 * ENDPOINT CONTRACT (core, not skin):
 *   GET <form action> + "&_g=ajax_price_format&price[0]=<n>[&price[1]=<n>]"
 *   handled by the 'ajax_price_format' case in Cubecart::loadPage(), which returns a JSON ARRAY
 *   of currency-formatted strings in the same order.
 *
 *   Prices must be formatted server-side: only PHP knows the store's currency,
 *   decimal places, tax mode and rounding. Never format money in JS.
 *
 * DOM CONTRACT (set by element.product.call_to_action.php):
 *   #ptp  data-price = price_to_pay      the price actually charged
 *   #fbp  data-price = full_base_price   the "was" price; present only on sale
 *
 * OPTION PRICING (element.product.options.php):
 *   [name^=productOptions] carry data-price and data-price-original.
 *   class="absolute" means the option REPLACES the base price rather than
 *   adding to it — subtract the base before adding the option's own price.
 *
 * COMBINATION STOCK (#cc-option-stock, from Catalogue::optionStockMap):
 *   {participants:[assign_id...], combinations:{"46|53":{ok:false,note:""}}}
 *   Keyed on assign_id because that is what the form posts. Only participants
 *   count towards the key — a product can carry options that are not part of
 *   the stock matrix, and including one would never match. An unknown
 *   combination means "no opinion": leave the button alone and let the server
 *   decide, exactly as before.
 *
 *   ⚠ A STORE, not component state. The option fields and the add-to-basket
 *   button sit inside ccAddToBasket, so @change on a select is evaluated in
 *   THAT scope: reads resolve up to ccProduct, but a write lands on the child
 *   scope and the parent never sees it. Held here once, read by both.
 */

document.addEventListener('alpine:init', function () {
    window.Alpine.store('optionStock', {
        available: true,
        note: '',
        // Stock of the SELECTED combination, or 0 when unknown or not low.
        // Core only publishes it up to Catalogue::LOW_STOCK_DISCLOSE_MAX.
        stock: 0,
        _map: null,
        _one: '',
        _many: '',

        load: function () {
            var el = document.getElementById('cc-option-stock');
            if (!el) return;
            // Translated on the server; %d is substituted here.
            this._one = el.getAttribute('data-low-one') || '';
            this._many = el.getAttribute('data-low-many') || '';
            try {
                var data = JSON.parse(el.textContent);
                if (data && data.combinations) this._map = data;
            } catch (e) {
                // A malformed payload must not take the page down with it.
                this._map = null;
            }
        },

        /* Hold the quantity field to what the chosen combination has left.
           Core trims an over-order on submit, but only after the customer has
           committed to it. data-qty-max is the product-level ceiling, restored
           when this combination publishes no figure of its own — which is also
           the case above LOW_STOCK_DISCLOSE_MAX, where the exact count is
           deliberately not in the page. */
        capQuantity: function () {
            var input = document.getElementById('product_quantity');
            if (!input) return;

            var base = parseInt(input.getAttribute('data-qty-max'), 10);
            var max = this.stock > 0 ? this.stock : null;
            if (!isNaN(base)) max = (max === null) ? base : Math.min(base, max);

            if (max === null) {
                input.removeAttribute('max');
                return;
            }
            input.max = max;
            if ((parseInt(input.value, 10) || 0) > max) {
                input.value = max;
                input.dispatchEvent(new Event('input', { bubbles: true }));
                input.dispatchEvent(new Event('change', { bubbles: true }));
            }
        },

        /** "Only 2 left in stock" for the current combination, or ''. */
        lowText: function (threshold) {
            var n = this.stock;
            if (!n || !threshold || n > threshold) return '';
            var s = (n === 1 && this._one) ? this._one : this._many;
            return s ? s.replace('%d', n) : '';
        },

        /* Judge the combination currently selected on the page.
           Scans the DOCUMENT rather than taking an element: called from a
           @change handler, Alpine's $el is the SELECT that fired, not the
           component root, so searching "inside" it finds nothing. Only one
           product form carries productOptions fields, and `participants`
           filters out anything not in the stock matrix anyway. */
        check: function () {
            if (!this._map) return;

            var participants = this._map.participants || [];
            var chosen = [];
            var fields = document.querySelectorAll('[name^=productOptions]');
            for (var i = 0; i < fields.length; i++) {
                var field = fields[i];
                if ((field.type === 'radio' || field.type === 'checkbox') && !field.checked) continue;
                var id = parseInt(field.value, 10);
                if (participants.indexOf(id) !== -1) chosen.push(id);
            }

            // Nothing from the matrix chosen yet, so there is nothing to judge.
            if (!chosen.length) {
                this.available = true;
                this.note = '';
                this.stock = 0;
                return;
            }

            chosen.sort(function (a, b) { return a - b; });
            var entry = this._map.combinations[chosen.join('|')];
            this.available = entry ? !!entry.ok : true;
            this.note = (entry && entry.note) ? entry.note : '';
            this.stock = (entry && entry.stock) ? entry.stock : 0;
            this.capQuantity();
        }
    });

    window.Alpine.data('ccProduct', function () {
        return {
            _seq: 0,

            init: function () {
                window.Alpine.store('optionStock').load();
                window.Alpine.store('optionStock').check();
                this.watchBuyButton();

                // Only meaningful when there is a price element AND options.
                if (!document.getElementById('ptp')) return;
                if (!this.$el.querySelector('[name^=productOptions]')) return;
                this.recalc();
            },

            /** Sum the selected options, then ask the server to format. */
            async recalc() {
                var ptpEl = document.getElementById('ptp');
                var fbpEl = document.getElementById('fbp');
                if (!ptpEl) return;

                var base = parseFloat(ptpEl.getAttribute('data-price'));
                var baseOriginal = fbpEl ? parseFloat(fbpEl.getAttribute('data-price')) : null;
                if (isNaN(base)) return;

                var delta = 0;
                var deltaOriginal = 0;
                var fields = this.$el.querySelectorAll('[name^=productOptions]');

                fields.forEach(function (el) {
                    var price, priceOriginal, absolute;

                    if (el.tagName === 'SELECT') {
                        var opt = el.options[el.selectedIndex];
                        if (!opt || !el.value) return;
                        price = parseFloat(opt.getAttribute('data-price'));
                        priceOriginal = parseFloat(opt.getAttribute('data-price-original'));
                        absolute = opt.classList.contains('absolute');
                    } else if (el.type === 'radio' || el.type === 'checkbox') {
                        if (!el.checked) return;
                        price = parseFloat(el.getAttribute('data-price'));
                        priceOriginal = parseFloat(el.getAttribute('data-price-original'));
                        absolute = el.classList.contains('absolute');
                    } else if (el.type === 'hidden') {
                        price = parseFloat(el.getAttribute('data-price'));
                        priceOriginal = parseFloat(el.getAttribute('data-price-original'));
                        absolute = el.classList.contains('absolute');
                    } else {
                        // text / textarea: only charged when the customer typed something
                        if (!el.value) return;
                        price = parseFloat(el.getAttribute('data-price'));
                        priceOriginal = parseFloat(el.getAttribute('data-price-original'));
                        absolute = el.classList.contains('absolute');
                    }

                    if (isNaN(price)) price = 0;
                    if (isNaN(priceOriginal)) priceOriginal = price;

                    if (absolute) {
                        delta -= base;
                        if (baseOriginal !== null) deltaOriginal -= baseOriginal;
                    }
                    delta += price;
                    deltaOriginal += priceOriginal;
                });

                var total = base + delta;
                var query = '_g=ajax_price_format&price[0]=' + encodeURIComponent(total);
                if (baseOriginal !== null) {
                    query += '&price[1]=' + encodeURIComponent(baseOriginal + deltaOriginal);
                }

                var action = (this.$el.getAttribute('action') || window.location.href);
                var url = action + (action.indexOf('?') > -1 ? '&' : '?') + query;

                var seq = ++this._seq;
                try {
                    var res = await fetch(url, { credentials: 'same-origin' });
                    var prices = await res.json();
                    if (seq !== this._seq) return;      // a newer change won
                    if (!Array.isArray(prices)) return;

                    ptpEl.innerHTML = prices[0];
                    // Keep the sticky bar's price in step with the options.
                    var mirrors = document.querySelectorAll('[data-cc-price-mirror]');
                    for (var m = 0; m < mirrors.length; m++) {
                        mirrors[m].innerHTML = prices[0];
                    }
                    if (fbpEl && prices.length > 1) {
                        fbpEl.innerHTML = prices[1];
                        // Hide the "was" price when the option choice has made
                        // it no cheaper than what is actually being charged.
                        var num = function (s) {
                            return parseFloat(String(s).replace(/[^0-9.-]/g, ''));
                        };
                        fbpEl.style.display = num(prices[0]) <= num(prices[1]) ? 'none' : '';
                    }
                } catch (e) {
                    // Leave the server-rendered price in place: a stale-but-real
                    // price is safer than a blank or a guess.
                }
            },

            /** Swap the main image when an option carries its own picture. */
            swapImage: function (event) {
                var el = event.target;
                var src = '';

                if (el.tagName === 'SELECT') {
                    var opt = el.options[el.selectedIndex];
                    src = opt ? opt.getAttribute('data-image') : '';
                } else if (el.type === 'radio' || el.type === 'checkbox') {
                    src = el.checked ? el.getAttribute('data-image') : '';
                } else {
                    src = el.getAttribute('data-image');
                }

                if (!src) return;
                var preview = document.getElementById('img-preview');
                if (preview) preview.src = src;
            },

            /* Reveal the sticky bar once the real button scrolls away.
               IntersectionObserver rather than a scroll handler: no listener
               running on every frame, and it reports the state on registration
               so the bar is correct if the customer lands mid-page on a
               #fragment. Browsers without it simply never show the bar, which
               is the behaviour this skin had until now. */
            watchBuyButton: function () {
                var target = document.getElementById('cc-main-buy');
                if (!target || !('IntersectionObserver' in window)) return;
                new window.IntersectionObserver(function (entries) {
                    /* isIntersecting alone is not enough: it is false both when
                       the button has scrolled off the TOP and when it is still
                       below the fold, and showing a duplicate buy button before
                       the customer has even reached the real one is just noise.
                       boundingClientRect.top < 0 distinguishes the two. */
                    var entry = entries[0];
                    var scrolledPast = entry.boundingClientRect.top < 0;
                    window.Alpine.store('ui').stickyBuy = !entry.isIntersecting && scrolledPast;
                }, { threshold: 0 }).observe(target);
            },

            onOptionChange: function (event) {
                this.recalc();
                this.swapImage(event);
                window.Alpine.store('optionStock').check();

                /* A failed add-to-basket reloads the PDP with a server-side
                   error, typically "that option combination is out of stock".
                   Picking a different option makes that error a statement about
                   a selection the customer is no longer making, so retire it.
                   box.errors.php listens for this on window. */
                window.dispatchEvent(new CustomEvent('cc-stale-errors'));
            }
        };
    });
});
;

/* ---- js/src/21-gallery.js ---- */
/**
 * Atrium — product image gallery and lightbox.
 *
 * HOUSE RULE: no ES6 template literals in this folder. See 00-boot.js.
 *
 * Replaces foundation's Clearing (Foundation 5) lightbox and its hover-swap
 * handler. #img-preview is a contract: 20-product.js swaps that element's src
 * when a product option carries its own image.
 */

document.addEventListener('alpine:init', function () {
    window.Alpine.data('ccGallery', function (initialFull) {
        return {
            full: initialFull || '',   // full-size src for the lightbox
            open: false,
            index: 0,        // which image the PAGE preview is showing
            lightboxIndex: 0, // which image the LIGHTBOX is showing
            images: [],
            _touchX: null,
            _touchY: null,
            _swiped: false,

            /* The thumbnails are the only list of images, so read it back off
               them rather than serialising $GALLERY into the x-data attribute.
               A single-image product renders no thumbnails, so images stays
               empty and the lightbox arrows never appear. */
            init: function () {
                var nodes = this.$el.querySelectorAll('[data-full]');
                for (var i = 0; i < nodes.length; i++) {
                    this.images.push({
                        medium: nodes[i].getAttribute('data-medium'),
                        full: nodes[i].getAttribute('data-full')
                    });
                }
            },

            /** Show a thumbnail's larger version in the main preview. */
            show: function (medium, full, index) {
                var preview = document.getElementById('img-preview');
                if (preview && medium) preview.src = medium;
                if (full) this.full = full;
                if (typeof index === 'number') this.index = index;
            },

            /* Move the LIGHTBOX only, wrapping. It used to carry the page
               preview and the thumbnail highlight with it, so arrowing through
               images animated the page behind the overlay and left the customer
               on a different image than the one they opened. The page keeps its
               own position; lightboxIndex is re-synced on every open. */
            step: function (delta) {
                if (this.images.length < 2) return;
                this.lightboxIndex = (this.lightboxIndex + delta + this.images.length) % this.images.length;
                var image = this.images[this.lightboxIndex];
                if (image && image.full) this.full = image.full;
            },

            /** Move the PAGE preview, wrapping. Dots and swipe both come here. */
            goTo: function (i) {
                if (this.images.length < 2) return;
                var n = (i + this.images.length) % this.images.length;
                var image = this.images[n];
                if (image) this.show(image.medium, image.full, n);
            },

            /* Swipe on the preview. Deliberately not scroll-snap: the preview is
               a single <img> whose src is also swapped by 20-product.js when an
               option carries its own image, and a track of slides would leave
               that writing to whichever slide happened to be first. */
            swipeStart: function (event) {
                // A second finger means a pinch-zoom, not a swipe.
                if (event.touches && event.touches.length > 1) {
                    this._touchX = null;
                    return;
                }
                var t = event.changedTouches[0];
                this._touchX = t.clientX;
                this._touchY = t.clientY;
                this._swiped = false;
            },

            /** -1, 1 or 0 for "that was not a swipe". Shared by both surfaces. */
            _swipeDelta: function (event) {
                if (this._touchX === null) return 0;
                var t = event.changedTouches[0];
                var dx = t.clientX - this._touchX;
                var dy = t.clientY - this._touchY;
                this._touchX = null;
                // Ignore a tap, and anything that is really a vertical scroll.
                if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return 0;
                return dx < 0 ? 1 : -1;
            },

            /** Swipe on the page preview. */
            swipeEnd: function (event) {
                var delta = this._swipeDelta(event);
                if (!delta) return;
                // Only the page preview sets this: a swipe there ends in a click
                // on the same element, which would otherwise open the lightbox.
                this._swiped = true;
                this.goTo(this.index + delta);
            },

            /** Swipe inside the lightbox — the same gesture as its arrows. */
            swipeLightbox: function (event) {
                var delta = this._swipeDelta(event);
                if (delta) this.step(delta);
            },

            /** Open the lightbox on whatever is currently previewed. */
            enlarge: function () {
                /* A swipe ends in a click on the same element. Without this the
                   lightbox opens every time the customer flicks through. */
                if (this._swiped) {
                    this._swiped = false;
                    return;
                }
                var preview = document.getElementById('img-preview');
                if (!this.full && preview) this.full = preview.src;
                this.lightboxIndex = this.index;
                this.open = true;
            },

            close: function () {
                this.open = false;
            }
        };
    });
});
;

/* ---- js/src/22-stars.js ---- */
/**
 * Atrium — star rating chooser for the review form.
 *
 * HOUSE RULE: no ES6 template literals in this folder. See 00-boot.js.
 *
 * The five radios in element.product_reviews.php remain the actual control —
 * this only paints them. They are hidden with .cc-sr-only, which keeps them in
 * the tab order, so the native radio group still provides:
 *   - arrow-key selection within the group
 *   - a single tab stop
 *   - the value core reads from $_POST['rating']
 * Nothing here handles keys; doing so would fight the browser.
 *
 * `hover` is a transient preview and `value` is the committed choice. Fill is
 * `i <= (hover || value)`, so leaving the row falls back to what is actually
 * selected rather than emptying the stars.
 */
document.addEventListener('alpine:init', function () {
    window.Alpine.data('ccStarRating', function () {
        return {
            value: 0,
            hover: 0,

            init: function () {
                // Core pre-checks a radio when the form is redisplayed after a
                // failed post ($RATING_STARS[].checked), so read the truth from
                // the DOM instead of threading it through the template.
                var checked = this.$el.querySelector('input[name="rating"]:checked');
                if (checked) this.value = parseInt(checked.value, 10) || 0;

                // Keep in step if anything else moves the selection — arrow
                // keys fire change on the radio, and the validator may reset it.
                var self = this;
                this.$el.addEventListener('change', function (e) {
                    if (e.target && e.target.name === 'rating') {
                        self.value = parseInt(e.target.value, 10) || 0;
                    }
                });
            }
        };
    });
});
;

/* ---- js/src/23-hero.js ---- */
/**
 * Atrium — controls for the homepage hero banners.
 *
 * HOUSE RULE: no ES6 template literals in this folder. See 00-boot.js.
 *
 * The .cc-hero markup arrives inside the merchant's homepage DOCUMENT (seeded
 * by the installer from the default_doc_content_welcome language string), so
 * the skin cannot template controls into it. This component attaches to a
 * wrapper in content.homepage.php, finds the .cc-hero scroller inside the
 * injected HTML, and drives it.
 *
 * The scroller is CSS scroll-snap and works on its own — swipe on touch,
 * shift+wheel on desktop. What it lacks is any SIGNAL that more banners exist,
 * because the scrollbar is hidden: on a 1400px desktop that left 3003px of
 * banners in a 993px window with nothing to click. These controls are that
 * signal, not the scrolling mechanism.
 *
 * DELIBERATELY NOT AUTO-ROTATING. Auto-advancing heroes engage poorly (clicks
 * concentrate on the first slide), and anything that moves for more than five
 * seconds needs a pause control to satisfy WCAG 2.2.2 plus a
 * prefers-reduced-motion path. Manual controls avoid all of it.
 */
document.addEventListener('alpine:init', function () {
    window.Alpine.data('ccHero', function () {
        return {
            count: 0,
            index: 0,
            _el: null,

            init: function () {
                this._el = this.$el.querySelector('.cc-hero');
                if (!this._el) return;
                this.count = this._el.children.length;
                if (this.count < 2) return;

                var self = this;
                var ticking = false;
                this._el.addEventListener('scroll', function () {
                    if (ticking) return;
                    ticking = true;
                    window.requestAnimationFrame(function () {
                        var w = self._el.clientWidth || 1;
                        self.index = Math.round(self._el.scrollLeft / w);
                        ticking = false;
                    });
                }, { passive: true });
            },

            go: function (i) {
                if (!this._el) return;
                var n = Math.max(0, Math.min(this.count - 1, i));
                this._el.scrollTo({ left: n * this._el.clientWidth, behavior: 'smooth' });
                this.index = n;
            },
            next: function () { this.go(this.index + 1); },
            prev: function () { this.go(this.index - 1); }
        };
    });
});
;

/* ---- js/src/23-quickview.js ---- */
/**
 * Atrium — quick view.
 *
 * HOUSE RULE: no ES6 template literals in this folder. See 00-boot.js.
 *
 * ENDPOINT: index.php?_g=quickview&product_id=N returns the rendered
 * templates/content.quickview.php fragment (Cubecart::loadPage()). An empty
 * response means the store's skin has no such template, so we fall back to
 * simply opening the product page rather than showing an empty modal.
 *
 * ⚠ The fragment carries the product page's ids. Exactly one may exist at a
 * time, so close() clears the markup rather than hiding the modal, and the
 * cache holds markup strings, never live nodes.
 *
 * ⚠ The fragment is written with innerHTML on a plain container, NOT bound with
 * x-html. Alpine re-runs an x-html effect whenever its reactive dependency is
 * touched and reassigns innerHTML wholesale, which rebuilt the fragment mid-use
 * and silently reset every <select> to its server-rendered default. The
 * customer picked an in-stock option combination and the stock check kept
 * judging the original one. Alpine's MutationObserver initialises inserted
 * nodes either way, which is how the mini-basket swap in 12-basket.js works.
 */
document.addEventListener('alpine:init', function () {
    window.Alpine.store('quickView', {
        open: false,
        busy: false,
        title: '',
        _cache: {},

        /** Write the fragment into the modal body. Not reactive, by design. */
        _render: function (markup) {
            var host = document.getElementById('cc-quickview-body');
            if (host) host.innerHTML = markup;
        },

        show: async function (id, name, url) {
            this.title = name || '';
            this.open = true;
            this.busy = true;
            this._render('');

            if (this._cache[id]) {
                this._render(this._cache[id]);
                this.busy = false;
                return;
            }

            try {
                var base = window.CC_ROOT_PATH || '/';
                var res = await window.fetch(
                    base + 'index.php?_g=quickview&product_id=' + encodeURIComponent(id),
                    { credentials: 'same-origin' }
                );
                var text = await res.text();
                if (!text || !text.replace(/\s/g, '')) {
                    // Nothing to show: send them to the real page instead.
                    if (url) window.location = url;
                    this.open = false;
                    return;
                }
                this._cache[id] = text;
                this._render(text);
            } catch (e) {
                if (url) window.location = url;
                this.open = false;
            }

            this.busy = false;
        },

        close: function () {
            this.open = false;
            // Destroy the fragment: see the id warning above.
            this._render('');
        }
    });
});
;

/* ---- js/src/30-category.js ---- */
/**
 * Atrium — category listing: grid/list view toggle.
 *
 * HOUSE RULE: no ES6 template literals in this folder. See 00-boot.js.
 *
 * Foundation rendered EVERY product twice — a .product_list_view block and a
 * .product_grid_view block — and toggled which was hidden, disabling the
 * quantity input in whichever was inactive so the form did not submit two
 * values for the same name. Atrium renders each product ONCE and changes the
 * container's layout classes, so there is no duplicate markup and no disabled-
 * input bookkeeping.
 *
 * The choice persists in localStorage via @alpinejs/persist. Foundation used a
 * two-year `product_view` cookie; localStorage keeps it off every HTTP request.
 *
 * The argument is the merchant's "Default Product View" skin setting, passed in
 * by content.category.php. $persist uses it only when nothing is stored yet, so
 * a customer who has picked a view keeps it and changing the setting later moves
 * only first-time visitors.
 */

document.addEventListener('alpine:init', function () {
    window.Alpine.data('ccProductList', function (defaultView) {
        return {
            // Anything other than 'list' means grid, so a bad value cannot
            // leave the listing with no layout at all.
            view: window.Alpine.$persist(defaultView === 'list' ? 'list' : 'grid').as('cc_product_view'),

            isGrid: function () {
                return this.view === 'grid';
            },

            setView: function (v) {
                this.view = v;
            }
        };
    });
});

/**
 * Simple client-side filter for a long checkbox list (manufacturers).
 * Filtering only hides rows — it never unchecks them — so a selection made
 * before typing still posts.
 */
document.addEventListener('alpine:init', function () {
    window.Alpine.data('ccFilterList', function () {
        return {
            q: '',
            match: function (label) {
                if (!this.q) return true;
                return String(label).toLowerCase().indexOf(this.q.toLowerCase()) !== -1;
            }
        };
    });
});
;

/* ---- js/src/40-checkout.js ---- */
/**
 * Atrium — checkout behaviour.
 *
 * HOUSE RULE: no ES6 template literals in this folder. See 00-boot.js.
 *
 * Replaces the checkout half of foundation's 2.cubecart.js. Every DOM id and
 * field name below is a CORE CONTRACT read by PHP — see the comments in
 * content.checkout.php and content.checkout.confirm.php.
 *
 * COUNTRY -> STATE DEPENDENCY
 *   window.county_list is emitted by the template from $STATE_JSON: an object
 *   keyed by country numcode whose values are arrays of {id, name}.
 *   Each country <select> carries rel="<id of the state field>", and the
 *   selected <option> carries data-status:
 *       1 = state REQUIRED   2 = state optional   3 = state HIDDEN
 *   The wrapper to show/hide is "<target id>_wrapper".
 *
 *   Foundation replaced the state <input> with a <select> (and back) by
 *   destroying and rebuilding the element. That loses any value the customer
 *   already typed and any listener bound to it. Atrium keeps BOTH elements in
 *   the DOM and toggles which one is enabled, so the posted field name is
 *   always right and nothing is rebuilt.
 */

document.addEventListener('alpine:init', function () {
    window.Alpine.data('ccCheckout', function () {
        return {
            deliveryIsBilling: true,
            showRegister: false,
            mode: 'register',        // 'register' | 'login' — guest checkout only
            estimateOpen: false,

            init: function () {
                var dib = document.getElementById('delivery_is_billing');
                if (dib) {
                    this.deliveryIsBilling = dib.type === 'hidden' ? true : dib.checked;
                }
                this.syncDeliveryRequired();
                /* No checkbox means the merchant fixed the mode in the skin
                   settings: `required` renders the password block with no
                   toggle, `guest` renders neither. The block's presence is
                   therefore the answer in both cases. */
                var reg = document.getElementById('show-reg');
                this.showRegister = reg ? reg.checked : !!document.getElementById('account-reg');
                // Sync here too, not only on change: the server re-renders the
                // box already ticked ($REGISTER_CHECKED), and a change event
                // never fires on that path — so the password fields stayed
                // un-required and an empty password reached the server.
                this.syncRegisterRequired();

                // If the server came back with validation errors, the customer
                // was mid-edit — open the address form rather than hiding it.
                if (document.querySelector('.cc-alert-error')) {
                    this.mode = 'register';
                }

                // Deep links used by the login/register toggle.
                if (window.location.hash === '#login') this.mode = 'login';
                if (window.location.hash === '#register') this.mode = 'register';

                this.syncAuthFields();
                this.$nextTick(this.initCountries.bind(this));
            },

            /* ---- guest login / register ------------------------------------
               The login and register field sets live in ONE form, so both would
               post together. Foundation disabled the inactive set so the server
               only ever sees one. Same approach here — disabled fields are not
               submitted and are skipped by validation. */
            setMode: function (m) {
                this.mode = m;
                this.syncAuthFields();
            },

            syncAuthFields: function () {
                var login = this.mode === 'login';
                ['login-username', 'login-password', 'checkout_login_btn'].forEach(function (id) {
                    var el = document.getElementById(id);
                    if (el) el.disabled = !login;
                });
                var pw = document.getElementById('reg_password');
                var pc = document.getElementById('reg_passconf');
                if (pw) pw.disabled = login;
                if (pc) pc.disabled = login;
            },

            /** "Make Changes": swap the address summary for the editable form. */
            makeChanges: function () {
                this.setMode('register');
                var summary = document.getElementById('register_false_address');
                if (summary) summary.classList.add('hidden');
                var form = document.getElementById('checkout_register_form');
                if (form) form.classList.remove('hidden');
            },

            /* ---- delivery address ------------------------------------------ */
            toggleDelivery: function (event) {
                this.deliveryIsBilling = event.target.checked;
                this.syncDeliveryRequired();
            },

            /* required must track visibility. #address_delivery is hidden while
               delivery mirrors billing, but its fields ship with `required`, so
               validation failed on controls the customer could not see: the
               Checkout button did nothing and the messages sat inside the hidden
               block. Same trap as the register password fields. */
            syncDeliveryRequired: function () {
                var required = !this.deliveryIsBilling;
                ['del_first', 'del_last', 'del_line1', 'del_town', 'del_postcode'].forEach(function (id) {
                    var el = document.getElementById(id);
                    if (el) el.required = required;
                });
                /* The delivery state's requirement belongs to the chosen
                   country's zone status, so only ever CLEAR it here and let
                   ccApplyCountryState set it when the block is shown again. */
                if (!required) {
                    ['delivery_state', 'delivery_state_select'].forEach(function (id) {
                        var el = document.getElementById(id);
                        if (el) el.required = false;
                    });
                }
            },

            /* ---- create-an-account toggle ---------------------------------- */
            toggleRegister: function (event) {
                this.showRegister = event.target.checked;
                this.syncRegisterRequired();
            },

            /* required must track visibility, or the browser blocks submit on a
               field the customer cannot see. Called from init() as well. */
            syncRegisterRequired: function () {
                var pw = document.getElementById('reg_password');
                var pc = document.getElementById('reg_passconf');
                if (pw) pw.required = this.showRegister;
                if (pc) pc.required = this.showRegister;
            },

            /* ---- proceed ---------------------------------------------------
               Core distinguishes "update the basket" from "go to the next step"
               by the presence of a `proceed` field. The button is name="proceed"
               so a plain submit already carries it; this only adds it when the
               submit came from somewhere else. */
            proceed: function (event) {
                var form = document.getElementById('checkout_form');
                if (!form) return;

                // ⚠ Look for a HIDDEN input specifically. The earlier version
                // tested [name="proceed"], which ALWAYS matched — the submit
                // button itself is name="proceed" — so the compensator never
                // ran. Under invisible captcha (mode 3) grecaptcha submits the
                // form programmatically, and a programmatic submit does not
                // contribute the clicked button's name/value, so `proceed`
                // never posted and checkout silently never advanced.
                if (!form.querySelector('input[type="hidden"][name="proceed"]')) {
                    var i = document.createElement('input');
                    i.type = 'hidden';
                    i.name = 'proceed';
                    i.value = '1';
                    i.dataset.ccProceed = '1';
                    form.appendChild(i);
                }
            },

            /** Remove the compensator again — "Update basket" must NOT carry
             *  `proceed`, or updating a quantity would jump the customer to the
             *  next checkout step. */
            clearProceed: function () {
                var form = document.getElementById('checkout_form');
                if (!form) return;
                var i = form.querySelector('input[data-cc-proceed]');
                if (i) i.remove();
            },

            /* ---- country -> state ------------------------------------------
               Delegated to the page-level initialiser at the bottom of this
               file so the address book gets it too — that page has no
               ccCheckout component. */
            initCountries: function () {
                window.ccInitCountryState();
                // Runs after the zone status has been applied, so a hidden
                // delivery state cannot come back required.
                this.syncDeliveryRequired();
            },

            _unusedApplyState: function (sel) {
                if (typeof window.county_list !== 'object' || !window.county_list) return;

                var targetId = (sel.getAttribute('rel') && sel.id !== 'country-list')
                    ? sel.getAttribute('rel')
                    : 'state-list';

                var input   = document.getElementById(targetId);
                var select  = document.getElementById(targetId + '_select');
                var wrapper = document.getElementById(targetId + '_wrapper');
                if (!input) return;

                var opt = sel.options[sel.selectedIndex];
                var status = opt ? opt.getAttribute('data-status') : '2';
                var list = window.county_list[sel.value];
                var hasList = Array.isArray(list) && list.length > 0;

                // Show / hide / require, per the country's zone status.
                var hidden = status === '3';
                if (wrapper) wrapper.style.display = hidden ? 'none' : '';

                if (hasList) {
                    // Populate the paired <select> and use it instead of the text input.
                    if (select) {
                        var current = (input.value || select.value || '').toLowerCase();
                        select.innerHTML = '';
                        var blank = document.createElement('option');
                        blank.value = '';
                        blank.textContent = sel.getAttribute('title') || '';
                        select.appendChild(blank);
                        list.forEach(function (row) {
                            var o = document.createElement('option');
                            o.value = row.id > 0 ? row.id : '';
                            o.textContent = row.name;
                            if (current && (String(row.name).toLowerCase() === current || String(row.id) === current)) {
                                o.selected = true;
                            }
                            select.appendChild(o);
                        });
                        // Only ONE of the pair may be enabled: they share a name,
                        // and two enabled fields would post two values.
                        select.disabled = hidden;
                        select.required = !hidden && status === '1';
                        select.hidden = false;
                        input.disabled = true;
                        input.hidden = true;
                    }
                } else {
                    if (select) {
                        select.disabled = true;
                        select.hidden = true;
                        select.required = false;
                    }
                    input.disabled = hidden;
                    input.hidden = false;
                    input.required = !hidden && status === '1';
                }
            },

            /* ---- shipping estimate panel ----------------------------------- */
            toggleEstimate: function () {
                this.estimateOpen = !this.estimateOpen;
            }
        };
    });

    /** Basket line quantity stepper. Reveals the update button once a value
     *  actually differs from what the server currently holds. */
    window.Alpine.data('ccBasketLine', function (initial) {
        return {
            qty: parseInt(initial, 10) || 0,
            original: parseInt(initial, 10) || 0,

            get changed() {
                return this.qty !== this.original;
            },

            step: function (delta) {
                var next = this.qty + delta;
                if (next < 0 || next > 999) return;
                this.qty = next;
            }
        };
    });
});

/**
 * Gift certificate form: the recipient email field only applies to email
 * delivery. Kept out of the main ccCheckout component because this page has no
 * basket, no addresses and no gateways — nothing else in ccCheckout applies.
 */
document.addEventListener('alpine:init', function () {
    window.Alpine.data('ccGiftCertificate', function (initial) {
        return { method: initial || 'e' };
    });
});


/* ---------------------------------------------------------------------------
 * Country -> state, as a PAGE-LEVEL behaviour rather than a component method.
 *
 * Three pages need it — checkout, the shipping estimator and the address book —
 * and only checkout has a ccCheckout component. Binding it to the DOM instead
 * of to a component means a page just has to render the right markup:
 *
 *   <select class="country-list" rel="<state field id>">   options carry data-status
 *   <input  id="<state field id>"        name="x[state]">
 *   <select id="<state field id>_select" name="x[state]" hidden disabled>
 *   wrapper id="<state field id>_wrapper"
 *
 * data-status on the selected option: 1 = required, 2 = optional, 3 = hidden.
 * window.county_list maps country numcode -> [{id, name}].
 *
 * Input and select share a name and exactly ONE is ever enabled — a disabled
 * control is not submitted, so the posted value is unambiguous. Foundation
 * destroyed and rebuilt the element instead, losing anything already typed.
 * ------------------------------------------------------------------------- */
window.ccApplyCountryState = function (sel) {
    if (typeof window.county_list !== 'object' || !window.county_list) return;

    var targetId = (sel.getAttribute('rel') && sel.id !== 'country-list')
        ? sel.getAttribute('rel')
        : (sel.getAttribute('rel') || 'state-list');

    var input   = document.getElementById(targetId);
    var select  = document.getElementById(targetId + '_select');
    var wrapper = document.getElementById(targetId + '_wrapper');
    if (!input) return;

    var opt     = sel.options[sel.selectedIndex];
    var status  = opt ? opt.getAttribute('data-status') : '2';
    var list    = window.county_list[sel.value];
    var hasList = Array.isArray(list) && list.length > 0;
    var hidden  = status === '3';

    if (wrapper) wrapper.style.display = hidden ? 'none' : '';

    /* The state field is required for some countries and not others, so its
       "(Optional)" marker cannot be baked into the template. */
    var mark = document.querySelector('label[for="' + targetId + '"] [data-cc-optional]');
    if (mark) mark.hidden = (status === '1');

    if (hasList && select) {
        var current = (input.value || select.value || '').toLowerCase();
        select.innerHTML = '';
        var blank = document.createElement('option');
        blank.value = '';
        blank.textContent = sel.getAttribute('title') || '';
        select.appendChild(blank);
        list.forEach(function (row) {
            var o = document.createElement('option');
            o.value = row.id > 0 ? row.id : '';
            o.textContent = row.name;
            if (current && (String(row.name).toLowerCase() === current || String(row.id) === current)) {
                o.selected = true;
            }
            select.appendChild(o);
        });
        select.disabled = hidden;
        select.required = !hidden && status === '1';
        select.hidden   = false;
        input.disabled  = true;
        input.hidden    = true;
    } else {
        if (select) {
            select.disabled = true;
            select.hidden   = true;
            select.required = false;
        }
        input.disabled = hidden;
        input.hidden   = false;
        input.required = !hidden && status === '1';
    }
};

/* ---- Address lookup fallback ----------------------------------------------
 * With a postcode-lookup plugin active ($ADDRESS_LOOKUP) both address templates
 * render #address_form with class="hidden" — and town and postcode inside it
 * are `required`. Foundation revealed the block again from show_address_form()
 * (2.cubecart.js:313-314); Atrium shipped no equivalent, so a failed lookup left
 * required fields the customer could neither see nor fill, and Save/Checkout
 * silently refused to submit with its error messages rendered inside the hidden
 * block. Dormant while no lookup plugin is installed: the block renders visible.
 * ------------------------------------------------------------------------- */
window.ccRevealAddressForm = function () {
    var el = document.getElementById('address_form');
    if (el) el.classList.remove('hidden');
};

/* `invalid` does not bubble, hence capture. checkValidity() in 50-validate.js
   fires it at the field, so the block opens before the validator tries to focus
   and scroll to a field that is still display:none. */
document.addEventListener('invalid', function (e) {
    var block = document.getElementById('address_form');
    if (block && block.contains(e.target)) window.ccRevealAddressForm();
}, true);

window.ccInitCountryState = function () {
    document.querySelectorAll('select.country-list, select#country-list').forEach(function (sel) {
        if (sel.dataset.ccBound) return;      // idempotent: safe to call twice
        sel.dataset.ccBound = '1';
        window.ccApplyCountryState(sel);
        sel.addEventListener('change', function () { window.ccApplyCountryState(sel); });
    });
};

document.addEventListener('DOMContentLoaded', function () {
    window.ccInitCountryState();

    var block = document.getElementById('address_form');
    if (!block || !block.classList.contains('hidden')) return;

    // "Address not found" — the customer's way out of a lookup that missed.
    var fail = document.getElementById('lookup_fail');
    if (fail) {
        fail.addEventListener('click', function (e) {
            e.preventDefault();
            window.ccRevealAddressForm();
        });
    }

    // The server already rejected something, so the customer is mid-correction
    // and needs the manual fields regardless of what the lookup did.
    if (document.querySelector('.cc-alert-error')) window.ccRevealAddressForm();
});
;

/* ---- js/src/41-coupon.js ---- */
/**
 * Atrium — discount code celebration. No template literals (00-boot.js).
 *
 * Applying a coupon redirects, and core sets a notice only on FAILURE, so there
 * is no success signal to read after the reload. Instead: stash the typed code
 * on submit, and fire only if it now appears as applied. Read once and cleared,
 * so a refresh or back-button cannot replay it.
 *
 * Opt-out: templates emit data-cc-coupon only when the setting is on.
 */
(function () {
    'use strict';

    var KEY = 'cc_coupon_pending';

    function readFlag() {
        try {
            var v = window.sessionStorage.getItem(KEY);
            window.sessionStorage.removeItem(KEY);
            return v;
        } catch (e) {
            return null;   // blocked storage throws on read too
        }
    }

    function writeFlag(value) {
        try {
            window.sessionStorage.setItem(KEY, value);
        } catch (e) { /* as above */ }
    }

    function normalise(code) {
        return String(code || '').replace(/\s+/g, '').toLowerCase();
    }

    // The Apply button, not form submit: shipping and Proceed post this form too.
    function arm() {
        var button = document.getElementById('apply_coupon');
        var input = document.getElementById('coupon');
        if (!button || !input) return;
        button.addEventListener('click', function () {
            var code = normalise(input.value);
            if (code) writeFlag(code);
        });
    }

    // From the live tokens, so it matches the store's sub-theme.
    function palette() {
        var style = window.getComputedStyle(document.documentElement);
        var names = ['--color-brand-400', '--color-brand-600', '--color-success-600', '--color-star', '--color-brand-300'];
        var out = [];
        for (var i = 0; i < names.length; i++) {
            var value = style.getPropertyValue(names[i]).trim();
            if (value) out.push(value);
        }
        return out.length ? out : ['#2563eb', '#16a34a', '#eab308'];
    }

    function confetti(origin) {
        var canvas = document.createElement('canvas');
        canvas.className = 'cc-confetti';
        canvas.setAttribute('aria-hidden', 'true');
        document.body.appendChild(canvas);

        var dpr = window.devicePixelRatio || 1;
        var width = window.innerWidth;
        var height = window.innerHeight;
        canvas.width = width * dpr;
        canvas.height = height * dpr;
        var ctx = canvas.getContext('2d');
        ctx.scale(dpr, dpr);

        var colours = palette();
        var pieces = [];
        var count = 80;
        for (var i = 0; i < count; i++) {
            // A fan out of the discount line, not a full-screen drop.
            var angle = (-Math.PI / 2) + (Math.random() - 0.5) * 1.7;
            var speed = 5 + Math.random() * 7;
            pieces.push({
                x: origin.x,
                y: origin.y,
                vx: Math.cos(angle) * speed,
                vy: Math.sin(angle) * speed,
                size: 4 + Math.random() * 5,
                colour: colours[(Math.random() * colours.length) | 0],
                spin: (Math.random() - 0.5) * 0.35,
                angle: Math.random() * Math.PI
            });
        }

        var started = null;
        var LIFE = 1500;

        function frame(now) {
            if (started === null) started = now;
            var elapsed = now - started;
            if (elapsed > LIFE) {
                canvas.remove();
                return;
            }
            ctx.clearRect(0, 0, width, height);
            var fade = 1 - (elapsed / LIFE);
            for (var i = 0; i < pieces.length; i++) {
                var p = pieces[i];
                p.vy += 0.28;          // gravity
                p.vx *= 0.995;         // drag, so the fan narrows as it falls
                p.x += p.vx;
                p.y += p.vy;
                p.angle += p.spin;
                ctx.save();
                ctx.globalAlpha = fade;
                ctx.translate(p.x, p.y);
                ctx.rotate(p.angle);
                ctx.fillStyle = p.colour;
                ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 0.6);
                ctx.restore();
            }
            window.requestAnimationFrame(frame);
        }
        window.requestAnimationFrame(frame);
    }

    function celebrate() {
        var code = readFlag();
        if (!code) return;

        var rows = document.querySelectorAll('[data-cc-coupon]');
        var row = null;
        for (var i = 0; i < rows.length; i++) {
            if (normalise(rows[i].getAttribute('data-cc-coupon')) === code) {
                row = rows[i];
                break;
            }
        }
        if (!row) return;   // rejected, or the setting is off

        row.classList.add('cc-coupon-won');
        // Lifted from the rendered row, so it stays translated.
        if (window.ccAnnounce) window.ccAnnounce(row.textContent);

        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        // Off-screen keeps the flash and skips the burst nobody would see.
        var box = row.getBoundingClientRect();
        var middle = box.top + box.height / 2;
        if (middle < 0 || middle > (window.innerHeight || document.documentElement.clientHeight)) return;

        confetti({ x: box.left + box.width / 2, y: middle });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { arm(); celebrate(); });
    } else {
        arm();
        celebrate();
    }
}());
;

/* ---- js/src/42-recent.js ---- */
/**
 * Atrium — recently viewed products. No template literals (00-boot.js).
 *
 * localStorage only, never sent to the server: no core change, no table, no
 * session, nothing to disclose.
 *
 * ⚠ Read back as UNTRUSTED — anything on the origin can write that key. URLs are
 * scheme-checked and nodes are built with textContent, never innerHTML.
 */
(function () {
    'use strict';

    var KEY = 'cc_recent';
    var removeLabel = 'Remove';   // replaced from the template's data attribute
    var MAX_STORED = 12;
    // One row at the widest breakpoint; CSS (.cc-recent-row) trims the rest.
    var MAX_SHOWN = 4;

    function read() {
        try {
            var raw = window.localStorage.getItem(KEY);
            var list = raw ? JSON.parse(raw) : [];
            return Object.prototype.toString.call(list) === '[object Array]' ? list : [];
        } catch (e) {
            return [];   // blocked storage, or junk in the key
        }
    }

    function write(list) {
        try {
            window.localStorage.setItem(KEY, JSON.stringify(list));
        } catch (e) { /* private mode, or quota */ }
    }

    /** Drop one product from the stored list. */
    function forget(id) {
        var list = read();
        for (var i = list.length - 1; i >= 0; i--) {
            if (String(list[i].id) === String(id)) list.splice(i, 1);
        }
        write(list);
    }

    // http(s) and root-relative only: blocks a smuggled javascript: URL.
    function safeUrl(value) {
        var url = String(value || '');
        return (/^https?:\/\//i.test(url) || url.charAt(0) === '/') ? url : '';
    }

    function record() {
        var node = document.getElementById('cc-recent-record');
        if (!node) return null;

        var item;
        try {
            item = JSON.parse(node.textContent);
        } catch (e) {
            return null;
        }
        if (!item || !item.id) return null;

        var list = read();
        // Seen before: lift to the front rather than store it twice.
        for (var i = list.length - 1; i >= 0; i--) {
            if (String(list[i].id) === String(item.id)) list.splice(i, 1);
        }
        list.unshift(item);
        if (list.length > MAX_STORED) list.length = MAX_STORED;
        write(list);
        return String(item.id);
    }

    /* Always visible rather than hover-revealed: on a touch device there is no
       hover, and a control the customer cannot find is not a control. */
    function removeButton(item, li) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'absolute end-1.5 top-1.5 z-10 grid size-7 place-items-center rounded-full ' +
                           'bg-ink-50/90 text-ink-600 shadow hover:bg-ink-200 hover:text-ink-900';
        var label = (removeLabel + ' ' + (item.name || '')).trim();
        button.title = label;
        button.setAttribute('aria-label', label);
        button.innerHTML = '<svg class="size-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
                           'stroke-width="2" aria-hidden="true"><path d="M6 18 18 6M6 6l12 12" ' +
                           'stroke-linecap="round"/></svg>';
        button.addEventListener('click', function () {
            forget(item.id);
            li.remove();
            /* nth-child does the trimming, so removing a node promotes a hidden
               one into the row on its own.

               Hidden only at ZERO, not at one. The "a row of one is not
               recently viewed" rule below applies to the FIRST render; once a
               customer has removed something deliberately, the one they kept is
               the one they want to see, and taking the section away with it
               looks like the X cleared everything. */
            var list = document.getElementById('cc-recent-list');
            var section = document.getElementById('cc-recent');
            if (list && section && !list.children.length) section.classList.add('hidden');
        });
        return button;
    }

    function card(item) {
        var li = document.createElement('li');
        li.className = 'group flex flex-col';

        // The button is a SIBLING of the link, never inside it: a <button> in an
        // <a> is invalid and browsers reparent it.
        var frame = document.createElement('div');
        frame.className = 'relative';

        var link = document.createElement('a');
        link.href = safeUrl(item.url);
        link.title = String(item.name || '');
        link.className = 'cc-media block overflow-hidden rounded-cc-lg border border-ink-200';

        var img = document.createElement('img');
        img.src = safeUrl(item.img);
        img.alt = String(item.name || '');
        img.loading = 'lazy';
        img.className = 'aspect-square w-full object-cover transition-transform duration-300 group-hover:scale-105';
        link.appendChild(img);
        frame.appendChild(link);
        frame.appendChild(removeButton(item, li));
        li.appendChild(frame);

        var heading = document.createElement('h3');
        heading.className = 'mt-3 text-sm font-medium';
        var nameLink = document.createElement('a');
        nameLink.href = link.href;
        nameLink.textContent = String(item.name || '');
        nameLink.className = 'text-ink-900 hover:underline';
        heading.appendChild(nameLink);
        li.appendChild(heading);

        if (item.price) {
            var price = document.createElement('div');
            price.className = 'price mt-2 text-base font-semibold text-ink-900';
            price.textContent = String(item.price);
            li.appendChild(price);
        }
        return li;
    }

    function render(currentId) {
        var section = document.getElementById('cc-recent');
        var list = document.getElementById('cc-recent-list');
        if (!section || !list) return;

        removeLabel = section.getAttribute('data-remove-label') || removeLabel;

        var items = read();
        var shown = 0;
        for (var i = 0; i < items.length && shown < MAX_SHOWN; i++) {
            var item = items[i];
            // Never the page you are already on.
            if (currentId && String(item.id) === currentId) continue;
            if (!item.url || !safeUrl(item.url)) continue;
            list.appendChild(card(item));
            shown++;
        }
        // A row of one is not "recently viewed".
        if (shown > 1) section.classList.remove('hidden');
    }

    function init() {
        render(record());
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
}());
;

/* ---- js/src/50-validate.js ---- */
/**
 * Atrium — client-side form validation.
 *
 * HOUSE RULE: no ES6 template literals in this folder. See 00-boot.js.
 *
 * WHAT THIS IS FOR
 * A UX layer only. Every rule here is also enforced server-side, and this file
 * never decides whether data is acceptable — it only tells the customer sooner.
 * Nothing here may be relied on for correctness or security.
 *
 * WHY NOT jQuery VALIDATE (what Foundation uses)
 * Foundation loads jquery.validate.js plus a 409-line rules file. Atrium ships
 * jQuery only as a compatibility shim for third-party plugins (see README) —
 * no skin code uses it, and adding a ~50KB jQuery plugin for this would undo
 * that. The markup already carries the constraint attributes (121 `required`,
 * 14 type=email, 7 type=tel, 31 maxlength), so the browser can do most of the
 * work and this file only supplies what the platform cannot:
 *
 *   - cross-field equality      passconf === password, emailconf === email
 *   - remote uniqueness         "that email already has an account"
 *   - message text              translated, from the store's language pack
 *   - presentation              inline messages instead of browser bubbles,
 *                               which are unstyleable and untranslatable
 *
 * NOVALIDATE IS SET FROM JS, DELIBERATELY
 * The form keeps native validation in the markup; init() adds `novalidate`
 * only once this script is running. With JS off or broken the browser still
 * blocks an empty required field, instead of the form silently losing its
 * only client-side check.
 *
 * MESSAGES
 * Read once from the JSON blob emitted by element.validation_messages.php.
 * Per-field override with data-msg-<rule>, e.g. data-msg-required="...".
 * Falls back to the browser's own localised validationMessage.
 *
 * WHY THIS IS NOT AN Alpine.data() COMPONENT
 * Alpine permits ONE x-data per element, and two forms already have their own
 * (box.newsletter.php uses ccNewsletter, content.certificates.php uses
 * ccGiftCertificate). A component here would collide with those and could not
 * be added to a plugin's form at all. Instead every form carrying
 * data-cc-validate is wired on load, and the instance is parked on the element
 * as form._ccValidator. That also means validation keeps working if Alpine
 * itself fails to load.
 *
 * ENDPOINT CONTRACT (core, not skin) — Cubecart::loadPage() 'ajax_email' case:
 *   POST ?_g=ajax_email            body: email=<addr>      (account lookup)
 *   POST ?_g=ajax_email&source=newsletter  body: subscribe=<addr>
 *   -> {"result":true|false,"token":"..."} when config.csrf=1, else bare true/false
 *   result TRUE  = address is FREE (no account / not subscribed)
 *   result FALSE = already taken
 * The token in the response is the SAME session token, not a rotated one
 * (Session::getToken() only regenerates when absent), so there is nothing to
 * write back into the form.
 */

(function () {
    'use strict';

    /* Message catalogue, parsed once. */
    var MESSAGES = (function () {
        var el = document.getElementById('cc-validation-messages');
        if (!el) return {};
        try { return JSON.parse(el.textContent || '{}'); } catch (e) { return {}; }
    })();

    /* Remote answers are cached per address so retyping the same value does
       not re-hit the server on every blur. */
    var remoteCache = {};

    function messageFor(field, rule) {
        var attr = field.getAttribute('data-msg-' + rule);
        if (attr) return attr;
        if (MESSAGES[rule]) return MESSAGES[rule];
        return field.validationMessage || 'Invalid';
    }

    /** Which built-in constraint failed, as a rule name we have a message for. */
    function nativeRule(field) {
        var v = field.validity;
        if (v.valid) return null;
        if (v.valueMissing) return 'required';
        if (v.typeMismatch) return field.type === 'email' ? 'email' : 'invalid';
        if (v.tooShort) return 'minlength';
        if (v.tooLong) return 'maxlength';
        if (v.patternMismatch) return field.type === 'tel' ? 'phone' : 'invalid';
        if (v.rangeUnderflow || v.rangeOverflow || v.stepMismatch) return 'invalid';
        return 'invalid';
    }

    /** Wire one form. Idempotent — a second call on the same form is a no-op. */
    function createValidator(form) {
        if (form._ccValidator) return form._ccValidator;

        var api = {
            $el: form,
            /* fieldName -> message. Only used to drive the DOM; the DOM is the
               source of truth for validity so a plugin that injects a field
               mid-life is picked up without re-initialising anything. */
            errors: {},
            busy: false,

            /* STICKY once validation has passed, and cleared only when the
               customer edits something. It must NOT be consumed by the first
               handler that sees it: the click and submit handlers both fire
               for one interaction, so a consume-on-read flag made the second
               handler re-enter and, on a .g-recaptcha submit button, loop
               forever (click -> submit -> captcha.click() -> click -> ...).
               That locked the renderer on the basket page. */
            _verified: false,

            init: function () {
                var form = this.$el;
                // Only now that JS is confirmed running. See header.
                form.setAttribute('novalidate', 'novalidate');

                var self = this;

                /* ── Submit interception ──────────────────────────────────────
                   MUST be a capture-phase CLICK, not the submit event.

                   Invisible reCAPTCHA (content.recaptcha.head.php, config
                   recaptcha=3) binds its own click handler to each
                   .g-recaptcha button and, once it has a token, submits with
                   form.submit(). form.submit() does NOT dispatch a submit
                   event — so a @submit handler never runs on registration,
                   checkout or the newsletter, i.e. precisely the forms where
                   validation matters most. Capturing the click lets us run
                   first and stopPropagation() before grecaptcha ever sees it.

                   Validation is async (remote email lookup), so we cannot
                   decide inline: cancel the click, validate, then replay it. */
                form.addEventListener('click', function (e) {
                    var btn = e.target.closest('button, input[type="submit"], input[type="image"]');
                    if (!btn || !form.contains(btn)) return;
                    var type = (btn.getAttribute('type') || 'submit').toLowerCase();
                    if (type !== 'submit' && type !== 'image') return;

                    // Secondary actions (update basket, fetch shipping rates,
                    // apply coupon) must not require the whole form to be
                    // valid. formnovalidate is the standard opt-out.
                    if (btn.hasAttribute('formnovalidate')) return;

                    if (self._verified) return;   // already passed; let it run

                    e.preventDefault();
                    e.stopPropagation();          // keep grecaptcha out until we pass
                    self.validateAll().then(function (ok) {
                        if (!ok) return;
                        self._verified = true;
                        btn.click();              // now grecaptcha (or the browser) proceeds
                    });
                }, true);

                /* Enter-key submits dispatch a real submit event and never
                   touch the button, so they bypass the handler above. */
                form.addEventListener('submit', function (e) {
                    /* Secondary actions opt out of validation AND of any
                       rerouting. formnovalidate only tells the BROWSER to skip
                       its own checks — it does not stop this listener, so
                       without this test "Update basket" was swallowed here:
                       validation passed, and the submission was then replayed
                       through the .g-recaptcha checkout button, which posts
                       `proceed` instead of `update`. The basket never updated. */
                    if (e.submitter && e.submitter.hasAttribute('formnovalidate')) return;

                    if (self._verified) return;
                    e.preventDefault();
                    var submitter = e.submitter;
                    self.validateAll().then(function (ok) {
                        if (!ok) return;
                        self._verified = true;
                        /* Replay the ACTUAL button so its name/value posts —
                           HTMLFormElement.submit() contributes neither, which is
                           the same trap the `proceed` compensator exists for. */
                        if (submitter) { submitter.click(); return; }
                        // If the form is reCAPTCHA-protected, go through its
                        // button so a token is still minted; submitting the
                        // form directly would post without one and be rejected.
                        var captcha = form.querySelector('.g-recaptcha');
                        if (captcha) { captcha.click(); return; }
                        HTMLFormElement.prototype.submit.call(form);
                    });
                });

                form.addEventListener('blur', function (e) {
                    if (self._isField(e.target)) self.checkField(e.target);
                }, true);

                // Clear a message as soon as the customer fixes the field, but
                // never introduce one mid-typing — that is hostile on a field
                // being filled in for the first time.
                form.addEventListener('input', function (e) {
                    if (self._isField(e.target) && self._errorEl(e.target)) {
                        self.checkField(e.target);
                    }
                });
                form.addEventListener('change', function (e) {
                    if (self._isField(e.target)) self.checkField(e.target);
                });

                /* Editing after a successful pass must force a re-check,
                   otherwise the sticky flag would wave through a form the
                   customer has since broken. */
                ['input', 'change'].forEach(function (evt) {
                    form.addEventListener(evt, function () { self._verified = false; }, true);
                });
            },

            /** Is the field actually laid out? offsetParent is null under any
             *  display:none ancestor; position:fixed is the one false positive. */
            _isRendered: function (el) {
                if (el.offsetParent !== null) return true;
                return window.getComputedStyle(el).position === 'fixed';
            },

            _isField: function (el) {
                if (!el || !el.name) return false;
                var t = (el.tagName || '').toUpperCase();
                if (t !== 'INPUT' && t !== 'SELECT' && t !== 'TEXTAREA') return false;
                return el.type !== 'hidden' && el.type !== 'submit' && el.type !== 'button';
            },

            /* Every validatable control in the form, in DOM order.

               A radio GROUP is one field, not N. Every radio sharing a name
               reports valueMissing when none is checked, so without this the
               5-star rating group emitted five identical "No star rating was
               specified." messages. Keep only the first of each group. */
            _fields: function () {
                var self = this;
                var seen = {};
                return Array.prototype.filter.call(
                    this.$el.querySelectorAll('input, select, textarea'),
                    function (el) {
                        if (!self._isField(el)) return false;
                        if (el.type === 'radio') {
                            if (seen[el.name]) return false;
                            seen[el.name] = true;
                        }
                        return true;
                    }
                );
            },

            /* Where a message for this field should live.

               For a checkbox/radio the control and its <label> are usually
               flex SIBLINGS (e.g. terms_agree lives in
               <div class="flex items-start gap-2"><input><label></div>), so
               inserting after the input puts the message BETWEEN the box and
               its text, laid out inline by the flex parent. Anchor to the row
               instead so the message sits underneath it.

               Any field can opt out of the guesswork with a [data-field]
               wrapper, which always wins. */
            _anchor: function (field) {
                var explicit = field.closest('[data-field]');
                if (explicit) return explicit;

                if (field.type === 'radio') {
                    // The whole group gets one message, so anchor it after the
                    // group container rather than after any single radio.
                    var group = field.closest('fieldset');
                    if (group) return group;
                }
                if (field.type === 'radio' || field.type === 'checkbox') {
                    var wrapped = field.closest('label');
                    if (wrapped) return wrapped;
                    var row = field.parentElement;
                    if (row) {
                        // Only treat the parent as the row if it actually holds
                        // the label too; otherwise we would skip too far up.
                        var lbl = field.id
                            ? row.querySelector('label[for="' + CSS.escape(field.id) + '"]')
                            : row.querySelector('label');
                        if (lbl) return row;
                    }
                    return row || field;
                }
                return field;
            },

            _errorId: function (field) {
                // Radios key off the group NAME so the whole group shares a
                // single message element instead of one per radio.
                var key = (field.type === 'radio') ? field.name : (field.id || field.name);
                return 'ccerr-' + key.replace(/[^a-zA-Z0-9_-]/g, '_');
            },

            _errorEl: function (field) {
                return this.$el.querySelector('#' + CSS.escape(this._errorId(field)));
            },

            showError: function (field, message) {
                var id = this._errorId(field);
                var el = this._errorEl(field);
                if (!el) {
                    el = document.createElement('p');
                    el.id = id;
                    el.className = 'cc-field-error';
                    // Announced without stealing focus.
                    el.setAttribute('role', 'alert');
                    var anchor = this._anchor(field);
                    anchor.parentNode.insertBefore(el, anchor.nextSibling);
                }
                el.textContent = message;
                this._groupMembers(field).forEach(function (m) {
                    m.setAttribute('aria-invalid', 'true');
                    m.setAttribute('aria-describedby', id);
                });
                this.errors[field.name] = message;
            },

            clearError: function (field) {
                var el = this._errorEl(field);
                if (el && el.parentNode) el.parentNode.removeChild(el);
                var id = this._errorId(field);
                this._groupMembers(field).forEach(function (m) {
                    m.removeAttribute('aria-invalid');
                    if (m.getAttribute('aria-describedby') === id) {
                        m.removeAttribute('aria-describedby');
                    }
                });
                delete this.errors[field.name];
            },

            /** The field itself, or every radio sharing its name. */
            _groupMembers: function (field) {
                if (field.type !== 'radio' || !field.name) return [field];
                return Array.prototype.slice.call(
                    this.$el.querySelectorAll('input[type="radio"][name="' + CSS.escape(field.name) + '"]')
                );
            },

            /**
             * Synchronous rules only. Returns true when the field passes.
             * Remote checks are deliberately excluded so blur feedback is
             * instant; they run in checkRemote() / validateAll().
             */
            checkField: function (field) {
                if (field.disabled || field.type === 'hidden') { this.clearError(field); return true; }

                /* A field the customer cannot see cannot be a field the customer
                   can fix. Checkout hides whole blocks whose inputs keep their
                   `required` — the delivery address while it mirrors billing,
                   the register form while an address is on file, the manual
                   address fields behind a postcode lookup — and validating them
                   blocked submit with the message rendered inside the hidden
                   block, so the button appeared to do nothing.

                   This is what foundation got for free: jQuery-validate ignores
                   ":hidden" by default. The server revalidates regardless. */
                if (!this._isRendered(field)) { this.clearError(field); return true; }

                if (!field.checkValidity()) {
                    var rule = nativeRule(field);
                    this.showError(field, messageFor(field, rule));
                    return false;
                }

                // Cross-field equality: data-match points at another control.
                var matchSel = field.getAttribute('data-match');
                if (matchSel) {
                    var other = this.$el.querySelector(matchSel);
                    if (other && other.value !== field.value) {
                        this.showError(field, messageFor(field, 'match'));
                        return false;
                    }
                }

                this.clearError(field);
                return true;
            },

            /**
             * Remote uniqueness check. data-remote="email" | "newsletter".
             * Only runs on an otherwise-valid, non-empty field.
             */
            checkRemote: async function (field) {
                var kind = field.getAttribute('data-remote');
                if (!kind || !field.value || !field.checkValidity()) return true;

                var key = kind + '|' + field.value.toLowerCase();
                if (Object.prototype.hasOwnProperty.call(remoteCache, key)) {
                    if (remoteCache[key]) { return true; }
                    this.showError(field, messageFor(field, kind === 'newsletter' ? 'subscribed' : 'emailInUse'));
                    return false;
                }

                var body = new FormData();
                var url = (this.$el.getAttribute('action') || window.location.href).replace(/\?.*/, '');
                url += '?_g=ajax_email' + (kind === 'newsletter' ? '&source=newsletter' : '');
                body.append(kind === 'newsletter' ? 'subscribe' : 'email', field.value);
                var token = window.ccToken();
                if (token) body.append('token', token);

                try {
                    var text = await window.ccPost(url, body);
                    var data = JSON.parse(text);
                    // Bare true/false when config.csrf is off; object when on.
                    var free = (data === true) || (data && data.result === true);
                    remoteCache[key] = free;
                    if (free) return true;
                    this.showError(field, messageFor(field, kind === 'newsletter' ? 'subscribed' : 'emailInUse'));
                    return false;
                } catch (e) {
                    // Never block submission on a failed availability check —
                    // the server revalidates and is the authority.
                    return true;
                }
            },

            /** Full pass. Returns true when the form may be submitted. */
            validateAll: async function () {
                var fields = this._fields();
                var ok = true;
                var i;

                for (i = 0; i < fields.length; i++) {
                    if (!this.checkField(fields[i])) ok = false;
                }

                if (ok) {
                    var remotes = fields.filter(function (f) { return f.getAttribute('data-remote'); });
                    for (i = 0; i < remotes.length; i++) {
                        if (!(await this.checkRemote(remotes[i]))) ok = false;
                    }
                }

                if (!ok) {
                    var first = this.$el.querySelector('[aria-invalid="true"]');
                    if (first) {
                        first.focus({ preventScroll: true });
                        first.scrollIntoView({ block: 'center', behavior: 'smooth' });
                    }
                }
                return ok;
            }
        };

        form._ccValidator = api;
        api.init();
        return api;
    }

    function attachAll(root) {
        var scope = root || document;
        var forms = scope.querySelectorAll ? scope.querySelectorAll('form[data-cc-validate]') : [];
        Array.prototype.forEach.call(forms, createValidator);
    }

    window.ccAttachValidation = createValidator;

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { attachAll(); });
    } else {
        attachAll();
    }

    /* Forms injected later (a plugin, or an AJAX-swapped fragment) are picked
       up without anyone having to remember to call us. */
    if (window.MutationObserver) {
        new MutationObserver(function (records) {
            for (var i = 0; i < records.length; i++) {
                var added = records[i].addedNodes;
                for (var j = 0; j < added.length; j++) {
                    var n = added[j];
                    if (n.nodeType !== 1) continue;
                    if (n.matches && n.matches('form[data-cc-validate]')) createValidator(n);
                    else attachAll(n);
                }
            }
        }).observe(document.documentElement, { childList: true, subtree: true });
    }
})();
;

/* ---- js/src/60-newsletter.js ---- */
/**
 * Atrium — newsletter signup box.
 *
 * HOUSE RULE: no ES6 template literals in this folder. See 00-boot.js.
 *
 * The captcha block is hidden until the email field is focused, so an unused
 * footer widget never loads third-party captcha JS on every page view. Once
 * revealed it stays revealed — re-hiding it would tear down a widget the
 * customer may already have solved.
 */

document.addEventListener('alpine:init', function () {
    window.Alpine.data('ccNewsletter', function () {
        return {
            showCaptcha: false
        };
    });

    /* Exit-intent modal (templates/modal.exit.php). Shown at most once a
       month per browser, and never on a touch device: the pointer leaving the
       viewport top is the only trigger, so there is nothing to fire there. */
    window.Alpine.data('ccExitModal', function () {
        return {
            open: false,

            init: function () {
                if (document.cookie.indexOf('newsletter_exit=') !== -1) return;

                var self = this;
                // Armed late: a pointer that swings off the window while the
                // page is still painting is not an exit.
                var armed = false;
                setTimeout(function () { armed = true; }, 3000);

                document.addEventListener('mouseout', function (event) {
                    if (!armed || self.open) return;
                    // Only a real exit past the top edge. relatedTarget is
                    // null when the pointer leaves the document entirely.
                    if (event.relatedTarget || event.clientY > 0) return;
                    self.show();
                });
            },

            show: function () {
                this.open = true;
                document.cookie = 'newsletter_exit=1;path=/;max-age=2592000;SameSite=Lax';
            },

            close: function () {
                this.open = false;
            }
        };
    });
});
;

/* ---- js/src/90-compat.js ---- */
/**
 * Atrium — behaviour shims for markup emitted by MODULES.
 *
 * HOUSE RULE: no ES6 template literals in this folder. See 00-boot.js.
 *
 * The CSS counterpart is css/src/compat.css. This file is for the cases CSS
 * cannot reach: module markup that depended on a Foundation JS behaviour the
 * reference skin provided and Atrium does not.
 *
 * Deliberately implemented as DELEGATED listeners on document, so they work on
 * markup that arrives after load (gateway forms are fetched into the checkout,
 * and the mini-basket is replaced wholesale by _g=ajaxadd).
 */

(function () {
    'use strict';

    /**
     * `.colorbox` — an inline image lightbox.
     *
     * modules/gateway/Card_Capture/skin/form.tpl emits, next to the CVV field:
     *     <a href="images/general/cvv.gif" class="colorbox">What's this?</a>
     * The reference skin rewrote that into a modal (2.cubecart.js:127-146).
     * Without a handler the link NAVIGATES AWAY from a part-completed card
     * form, mid-checkout, losing everything typed.
     *
     * Fixing it here rather than in a skin override of the module's template is
     * deliberate: an override forks the gateway's form permanently, so a future
     * module release that adds or renames a field would silently break payment
     * for Atrium stores only. The module keeps ownership of its markup; the
     * skin supplies the missing behaviour.
     */
    document.addEventListener('click', function (e) {
        var link = e.target.closest ? e.target.closest('a.colorbox') : null;
        if (!link) return;

        var href = link.getAttribute('href');
        if (!href) return;

        e.preventDefault();

        var overlay = document.createElement('div');
        overlay.className = 'cc-colorbox fixed inset-0 z-50 flex items-center justify-center bg-ink-950/80 p-4';
        overlay.setAttribute('role', 'dialog');
        overlay.setAttribute('aria-modal', 'true');
        overlay.setAttribute('aria-label', link.getAttribute('title') || link.textContent || '');

        var img = document.createElement('img');
        img.src = href;
        img.alt = link.getAttribute('title') || '';
        img.className = 'max-h-full max-w-full rounded-cc bg-white object-contain p-2';
        overlay.appendChild(img);

        function close() {
            overlay.remove();
            document.removeEventListener('keydown', onKey);
            if (link.focus) link.focus();          // return focus where it came from
        }
        function onKey(ev) { if (ev.key === 'Escape') close(); }

        overlay.addEventListener('click', close);
        document.addEventListener('keydown', onKey);
        document.body.appendChild(overlay);
    });
})();
;

/* ---- js/vendor/alpine-focus.min.js ---- */
(()=>{var fe=["input:not([inert]):not([inert] *)","select:not([inert]):not([inert] *)","textarea:not([inert]):not([inert] *)","a[href]:not([inert]):not([inert] *)","button:not([inert]):not([inert] *)","[tabindex]:not(slot):not([inert]):not([inert] *)","audio[controls]:not([inert]):not([inert] *)","video[controls]:not([inert]):not([inert] *)",'[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)',"details>summary:first-of-type:not([inert]):not([inert] *)","details:not([inert]):not([inert] *)"],J=fe.join(","),de=typeof Element>"u",M=de?function(){}:Element.prototype.matches||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector,Q=!de&&Element.prototype.getRootNode?function(a){var e;return a==null||(e=a.getRootNode)===null||e===void 0?void 0:e.call(a)}:function(a){return a?.ownerDocument},ee=function(e,t){var n;t===void 0&&(t=!0);var l=e==null||(n=e.getAttribute)===null||n===void 0?void 0:n.call(e,"inert"),u=l===""||l==="true",r=u||t&&e&&(typeof e.closest=="function"?e.closest("[inert]"):ee(e.parentNode));return r},Oe=function(e){var t,n=e==null||(t=e.getAttribute)===null||t===void 0?void 0:t.call(e,"contenteditable");return n===""||n==="true"},ve=function(e,t,n){if(ee(e))return[];var l=Array.prototype.slice.apply(e.querySelectorAll(J));return t&&M.call(e,J)&&l.unshift(e),l=l.filter(n),l},te=function(e,t,n){for(var l=[],u=Array.from(e);u.length;){var r=u.shift();if(!ee(r,!1))if(r.tagName==="SLOT"){var f=r.assignedElements(),d=f.length?f:r.children,h=te(d,!0,n);n.flatten?l.push.apply(l,h):l.push({scopeParent:r,candidates:h})}else{var S=M.call(r,J);S&&n.filter(r)&&(t||!e.includes(r))&&l.push(r);var w=r.shadowRoot||typeof n.getShadowRoot=="function"&&n.getShadowRoot(r),k=!ee(w,!1)&&(!n.shadowRootFilter||n.shadowRootFilter(r));if(w&&k){var E=te(w===!0?r.children:w.children,!0,n);n.flatten?l.push.apply(l,E):l.push({scopeParent:r,candidates:E})}else u.unshift.apply(u,r.children)}}return l},be=function(e){return!isNaN(parseInt(e.getAttribute("tabindex"),10))},L=function(e){if(!e)throw new Error("No node provided");return e.tabIndex<0&&(/^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName)||Oe(e))&&!be(e)?0:e.tabIndex},Re=function(e,t){var n=L(e);return n<0&&t&&!be(e)?0:n},Pe=function(e,t){return e.tabIndex===t.tabIndex?e.documentOrder-t.documentOrder:e.tabIndex-t.tabIndex},he=function(e){return e.tagName==="INPUT"},De=function(e){return he(e)&&e.type==="hidden"},Ce=function(e){var t=e.tagName==="DETAILS"&&Array.prototype.slice.apply(e.children).some(function(n){return n.tagName==="SUMMARY"});return t},xe=function(e,t){for(var n=0;n<e.length;n++)if(e[n].checked&&e[n].form===t)return e[n]},je=function(e){if(!e.name)return!0;var t=e.form||Q(e),n=function(f){return t.querySelectorAll('input[type="radio"][name="'+f+'"]')},l;if(typeof window<"u"&&typeof window.CSS<"u"&&typeof window.CSS.escape=="function")l=n(window.CSS.escape(e.name));else try{l=n(e.name)}catch(r){return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s",r.message),!1}var u=xe(l,e.form);return!u||u===e},_e=function(e){return he(e)&&e.type==="radio"},Le=function(e){return _e(e)&&!je(e)},Be=function(e){var t,n=e&&Q(e),l=(t=n)===null||t===void 0?void 0:t.host,u=!1;if(n&&n!==e){var r,f,d;for(u=!!((r=l)!==null&&r!==void 0&&(f=r.ownerDocument)!==null&&f!==void 0&&f.contains(l)||e!=null&&(d=e.ownerDocument)!==null&&d!==void 0&&d.contains(e));!u&&l;){var h,S,w;n=Q(l),l=(h=n)===null||h===void 0?void 0:h.host,u=!!((S=l)!==null&&S!==void 0&&(w=S.ownerDocument)!==null&&w!==void 0&&w.contains(l))}}return u},ce=function(e){var t=e.getBoundingClientRect(),n=t.width,l=t.height;return n===0&&l===0},Ge=function(e,t){var n=t.displayCheck,l=t.getShadowRoot;if(n==="full-native"&&"checkVisibility"in e){var u=e.checkVisibility({checkOpacity:!1,opacityProperty:!1,contentVisibilityAuto:!0,visibilityProperty:!0,checkVisibilityCSS:!0});return!u}if(getComputedStyle(e).visibility==="hidden")return!0;var r=M.call(e,"details>summary:first-of-type"),f=r?e.parentElement:e;if(M.call(f,"details:not([open]) *"))return!0;if(!n||n==="full"||n==="full-native"||n==="legacy-full"){if(typeof l=="function"){for(var d=e;e;){var h=e.parentElement,S=Q(e);if(h&&!h.shadowRoot&&l(h)===!0)return ce(e);e.assignedSlot?e=e.assignedSlot:!h&&S!==e.ownerDocument?e=S.host:e=h}e=d}if(Be(e))return!e.getClientRects().length;if(n!=="legacy-full")return!0}else if(n==="non-zero-area")return ce(e);return!1},Ke=function(e){if(/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName))for(var t=e.parentElement;t;){if(t.tagName==="FIELDSET"&&t.disabled){for(var n=0;n<t.children.length;n++){var l=t.children.item(n);if(l.tagName==="LEGEND")return M.call(t,"fieldset[disabled] *")?!0:!l.contains(e)}return!0}t=t.parentElement}return!1},re=function(e,t){return!(t.disabled||De(t)||Ge(t,e)||Ce(t)||Ke(t))},le=function(e,t){return!(Le(t)||L(t)<0||!re(e,t))},Me=function(e){var t=parseInt(e.getAttribute("tabindex"),10);return!!(isNaN(t)||t>=0)},pe=function(e){var t=[],n=[];return e.forEach(function(l,u){var r=!!l.scopeParent,f=r?l.scopeParent:l,d=Re(f,r),h=r?pe(l.candidates):f;d===0?r?t.push.apply(t,h):t.push(f):n.push({documentOrder:u,tabIndex:d,item:l,isScope:r,content:h})}),n.sort(Pe).reduce(function(l,u){return u.isScope?l.push.apply(l,u.content):l.push(u.content),l},[]).concat(t)},ye=function(e,t){t=t||{};var n;return t.getShadowRoot?n=te([e],t.includeContainer,{filter:le.bind(null,t),flatten:!1,getShadowRoot:t.getShadowRoot,shadowRootFilter:Me}):n=ve(e,t.includeContainer,le.bind(null,t)),pe(n)},ae=function(e,t){t=t||{};var n;return t.getShadowRoot?n=te([e],t.includeContainer,{filter:re.bind(null,t),flatten:!0,getShadowRoot:t.getShadowRoot}):n=ve(e,t.includeContainer,re.bind(null,t)),n},V=function(e,t){if(t=t||{},!e)throw new Error("No node provided");return M.call(e,J)===!1?!1:le(t,e)},Ve=fe.concat("iframe:not([inert]):not([inert] *)").join(","),q=function(e,t){if(t=t||{},!e)throw new Error("No node provided");return M.call(e,Ve)===!1?!1:re(t,e)};function se(a,e){(e==null||e>a.length)&&(e=a.length);for(var t=0,n=Array(e);t<e;t++)n[t]=a[t];return n}function We(a){if(Array.isArray(a))return se(a)}function me(a,e,t,n,l,u,r){try{var f=a[u](r),d=f.value}catch(h){return void t(h)}f.done?e(d):Promise.resolve(d).then(n,l)}function ge(a){return function(){var e=this,t=arguments;return new Promise(function(n,l){var u=a.apply(e,t);function r(d){me(u,n,l,r,f,"next",d)}function f(d){me(u,n,l,r,f,"throw",d)}r(void 0)})}}function we(a,e){var t=typeof Symbol<"u"&&a[Symbol.iterator]||a["@@iterator"];if(!t){if(Array.isArray(a)||(t=Ee(a))||e){t&&(a=t);var n=0,l=function(){};return{s:l,n:function(){return n>=a.length?{done:!0}:{done:!1,value:a[n++]}},e:function(d){throw d},f:l}}throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`)}var u,r=!0,f=!1;return{s:function(){t=t.call(a)},n:function(){var d=t.next();return r=d.done,d},e:function(d){f=!0,u=d},f:function(){try{r||t.return==null||t.return()}finally{if(f)throw u}}}}function qe(a,e,t){return(e=$e(e))in a?Object.defineProperty(a,e,{value:t,enumerable:!0,configurable:!0,writable:!0}):a[e]=t,a}function Ue(a){if(typeof Symbol<"u"&&a[Symbol.iterator]!=null||a["@@iterator"]!=null)return Array.from(a)}function Ye(){throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`)}function Se(a,e){var t=Object.keys(a);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(a);e&&(n=n.filter(function(l){return Object.getOwnPropertyDescriptor(a,l).enumerable})),t.push.apply(t,n)}return t}function Te(a){for(var e=1;e<arguments.length;e++){var t=arguments[e]!=null?arguments[e]:{};e%2?Se(Object(t),!0).forEach(function(n){qe(a,n,t[n])}):Object.getOwnPropertyDescriptors?Object.defineProperties(a,Object.getOwnPropertyDescriptors(t)):Se(Object(t)).forEach(function(n){Object.defineProperty(a,n,Object.getOwnPropertyDescriptor(t,n))})}return a}function H(){var a,e,t=typeof Symbol=="function"?Symbol:{},n=t.iterator||"@@iterator",l=t.toStringTag||"@@toStringTag";function u(E,F,B,D){var W=F&&F.prototype instanceof f?F:f,U=Object.create(W.prototype);return P(U,"_invoke",function(ie,$,z){var C,T,I,G=0,X=z||[],x=!1,A={p:0,n:0,v:a,a:y,f:y.bind(a,4),d:function(i,o){return C=i,T=0,I=a,A.n=o,r}};function y(i,o){for(T=i,I=o,e=0;!x&&G&&!s&&e<X.length;e++){var s,c=X[e],b=A.p,p=c[2];i>3?(s=p===o)&&(I=c[(T=c[4])?5:(T=3,3)],c[4]=c[5]=a):c[0]<=b&&((s=i<2&&b<c[1])?(T=0,A.v=o,A.n=c[1]):b<p&&(s=i<3||c[0]>o||o>p)&&(c[4]=i,c[5]=o,A.n=p,T=0))}if(s||i>1)return r;throw x=!0,o}return function(i,o,s){if(G>1)throw TypeError("Generator is already running");for(x&&o===1&&y(o,s),T=o,I=s;(e=T<2?a:I)||!x;){C||(T?T<3?(T>1&&(A.n=-1),y(T,I)):A.n=I:A.v=I);try{if(G=2,C){if(T||(i="next"),e=C[i]){if(!(e=e.call(C,I)))throw TypeError("iterator result is not an object");if(!e.done)return e;I=e.value,T<2&&(T=0)}else T===1&&(e=C.return)&&e.call(C),T<2&&(I=TypeError("The iterator does not provide a '"+i+"' method"),T=1);C=a}else if((e=(x=A.n<0)?I:ie.call($,A))!==r)break}catch(c){C=a,T=1,I=c}finally{G=1}}return{value:e,done:x}}}(E,B,D),!0),U}var r={};function f(){}function d(){}function h(){}e=Object.getPrototypeOf;var S=[][n]?e(e([][n]())):(P(e={},n,function(){return this}),e),w=h.prototype=f.prototype=Object.create(S);function k(E){return Object.setPrototypeOf?Object.setPrototypeOf(E,h):(E.__proto__=h,P(E,l,"GeneratorFunction")),E.prototype=Object.create(w),E}return d.prototype=h,P(w,"constructor",h),P(h,"constructor",d),d.displayName="GeneratorFunction",P(h,l,"GeneratorFunction"),P(w),P(w,l,"Generator"),P(w,n,function(){return this}),P(w,"toString",function(){return"[object Generator]"}),(H=function(){return{w:u,m:k}})()}function P(a,e,t,n){var l=Object.defineProperty;try{l({},"",{})}catch{l=0}P=function(u,r,f,d){function h(S,w){P(u,S,function(k){return this._invoke(S,w,k)})}r?l?l(u,r,{value:f,enumerable:!d,configurable:!d,writable:!d}):u[r]=f:(h("next",0),h("throw",1),h("return",2))},P(a,e,t,n)}function He(a){return We(a)||Ue(a)||Ee(a)||Ye()}function Ze(a,e){if(typeof a!="object"||!a)return a;var t=a[Symbol.toPrimitive];if(t!==void 0){var n=t.call(a,e);if(typeof n!="object")return n;throw new TypeError("@@toPrimitive must return a primitive value.")}return(e==="string"?String:Number)(a)}function $e(a){var e=Ze(a,"string");return typeof e=="symbol"?e:e+""}function Ee(a,e){if(a){if(typeof a=="string")return se(a,e);var t={}.toString.call(a).slice(8,-1);return t==="Object"&&a.constructor&&(t=a.constructor.name),t==="Map"||t==="Set"?Array.from(a):t==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)?se(a,e):void 0}}var j={getActiveTrap:function(e){return e?.length>0?e[e.length-1]:null},activateTrap:function(e,t){var n=j.getActiveTrap(e);t!==n&&j.pauseTrap(e);var l=e.indexOf(t);l===-1||e.splice(l,1),e.push(t)},deactivateTrap:function(e,t){var n=e.indexOf(t);n!==-1&&e.splice(n,1),j.unpauseTrap(e)},pauseTrap:function(e){var t=j.getActiveTrap(e);t?._setPausedState(!0)},unpauseTrap:function(e){var t=j.getActiveTrap(e);t&&!t._isManuallyPaused()&&t._setPausedState(!1)}},ze=function(e){return e.tagName&&e.tagName.toLowerCase()==="input"&&typeof e.select=="function"},Xe=function(e){return e?.key==="Escape"||e?.key==="Esc"||e?.keyCode===27},Z=function(e){return e?.key==="Tab"||e?.keyCode===9},Je=function(e){return Z(e)&&!e.shiftKey},Qe=function(e){return Z(e)&&e.shiftKey},Ne=function(e){return setTimeout(e,0)},Y=function(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),l=1;l<t;l++)n[l-1]=arguments[l];return typeof e=="function"?e.apply(void 0,n):e},ne=function(e){return e.target.shadowRoot&&typeof e.composedPath=="function"?e.composedPath()[0]:e.target},et=[],Fe=function(e,t){var n=t?.document||document,l=t?.trapStack||et,u=Te({returnFocusOnDeactivate:!0,escapeDeactivates:!0,delayInitialFocus:!0,isolateSubtrees:!1,isKeyForward:Je,isKeyBackward:Qe},t),r={containers:[],containerGroups:[],tabbableGroups:[],adjacentElements:new Set,alreadySilent:new Set,nodeFocusedBeforeActivation:null,mostRecentlyFocusedNode:null,active:!1,paused:!1,manuallyPaused:!1,delayInitialFocusTimer:void 0,recentNavEvent:void 0},f,d=function(i,o,s){return i&&i[o]!==void 0?i[o]:u[s||o]},h=function(i,o){var s=typeof o?.composedPath=="function"?o.composedPath():void 0;return r.containerGroups.findIndex(function(c){var b=c.container,p=c.tabbableNodes;return b.contains(i)||s?.includes(b)||p.find(function(v){return v===i})})},S=function(i){var o=arguments.length>1&&arguments[1]!==void 0?arguments[1]:{},s=o.hasFallback,c=s===void 0?!1:s,b=o.params,p=b===void 0?[]:b,v=u[i];if(typeof v=="function"&&(v=v.apply(void 0,He(p))),v===!0&&(v=void 0),!v){if(v===void 0||v===!1)return v;throw new Error("`".concat(i,"` was specified but was not a node, or did not return a node"))}var m=v;if(typeof v=="string"){try{m=n.querySelector(v)}catch(g){throw new Error("`".concat(i,'` appears to be an invalid selector; error="').concat(g.message,'"'))}if(!m&&!c)throw new Error("`".concat(i,"` as selector refers to no known node"))}return m},w=function(){var i=S("initialFocus",{hasFallback:!0});if(i===!1)return!1;if(i===void 0||i&&!q(i,u.tabbableOptions))if(h(n.activeElement)>=0)i=n.activeElement;else{var o=r.tabbableGroups[0],s=o&&o.firstTabbableNode;i=s||S("fallbackFocus")}else i===null&&(i=S("fallbackFocus"));if(!i)throw new Error("Your focus-trap needs to have at least one focusable element");return i},k=function(){if(r.containerGroups=r.containers.map(function(i){var o=ye(i,u.tabbableOptions),s=ae(i,u.tabbableOptions),c=o.length>0?o[0]:void 0,b=o.length>0?o[o.length-1]:void 0,p=s.find(function(g){return V(g)}),v=s.slice().reverse().find(function(g){return V(g)}),m=!!o.find(function(g){return L(g)>0});return{container:i,tabbableNodes:o,focusableNodes:s,posTabIndexesFound:m,firstTabbableNode:c,lastTabbableNode:b,firstDomTabbableNode:p,lastDomTabbableNode:v,nextTabbableNode:function(N){var R=arguments.length>1&&arguments[1]!==void 0?arguments[1]:!0,O=o.indexOf(N);return O<0?R?s.slice(s.indexOf(N)+1).find(function(K){return V(K)}):s.slice(0,s.indexOf(N)).reverse().find(function(K){return V(K)}):o[O+(R?1:-1)]}}}),r.tabbableGroups=r.containerGroups.filter(function(i){return i.tabbableNodes.length>0}),r.tabbableGroups.length<=0&&!S("fallbackFocus"))throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");if(r.containerGroups.find(function(i){return i.posTabIndexesFound})&&r.containerGroups.length>1)throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.")},E=function(i){var o=i.activeElement;if(o)return o.shadowRoot&&o.shadowRoot.activeElement!==null?E(o.shadowRoot):o},F=function(i){if(i!==!1&&i!==E(document)){if(!i||!i.focus){F(w());return}i.focus({preventScroll:!!u.preventScroll}),r.mostRecentlyFocusedNode=i,ze(i)&&i.select()}},B=function(i){var o=S("setReturnFocus",{params:[i]});return o||(o===!1?!1:i)},D=function(i){var o=i.target,s=i.event,c=i.isBackward,b=c===void 0?!1:c;o=o||ne(s),k();var p=null;if(r.tabbableGroups.length>0){var v=h(o,s),m=v>=0?r.containerGroups[v]:void 0;if(v<0)b?p=r.tabbableGroups[r.tabbableGroups.length-1].lastTabbableNode:p=r.tabbableGroups[0].firstTabbableNode;else if(b){var g=r.tabbableGroups.findIndex(function(oe){var ue=oe.firstTabbableNode;return o===ue});if(g<0&&(m.container===o||q(o,u.tabbableOptions)&&!V(o,u.tabbableOptions)&&!m.nextTabbableNode(o,!1))&&(g=v),g>=0){var N=g===0?r.tabbableGroups.length-1:g-1,R=r.tabbableGroups[N];p=L(o)>=0?R.lastTabbableNode:R.lastDomTabbableNode}else Z(s)||(p=m.nextTabbableNode(o,!1))}else{var O=r.tabbableGroups.findIndex(function(oe){var ue=oe.lastTabbableNode;return o===ue});if(O<0&&(m.container===o||q(o,u.tabbableOptions)&&!V(o,u.tabbableOptions)&&!m.nextTabbableNode(o))&&(O=v),O>=0){var K=O===r.tabbableGroups.length-1?0:O+1,_=r.tabbableGroups[K];p=L(o)>=0?_.firstTabbableNode:_.firstDomTabbableNode}else Z(s)||(p=m.nextTabbableNode(o))}}else p=S("fallbackFocus");return p},W=function(i){var o=ne(i);if(!(h(o,i)>=0)){if(Y(u.clickOutsideDeactivates,i)){f.deactivate({returnFocus:u.returnFocusOnDeactivate});return}Y(u.allowOutsideClick,i)||i.preventDefault()}},U=function(i){var o=ne(i),s=h(o,i)>=0;if(s||o instanceof Document)s&&(r.mostRecentlyFocusedNode=o);else{i.stopImmediatePropagation();var c,b=!0;if(r.mostRecentlyFocusedNode)if(L(r.mostRecentlyFocusedNode)>0){var p=h(r.mostRecentlyFocusedNode),v=r.containerGroups[p].tabbableNodes;if(v.length>0){var m=v.findIndex(function(g){return g===r.mostRecentlyFocusedNode});m>=0&&(u.isKeyForward(r.recentNavEvent)?m+1<v.length&&(c=v[m+1],b=!1):m-1>=0&&(c=v[m-1],b=!1))}}else r.containerGroups.some(function(g){return g.tabbableNodes.some(function(N){return L(N)>0})})||(b=!1);else b=!1;b&&(c=D({target:r.mostRecentlyFocusedNode,isBackward:u.isKeyBackward(r.recentNavEvent)})),F(c||r.mostRecentlyFocusedNode||w())}r.recentNavEvent=void 0},ie=function(i){var o=arguments.length>1&&arguments[1]!==void 0?arguments[1]:!1;r.recentNavEvent=i;var s=D({event:i,isBackward:o});s&&(Z(i)&&i.preventDefault(),F(s))},$=function(i){(u.isKeyForward(i)||u.isKeyBackward(i))&&ie(i,u.isKeyBackward(i))},z=function(i){Xe(i)&&Y(u.escapeDeactivates,i)!==!1&&(i.preventDefault(),f.deactivate())},C=function(i){var o=ne(i);h(o,i)>=0||Y(u.clickOutsideDeactivates,i)||Y(u.allowOutsideClick,i)||(i.preventDefault(),i.stopImmediatePropagation())},T=function(){if(!r.active)return Promise.resolve();j.activateTrap(l,f);var i;return u.delayInitialFocus?i=new Promise(function(o){r.delayInitialFocusTimer=Ne(function(){F(w()),o()})}):(i=Promise.resolve(),F(w())),n.addEventListener("focusin",U,!0),n.addEventListener("mousedown",W,{capture:!0,passive:!1}),n.addEventListener("touchstart",W,{capture:!0,passive:!1}),n.addEventListener("click",C,{capture:!0,passive:!1}),n.addEventListener("keydown",$,{capture:!0,passive:!1}),n.addEventListener("keydown",z),i},I=function(i){r.active&&!r.paused&&f._setSubtreeIsolation(!1),r.adjacentElements.clear(),r.alreadySilent.clear();var o=new Set,s=new Set,c=we(i),b;try{for(c.s();!(b=c.n()).done;){var p=b.value;o.add(p);for(var v=typeof ShadowRoot<"u"&&p.getRootNode()instanceof ShadowRoot,m=p;m;){o.add(m);var g=m.parentElement,N=[];g?N=g.children:!g&&v&&(N=m.getRootNode().children,g=m.getRootNode().host,v=typeof ShadowRoot<"u"&&g.getRootNode()instanceof ShadowRoot);var R=we(N),O;try{for(R.s();!(O=R.n()).done;){var K=O.value;s.add(K)}}catch(_){R.e(_)}finally{R.f()}m=g}}}catch(_){c.e(_)}finally{c.f()}o.forEach(function(_){s.delete(_)}),r.adjacentElements=s},G=function(){if(r.active)return n.removeEventListener("focusin",U,!0),n.removeEventListener("mousedown",W,!0),n.removeEventListener("touchstart",W,!0),n.removeEventListener("click",C,!0),n.removeEventListener("keydown",$,!0),n.removeEventListener("keydown",z),f},X=function(i){var o=i.some(function(s){var c=Array.from(s.removedNodes);return c.some(function(b){return b===r.mostRecentlyFocusedNode})});o&&F(w())},x=typeof window<"u"&&"MutationObserver"in window?new MutationObserver(X):void 0,A=function(){x&&(x.disconnect(),r.active&&!r.paused&&r.containers.map(function(i){x.observe(i,{subtree:!0,childList:!0})}))};return f={get active(){return r.active},get paused(){return r.paused},activate:function(i){if(r.active)return this;var o=d(i,"onActivate"),s=d(i,"onPostActivate"),c=d(i,"checkCanFocusTrap"),b=j.getActiveTrap(l),p=!1;if(b&&!b.paused){var v;(v=b._setSubtreeIsolation)===null||v===void 0||v.call(b,!1),p=!0}try{c||k(),r.active=!0,r.paused=!1,r.nodeFocusedBeforeActivation=E(n),o?.();var m=function(){var N=ge(H().m(function R(){return H().w(function(O){for(;;)switch(O.n){case 0:return c&&k(),O.n=1,T();case 1:f._setSubtreeIsolation(!0),A(),s?.();case 2:return O.a(2)}},R)}));return function(){return N.apply(this,arguments)}}();if(c)return c(r.containers.concat()).then(m,m),this;m()}catch(N){if(b===j.getActiveTrap(l)&&p){var g;(g=b._setSubtreeIsolation)===null||g===void 0||g.call(b,!0)}throw N}return this},deactivate:function(i){if(!r.active)return this;var o=Te({onDeactivate:u.onDeactivate,onPostDeactivate:u.onPostDeactivate,checkCanReturnFocus:u.checkCanReturnFocus},i);clearTimeout(r.delayInitialFocusTimer),r.delayInitialFocusTimer=void 0,r.paused||f._setSubtreeIsolation(!1),r.alreadySilent.clear(),G(),r.active=!1,r.paused=!1,A(),j.deactivateTrap(l,f);var s=d(o,"onDeactivate"),c=d(o,"onPostDeactivate"),b=d(o,"checkCanReturnFocus"),p=d(o,"returnFocus","returnFocusOnDeactivate");s?.();var v=function(){Ne(function(){p&&F(B(r.nodeFocusedBeforeActivation)),c?.()})};return p&&b?(b(B(r.nodeFocusedBeforeActivation)).then(v,v),this):(v(),this)},pause:function(i){return r.active?(r.manuallyPaused=!0,this._setPausedState(!0,i)):this},unpause:function(i){return r.active?(r.manuallyPaused=!1,l[l.length-1]!==this?this:this._setPausedState(!1,i)):this},updateContainerElements:function(i){var o=[].concat(i).filter(Boolean);return r.containers=o.map(function(s){return typeof s=="string"?n.querySelector(s):s}),u.isolateSubtrees&&I(r.containers),r.active&&(k(),r.paused||f._setSubtreeIsolation(!0)),A(),this}},Object.defineProperties(f,{_isManuallyPaused:{value:function(){return r.manuallyPaused}},_setPausedState:{value:function(i,o){if(r.paused===i)return this;if(r.paused=i,i){var s=d(o,"onPause"),c=d(o,"onPostPause");s?.(),G(),f._setSubtreeIsolation(!1),A(),c?.()}else{var b=d(o,"onUnpause"),p=d(o,"onPostUnpause");b?.();var v=function(){var m=ge(H().m(function g(){return H().w(function(N){for(;;)switch(N.n){case 0:return k(),N.n=1,T();case 1:f._setSubtreeIsolation(!0),A(),p?.();case 2:return N.a(2)}},g)}));return function(){return m.apply(this,arguments)}}();v()}return this}},_setSubtreeIsolation:{value:function(i){u.isolateSubtrees&&r.adjacentElements.forEach(function(o){var s;if(i)switch(u.isolateSubtrees){case"aria-hidden":(o.ariaHidden==="true"||((s=o.getAttribute("aria-hidden"))===null||s===void 0?void 0:s.toLowerCase())==="true")&&r.alreadySilent.add(o),o.setAttribute("aria-hidden","true");break;default:(o.inert||o.hasAttribute("inert"))&&r.alreadySilent.add(o),o.setAttribute("inert",!0);break}else if(!r.alreadySilent.has(o))switch(u.isolateSubtrees){case"aria-hidden":o.removeAttribute("aria-hidden");break;default:o.removeAttribute("inert");break}})}}}),f.updateContainerElements(e),f};function ke(a){let e,t;window.addEventListener("focusin",()=>{e=t,t=document.activeElement}),a.magic("focus",n=>{let l=n;return{__noscroll:!1,__wrapAround:!1,within(u){return l=u,this},withoutScrolling(){return this.__noscroll=!0,this},noscroll(){return this.__noscroll=!0,this},withWrapAround(){return this.__wrapAround=!0,this},wrap(){return this.withWrapAround()},focusable(u){return q(u)},previouslyFocused(){return e},lastFocused(){return e},focused(){return t},focusables(){return Array.isArray(l)?l:ae(l,{displayCheck:"none"})},all(){return this.focusables()},isFirst(u){let r=this.all();return r[0]&&r[0].isSameNode(u)},isLast(u){let r=this.all();return r.length&&r.slice(-1)[0].isSameNode(u)},getFirst(){return this.all()[0]},getLast(){return this.all().slice(-1)[0]},getNext(){let u=this.all(),r=document.activeElement;if(u.indexOf(r)!==-1)return this.__wrapAround&&u.indexOf(r)===u.length-1?u[0]:u[u.indexOf(r)+1]},getPrevious(){let u=this.all(),r=document.activeElement;if(u.indexOf(r)!==-1)return this.__wrapAround&&u.indexOf(r)===0?u.slice(-1)[0]:u[u.indexOf(r)-1]},first(){this.focus(this.getFirst())},last(){this.focus(this.getLast())},next(){this.focus(this.getNext())},previous(){this.focus(this.getPrevious())},prev(){return this.previous()},focus(u){u&&setTimeout(()=>{u.hasAttribute("tabindex")||u.setAttribute("tabindex","0"),u.focus({preventScroll:this.__noscroll})})}}}),a.directive("trap",a.skipDuringClone((n,{expression:l,modifiers:u},{effect:r,evaluateLater:f,cleanup:d})=>{let h=f(l),S=!1,w={escapeDeactivates:!1,allowOutsideClick:!0,fallbackFocus:()=>n},k=()=>{};if(u.includes("noautofocus"))w.initialFocus=!1;else{let D=n.querySelector("[autofocus]");D&&(w.initialFocus=D)}u.includes("inert")&&(w.onPostActivate=()=>{a.nextTick(()=>{k=Ae(n)})});let E=Fe(n,w),F=()=>{},B=()=>{k(),k=()=>{},F(),F=()=>{},E.deactivate({returnFocus:!u.includes("noreturn")})};r(()=>h(D=>{S!==D&&(D&&!S&&(u.includes("noscroll")&&(F=tt()),setTimeout(()=>{E.activate()},15)),!D&&S&&B(),S=!!D)})),d(B)},(n,{expression:l,modifiers:u},{evaluate:r})=>{u.includes("inert")&&r(l)&&Ae(n)}))}function Ae(a){let e=[];return Ie(a,t=>{let n=t.hasAttribute("aria-hidden");t.setAttribute("aria-hidden","true"),e.push(()=>n||t.removeAttribute("aria-hidden"))}),()=>{for(;e.length;)e.pop()()}}function Ie(a,e){a.isSameNode(document.body)||!a.parentNode||Array.from(a.parentNode.children).forEach(t=>{t.isSameNode(a)?Ie(a.parentNode,e):e(t)})}function tt(){let a=document.documentElement.style.overflow,e=document.documentElement.style.paddingRight,t=window.innerWidth-document.documentElement.clientWidth,n=window.getComputedStyle(document.documentElement).scrollbarGutter;return document.documentElement.style.overflow="hidden",n&&n!=="auto"?()=>{document.documentElement.style.overflow=a}:(document.documentElement.style.paddingRight=`${t}px`,()=>{document.documentElement.style.overflow=a,document.documentElement.style.paddingRight=e})}document.addEventListener("alpine:init",()=>{window.Alpine.plugin(ke)});})();
/*! Bundled license information:

tabbable/dist/index.esm.js:
  (*!
  * tabbable 6.4.0
  * @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
  *)

focus-trap/dist/focus-trap.esm.js:
  (*!
  * focus-trap 8.0.0
  * @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
  *)
  (*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE *)
*/
;

/* ---- js/vendor/alpine-collapse.min.js ---- */
(()=>{function g(n){n.directive("collapse",e),e.inline=(t,{modifiers:i})=>{i.includes("min")&&(t._x_doShow=()=>{},t._x_doHide=()=>{})};function e(t,{modifiers:i}){let r=l(i,"duration",250)/1e3,h=l(i,"min",0),u=!i.includes("min");t._x_isShown||(t.style.height=`${h}px`),!t._x_isShown&&u&&(t.hidden=!0),t._x_isShown||(t.style.overflow="hidden");let c=(d,s)=>{let o=n.setStyles(d,s);return s.height?()=>{}:o},f={transitionProperty:"height",transitionDuration:`${r}s`,transitionTimingFunction:"cubic-bezier(0.4, 0.0, 0.2, 1)"};t._x_transition={in(d=()=>{},s=()=>{}){u&&(t.hidden=!1),u&&(t.style.display=null);let o=t.getBoundingClientRect().height;t.style.height="auto";let a=t.getBoundingClientRect().height;o===a&&(o=h),n.transition(t,n.setStyles,{during:f,start:{height:o+"px"},end:{height:a+"px"}},()=>t._x_isShown=!0,()=>{Math.abs(t.getBoundingClientRect().height-a)<1&&(t.style.overflow=null)})},out(d=()=>{},s=()=>{}){let o=t.getBoundingClientRect().height;n.transition(t,c,{during:f,start:{height:o+"px"},end:{height:h+"px"}},()=>t.style.overflow="hidden",()=>{t._x_isShown=!1,t.style.height==`${h}px`&&u&&(t.style.display="none",t.hidden=!0)})}}}}function l(n,e,t){if(n.indexOf(e)===-1)return t;let i=n[n.indexOf(e)+1];if(!i)return t;if(e==="duration"){let r=i.match(/([0-9]+)ms/);if(r)return r[1]}if(e==="min"){let r=i.match(/([0-9]+)px/);if(r)return r[1]}return i}document.addEventListener("alpine:init",()=>{window.Alpine.plugin(g)});})();
;

/* ---- js/vendor/alpine-anchor.min.js ---- */
(()=>{var V=Math.min,S=Math.max,X=Math.round,U=Math.floor,T=t=>({x:t,y:t}),Ht={left:"right",right:"left",bottom:"top",top:"bottom"},zt={start:"end",end:"start"};function ot(t,e,n){return S(t,V(e,n))}function q(t,e){return typeof t=="function"?t(e):t}function L(t){return t.split("-")[0]}function J(t){return t.split("-")[1]}function it(t){return t==="x"?"y":"x"}function st(t){return t==="y"?"height":"width"}function K(t){return["top","bottom"].includes(L(t))?"y":"x"}function rt(t){return it(K(t))}function pt(t,e,n){n===void 0&&(n=!1);let o=J(t),i=rt(t),r=st(i),s=i==="x"?o===(n?"end":"start")?"right":"left":o==="start"?"bottom":"top";return e.reference[r]>e.floating[r]&&(s=$(s)),[s,$(s)]}function xt(t){let e=$(t);return[tt(t),e,tt(e)]}function tt(t){return t.replace(/start|end/g,e=>zt[e])}function It(t,e,n){let o=["left","right"],i=["right","left"],r=["top","bottom"],s=["bottom","top"];switch(t){case"top":case"bottom":return n?e?i:o:e?o:i;case"left":case"right":return e?r:s;default:return[]}}function wt(t,e,n,o){let i=J(t),r=It(L(t),n==="start",o);return i&&(r=r.map(s=>s+"-"+i),e&&(r=r.concat(r.map(tt)))),r}function $(t){return t.replace(/left|right|bottom|top/g,e=>Ht[e])}function jt(t){return{top:0,right:0,bottom:0,left:0,...t}}function yt(t){return typeof t!="number"?jt(t):{top:t,right:t,bottom:t,left:t}}function _(t){return{...t,top:t.y,left:t.x,right:t.x+t.width,bottom:t.y+t.height}}function vt(t,e,n){let{reference:o,floating:i}=t,r=K(e),s=rt(e),c=st(s),l=L(e),f=r==="y",m=o.x+o.width/2-i.width/2,u=o.y+o.height/2-i.height/2,p=o[c]/2-i[c]/2,a;switch(l){case"top":a={x:m,y:o.y-i.height};break;case"bottom":a={x:m,y:o.y+o.height};break;case"right":a={x:o.x+o.width,y:u};break;case"left":a={x:o.x-i.width,y:u};break;default:a={x:o.x,y:o.y}}switch(J(e)){case"start":a[s]-=p*(n&&f?-1:1);break;case"end":a[s]+=p*(n&&f?-1:1);break}return a}var bt=async(t,e,n)=>{let{placement:o="bottom",strategy:i="absolute",middleware:r=[],platform:s}=n,c=r.filter(Boolean),l=await(s.isRTL==null?void 0:s.isRTL(e)),f=await s.getElementRects({reference:t,floating:e,strategy:i}),{x:m,y:u}=vt(f,o,l),p=o,a={},d=0;for(let h=0;h<c.length;h++){let{name:w,fn:g}=c[h],{x,y,data:O,reset:v}=await g({x:m,y:u,initialPlacement:o,placement:p,strategy:i,middlewareData:a,rects:f,platform:s,elements:{reference:t,floating:e}});if(m=x??m,u=y??u,a={...a,[w]:{...a[w],...O}},v&&d<=50){d++,typeof v=="object"&&(v.placement&&(p=v.placement),v.rects&&(f=v.rects===!0?await s.getElementRects({reference:t,floating:e,strategy:i}):v.rects),{x:m,y:u}=vt(f,p,l)),h=-1;continue}}return{x:m,y:u,placement:p,strategy:i,middlewareData:a}};async function ct(t,e){var n;e===void 0&&(e={});let{x:o,y:i,platform:r,rects:s,elements:c,strategy:l}=t,{boundary:f="clippingAncestors",rootBoundary:m="viewport",elementContext:u="floating",altBoundary:p=!1,padding:a=0}=q(e,t),d=yt(a),w=c[p?u==="floating"?"reference":"floating":u],g=_(await r.getClippingRect({element:(n=await(r.isElement==null?void 0:r.isElement(w)))==null||n?w:w.contextElement||await(r.getDocumentElement==null?void 0:r.getDocumentElement(c.floating)),boundary:f,rootBoundary:m,strategy:l})),x=u==="floating"?{...s.floating,x:o,y:i}:s.reference,y=await(r.getOffsetParent==null?void 0:r.getOffsetParent(c.floating)),O=await(r.isElement==null?void 0:r.isElement(y))?await(r.getScale==null?void 0:r.getScale(y))||{x:1,y:1}:{x:1,y:1},v=_(r.convertOffsetParentRelativeRectToViewportRelativeRect?await r.convertOffsetParentRelativeRectToViewportRelativeRect({rect:x,offsetParent:y,strategy:l}):x);return{top:(g.top-v.top+d.top)/O.y,bottom:(v.bottom-g.bottom+d.bottom)/O.y,left:(g.left-v.left+d.left)/O.x,right:(v.right-g.right+d.right)/O.x}}var lt=function(t){return t===void 0&&(t={}),{name:"flip",options:t,async fn(e){var n,o;let{placement:i,middlewareData:r,rects:s,initialPlacement:c,platform:l,elements:f}=e,{mainAxis:m=!0,crossAxis:u=!0,fallbackPlacements:p,fallbackStrategy:a="bestFit",fallbackAxisSideDirection:d="none",flipAlignment:h=!0,...w}=q(t,e);if((n=r.arrow)!=null&&n.alignmentOffset)return{};let g=L(i),x=L(c)===c,y=await(l.isRTL==null?void 0:l.isRTL(f.floating)),O=p||(x||!h?[$(c)]:xt(c));!p&&d!=="none"&&O.push(...wt(c,h,d,y));let v=[c,...O],D=await ct(e,w),Z=[],I=((o=r.flip)==null?void 0:o.overflows)||[];if(m&&Z.push(D[g]),u){let k=pt(i,s,y);Z.push(D[k[0]],D[k[1]])}if(I=[...I,{placement:i,overflows:Z}],!Z.every(k=>k<=0)){var dt,mt;let k=(((dt=r.flip)==null?void 0:dt.index)||0)+1,ht=v[k];if(ht)return{data:{index:k,overflows:I},reset:{placement:ht}};let j=(mt=I.filter(N=>N.overflows[0]<=0).sort((N,B)=>N.overflows[1]-B.overflows[1])[0])==null?void 0:mt.placement;if(!j)switch(a){case"bestFit":{var gt;let N=(gt=I.map(B=>[B.placement,B.overflows.filter(Y=>Y>0).reduce((Y,Wt)=>Y+Wt,0)]).sort((B,Y)=>B[1]-Y[1])[0])==null?void 0:gt[0];N&&(j=N);break}case"initialPlacement":j=c;break}if(i!==j)return{reset:{placement:j}}}return{}}}};async function Yt(t,e){let{placement:n,platform:o,elements:i}=t,r=await(o.isRTL==null?void 0:o.isRTL(i.floating)),s=L(n),c=J(n),l=K(n)==="y",f=["left","top"].includes(s)?-1:1,m=r&&l?-1:1,u=q(e,t),{mainAxis:p,crossAxis:a,alignmentAxis:d}=typeof u=="number"?{mainAxis:u,crossAxis:0,alignmentAxis:null}:{mainAxis:0,crossAxis:0,alignmentAxis:null,...u};return c&&typeof d=="number"&&(a=c==="end"?d*-1:d),l?{x:a*m,y:p*f}:{x:p*f,y:a*m}}var ft=function(t){return t===void 0&&(t=0),{name:"offset",options:t,async fn(e){let{x:n,y:o}=e,i=await Yt(e,t);return{x:n+i.x,y:o+i.y,data:i}}}},at=function(t){return t===void 0&&(t={}),{name:"shift",options:t,async fn(e){let{x:n,y:o,placement:i}=e,{mainAxis:r=!0,crossAxis:s=!1,limiter:c={fn:w=>{let{x:g,y:x}=w;return{x:g,y:x}}},...l}=q(t,e),f={x:n,y:o},m=await ct(e,l),u=K(L(i)),p=it(u),a=f[p],d=f[u];if(r){let w=p==="y"?"top":"left",g=p==="y"?"bottom":"right",x=a+m[w],y=a-m[g];a=ot(x,a,y)}if(s){let w=u==="y"?"top":"left",g=u==="y"?"bottom":"right",x=d+m[w],y=d-m[g];d=ot(x,d,y)}let h=c.fn({...e,[p]:a,[u]:d});return{...h,data:{x:h.x-n,y:h.y-o}}}}};function P(t){return Ot(t)?(t.nodeName||"").toLowerCase():"#document"}function b(t){var e;return(t==null||(e=t.ownerDocument)==null?void 0:e.defaultView)||window}function C(t){var e;return(e=(Ot(t)?t.ownerDocument:t.document)||window.document)==null?void 0:e.documentElement}function Ot(t){return t instanceof Node||t instanceof b(t).Node}function E(t){return t instanceof Element||t instanceof b(t).Element}function R(t){return t instanceof HTMLElement||t instanceof b(t).HTMLElement}function At(t){return typeof ShadowRoot>"u"?!1:t instanceof ShadowRoot||t instanceof b(t).ShadowRoot}function H(t){let{overflow:e,overflowX:n,overflowY:o,display:i}=A(t);return/auto|scroll|overlay|hidden|clip/.test(e+o+n)&&!["inline","contents"].includes(i)}function Rt(t){return["table","td","th"].includes(P(t))}function et(t){let e=nt(),n=A(t);return n.transform!=="none"||n.perspective!=="none"||(n.containerType?n.containerType!=="normal":!1)||!e&&(n.backdropFilter?n.backdropFilter!=="none":!1)||!e&&(n.filter?n.filter!=="none":!1)||["transform","perspective","filter"].some(o=>(n.willChange||"").includes(o))||["paint","layout","strict","content"].some(o=>(n.contain||"").includes(o))}function Ct(t){let e=M(t);for(;R(e)&&!G(e);){if(et(e))return e;e=M(e)}return null}function nt(){return typeof CSS>"u"||!CSS.supports?!1:CSS.supports("-webkit-backdrop-filter","none")}function G(t){return["html","body","#document"].includes(P(t))}function A(t){return b(t).getComputedStyle(t)}function Q(t){return E(t)?{scrollLeft:t.scrollLeft,scrollTop:t.scrollTop}:{scrollLeft:t.pageXOffset,scrollTop:t.pageYOffset}}function M(t){if(P(t)==="html")return t;let e=t.assignedSlot||t.parentNode||At(t)&&t.host||C(t);return At(e)?e.host:e}function Et(t){let e=M(t);return G(e)?t.ownerDocument?t.ownerDocument.body:t.body:R(e)&&H(e)?e:Et(e)}function W(t,e,n){var o;e===void 0&&(e=[]),n===void 0&&(n=!0);let i=Et(t),r=i===((o=t.ownerDocument)==null?void 0:o.body),s=b(i);return r?e.concat(s,s.visualViewport||[],H(i)?i:[],s.frameElement&&n?W(s.frameElement):[]):e.concat(i,W(i,[],n))}function Pt(t){let e=A(t),n=parseFloat(e.width)||0,o=parseFloat(e.height)||0,i=R(t),r=i?t.offsetWidth:n,s=i?t.offsetHeight:o,c=X(n)!==r||X(o)!==s;return c&&(n=r,o=s),{width:n,height:o,$:c}}function ut(t){return E(t)?t:t.contextElement}function z(t){let e=ut(t);if(!R(e))return T(1);let n=e.getBoundingClientRect(),{width:o,height:i,$:r}=Pt(e),s=(r?X(n.width):n.width)/o,c=(r?X(n.height):n.height)/i;return(!s||!Number.isFinite(s))&&(s=1),(!c||!Number.isFinite(c))&&(c=1),{x:s,y:c}}var $t=T(0);function Lt(t){let e=b(t);return!nt()||!e.visualViewport?$t:{x:e.visualViewport.offsetLeft,y:e.visualViewport.offsetTop}}function Xt(t,e,n){return e===void 0&&(e=!1),!n||e&&n!==b(t)?!1:e}function F(t,e,n,o){e===void 0&&(e=!1),n===void 0&&(n=!1);let i=t.getBoundingClientRect(),r=ut(t),s=T(1);e&&(o?E(o)&&(s=z(o)):s=z(t));let c=Xt(r,n,o)?Lt(r):T(0),l=(i.left+c.x)/s.x,f=(i.top+c.y)/s.y,m=i.width/s.x,u=i.height/s.y;if(r){let p=b(r),a=o&&E(o)?b(o):o,d=p.frameElement;for(;d&&o&&a!==p;){let h=z(d),w=d.getBoundingClientRect(),g=A(d),x=w.left+(d.clientLeft+parseFloat(g.paddingLeft))*h.x,y=w.top+(d.clientTop+parseFloat(g.paddingTop))*h.y;l*=h.x,f*=h.y,m*=h.x,u*=h.y,l+=x,f+=y,d=b(d).frameElement}}return _({width:m,height:u,x:l,y:f})}function Ut(t){let{rect:e,offsetParent:n,strategy:o}=t,i=R(n),r=C(n);if(n===r)return e;let s={scrollLeft:0,scrollTop:0},c=T(1),l=T(0);if((i||!i&&o!=="fixed")&&((P(n)!=="body"||H(r))&&(s=Q(n)),R(n))){let f=F(n);c=z(n),l.x=f.x+n.clientLeft,l.y=f.y+n.clientTop}return{width:e.width*c.x,height:e.height*c.y,x:e.x*c.x-s.scrollLeft*c.x+l.x,y:e.y*c.y-s.scrollTop*c.y+l.y}}function qt(t){return Array.from(t.getClientRects())}function Dt(t){return F(C(t)).left+Q(t).scrollLeft}function Jt(t){let e=C(t),n=Q(t),o=t.ownerDocument.body,i=S(e.scrollWidth,e.clientWidth,o.scrollWidth,o.clientWidth),r=S(e.scrollHeight,e.clientHeight,o.scrollHeight,o.clientHeight),s=-n.scrollLeft+Dt(t),c=-n.scrollTop;return A(o).direction==="rtl"&&(s+=S(e.clientWidth,o.clientWidth)-i),{width:i,height:r,x:s,y:c}}function Kt(t,e){let n=b(t),o=C(t),i=n.visualViewport,r=o.clientWidth,s=o.clientHeight,c=0,l=0;if(i){r=i.width,s=i.height;let f=nt();(!f||f&&e==="fixed")&&(c=i.offsetLeft,l=i.offsetTop)}return{width:r,height:s,x:c,y:l}}function Gt(t,e){let n=F(t,!0,e==="fixed"),o=n.top+t.clientTop,i=n.left+t.clientLeft,r=R(t)?z(t):T(1),s=t.clientWidth*r.x,c=t.clientHeight*r.y,l=i*r.x,f=o*r.y;return{width:s,height:c,x:l,y:f}}function St(t,e,n){let o;if(e==="viewport")o=Kt(t,n);else if(e==="document")o=Jt(C(t));else if(E(e))o=Gt(e,n);else{let i=Lt(t);o={...e,x:e.x-i.x,y:e.y-i.y}}return _(o)}function kt(t,e){let n=M(t);return n===e||!E(n)||G(n)?!1:A(n).position==="fixed"||kt(n,e)}function Qt(t,e){let n=e.get(t);if(n)return n;let o=W(t,[],!1).filter(c=>E(c)&&P(c)!=="body"),i=null,r=A(t).position==="fixed",s=r?M(t):t;for(;E(s)&&!G(s);){let c=A(s),l=et(s);!l&&c.position==="fixed"&&(i=null),(r?!l&&!i:!l&&c.position==="static"&&!!i&&["absolute","fixed"].includes(i.position)||H(s)&&!l&&kt(t,s))?o=o.filter(m=>m!==s):i=c,s=M(s)}return e.set(t,o),o}function Zt(t){let{element:e,boundary:n,rootBoundary:o,strategy:i}=t,s=[...n==="clippingAncestors"?Qt(e,this._c):[].concat(n),o],c=s[0],l=s.reduce((f,m)=>{let u=St(e,m,i);return f.top=S(u.top,f.top),f.right=V(u.right,f.right),f.bottom=V(u.bottom,f.bottom),f.left=S(u.left,f.left),f},St(e,c,i));return{width:l.right-l.left,height:l.bottom-l.top,x:l.left,y:l.top}}function te(t){return Pt(t)}function ee(t,e,n){let o=R(e),i=C(e),r=n==="fixed",s=F(t,!0,r,e),c={scrollLeft:0,scrollTop:0},l=T(0);if(o||!o&&!r)if((P(e)!=="body"||H(i))&&(c=Q(e)),o){let f=F(e,!0,r,e);l.x=f.x+e.clientLeft,l.y=f.y+e.clientTop}else i&&(l.x=Dt(i));return{x:s.left+c.scrollLeft-l.x,y:s.top+c.scrollTop-l.y,width:s.width,height:s.height}}function Tt(t,e){return!R(t)||A(t).position==="fixed"?null:e?e(t):t.offsetParent}function _t(t,e){let n=b(t);if(!R(t))return n;let o=Tt(t,e);for(;o&&Rt(o)&&A(o).position==="static";)o=Tt(o,e);return o&&(P(o)==="html"||P(o)==="body"&&A(o).position==="static"&&!et(o))?n:o||Ct(t)||n}var ne=async function(t){let{reference:e,floating:n,strategy:o}=t,i=this.getOffsetParent||_t,r=this.getDimensions;return{reference:ee(e,await i(n),o),floating:{x:0,y:0,...await r(n)}}};function oe(t){return A(t).direction==="rtl"}var ie={convertOffsetParentRelativeRectToViewportRelativeRect:Ut,getDocumentElement:C,getClippingRect:Zt,getOffsetParent:_t,getElementRects:ne,getClientRects:qt,getDimensions:te,getScale:z,isElement:E,isRTL:oe};function se(t,e){let n=null,o,i=C(t);function r(){clearTimeout(o),n&&n.disconnect(),n=null}function s(c,l){c===void 0&&(c=!1),l===void 0&&(l=1),r();let{left:f,top:m,width:u,height:p}=t.getBoundingClientRect();if(c||e(),!u||!p)return;let a=U(m),d=U(i.clientWidth-(f+u)),h=U(i.clientHeight-(m+p)),w=U(f),x={rootMargin:-a+"px "+-d+"px "+-h+"px "+-w+"px",threshold:S(0,V(1,l))||1},y=!0;function O(v){let D=v[0].intersectionRatio;if(D!==l){if(!y)return s();D?s(!1,D):o=setTimeout(()=>{s(!1,1e-7)},100)}y=!1}try{n=new IntersectionObserver(O,{...x,root:i.ownerDocument})}catch{n=new IntersectionObserver(O,x)}n.observe(t)}return s(!0),r}function Mt(t,e,n,o){o===void 0&&(o={});let{ancestorScroll:i=!0,ancestorResize:r=!0,elementResize:s=typeof ResizeObserver=="function",layoutShift:c=typeof IntersectionObserver=="function",animationFrame:l=!1}=o,f=ut(t),m=i||r?[...f?W(f):[],...W(e)]:[];m.forEach(g=>{i&&g.addEventListener("scroll",n,{passive:!0}),r&&g.addEventListener("resize",n)});let u=f&&c?se(f,n):null,p=-1,a=null;s&&(a=new ResizeObserver(g=>{let[x]=g;x&&x.target===f&&a&&(a.unobserve(e),cancelAnimationFrame(p),p=requestAnimationFrame(()=>{a&&a.observe(e)})),n()}),f&&!l&&a.observe(f),a.observe(e));let d,h=l?F(t):null;l&&w();function w(){let g=F(t);h&&(g.x!==h.x||g.y!==h.y||g.width!==h.width||g.height!==h.height)&&n(),h=g,d=requestAnimationFrame(w)}return n(),()=>{m.forEach(g=>{i&&g.removeEventListener("scroll",n),r&&g.removeEventListener("resize",n)}),u&&u(),a&&a.disconnect(),a=null,l&&cancelAnimationFrame(d)}}var Ft=(t,e,n)=>{let o=new Map,i={platform:ie,...n},r={...i.platform,_c:o};return bt(t,e,{...i,platform:r})};function Vt(t){t.magic("anchor",e=>{if(!e._x_anchor)throw"Alpine: No x-anchor directive found on element using $anchor...";return e._x_anchor}),t.interceptClone((e,n)=>{e&&e._x_anchor&&!n._x_anchor&&(n._x_anchor=e._x_anchor)}),t.directive("anchor",t.skipDuringClone((e,{expression:n,modifiers:o,value:i},{evaluate:r,effect:s,cleanup:c})=>{let{placement:l,offsetValue:f,unstyled:m,strategy:u,allowFlip:p}=Bt(o);e._x_anchor=t.reactive({x:0,y:0});let a=null,d=null;s(()=>{let h=r(n);if(h&&a!==h){d&&d(),a=h;let w=()=>{let g;Ft(h,e,{placement:l,strategy:u,middleware:[p&&lt(),at({padding:5}),ft(f)]}).then(({x,y})=>{m||Nt(e,x,y,u),JSON.stringify({x,y})!==g&&(e._x_anchor.x=x,e._x_anchor.y=y),g=JSON.stringify({x,y})})};d=Mt(h,e,()=>w())}}),c(()=>{d&&d()})},(e,{expression:n,modifiers:o,value:i},{cleanup:r,evaluate:s})=>{let{placement:c,offsetValue:l,unstyled:f,strategy:m}=Bt(o);e._x_anchor&&(f||Nt(e,e._x_anchor.x,e._x_anchor.y,m))}))}function Nt(t,e,n,o="absolute"){Object.assign(t.style,{left:e+"px",top:n+"px",position:o})}function Bt(t){let n=["top","top-start","top-end","right","right-start","right-end","bottom","bottom-start","bottom-end","left","left-start","left-end"].find(c=>t.includes(c)),o=0;if(t.includes("offset")){let c=t.findIndex(l=>l==="offset");o=t[c+1]!==void 0?Number(t[c+1]):o}let i=t.includes("no-style"),r=!t.includes("noflip"),s=t.includes("fixed")?"fixed":"absolute";return{placement:n,offsetValue:o,unstyled:i,strategy:s,allowFlip:r}}document.addEventListener("alpine:init",()=>{window.Alpine.plugin(Vt)});})();
;

/* ---- js/vendor/alpine-persist.min.js ---- */
(()=>{function p(t){let a=()=>{let r,n;try{n=localStorage}catch(i){console.error(i),console.warn("Alpine: $persist is using temporary storage since localStorage is unavailable.");let e=new Map;n={getItem:e.get.bind(e),setItem:e.set.bind(e)}}return t.interceptor((i,e,l,s,v,d)=>{let o=r||`_x_${s}`,u=g(o,n)?f(o,n):i;l(u);let S=t.effect(()=>{let c=e();m(o,c,n),l(c)});return d(()=>t.release(S)),u},i=>{i.as=e=>(r=e,i),i.using=e=>(n=e,i)})};Object.defineProperty(t,"$persist",{get:()=>a()}),t.magic("persist",a),t.persist=(r,{get:n,set:i},e=localStorage)=>{let l=g(r,e)?f(r,e):n();i(l),t.effect(()=>{let s=n();m(r,s,e),i(s)})}}function g(t,a){return a.getItem(t)!==null}function f(t,a){let r=a.getItem(t);if(r!==void 0)return JSON.parse(r)}function m(t,a,r){r.setItem(t,JSON.stringify(a))}document.addEventListener("alpine:init",()=>{window.Alpine.plugin(p)});})();
;

/* ---- js/vendor/alpine.min.js ---- */
(()=>{var re=!1,ne=!1,G=[],ie=-1,oe=!1;function qe(t){In(t)}function Ke(){oe=!0}function We(){oe=!1,Je()}function In(t){G.includes(t)||G.push(t),Je()}function Ge(t){let e=G.indexOf(t);e!==-1&&e>ie&&G.splice(e,1)}function Je(){if(!ne&&!re){if(oe)return;re=!0,queueMicrotask(kn)}}function kn(){re=!1,ne=!0;for(let t=0;t<G.length;t++)G[t](),ie=t;G.length=0,ie=-1,ne=!1}var C,M,L,ae,se=!0;function Ye(t){se=!1,t(),se=!0}function Xe(t){C=t.reactive,L=t.release,M=e=>t.effect(e,{scheduler:r=>{se?qe(r):r()}}),ae=t.raw}function ce(t){M=t}function Ze(t){let e=()=>{};return[n=>{let i=M(n);return t._x_effects||(t._x_effects=new Set,t._x_runEffects=()=>{t._x_effects.forEach(o=>o())}),t._x_effects.add(i),e=()=>{i!==void 0&&(t._x_effects.delete(i),L(i))},i},()=>{e()}]}function vt(t,e){let r=!0,n,i,o=M(()=>{let s=t(),a=JSON.stringify(s);if(!r&&(typeof s=="object"||s!==n)){let c=typeof n=="object"?JSON.parse(i):n;queueMicrotask(()=>{e(s,c)})}n=s,i=a,r=!1});return()=>L(o)}async function Qe(t){Ke();try{await t(),await Promise.resolve()}finally{We()}}var tr=[],er=[],rr=[];function nr(t){rr.push(t)}function rt(t,e){typeof e=="function"?(t._x_cleanups||(t._x_cleanups=[]),t._x_cleanups.push(e)):(e=t,er.push(e))}function Ot(t){tr.push(t)}function Ct(t,e,r){t._x_attributeCleanups||(t._x_attributeCleanups={}),t._x_attributeCleanups[e]||(t._x_attributeCleanups[e]=[]),t._x_attributeCleanups[e].push(r)}function le(t,e){t._x_attributeCleanups&&Object.entries(t._x_attributeCleanups).forEach(([r,n])=>{(e===void 0||e.includes(r))&&(n.forEach(i=>i()),delete t._x_attributeCleanups[r])})}function ir(t){for(t._x_effects?.forEach(Ge);t._x_cleanups?.length;)t._x_cleanups.pop()()}var ue=new MutationObserver(me),fe=!1;function ft(){ue.observe(document,{subtree:!0,childList:!0,attributes:!0,attributeOldValue:!0}),fe=!0}function de(){jn(),ue.disconnect(),fe=!1}var ut=[];function jn(){let t=ue.takeRecords();ut.push(()=>t.length>0&&me(t));let e=ut.length;queueMicrotask(()=>{if(ut.length===e)for(;ut.length>0;)ut.shift()()})}function m(t){if(!fe)return t();de();let e=t();return ft(),e}var pe=!1,At=[];function or(){pe=!0}function sr(){pe=!1,me(At),At=[]}function me(t){if(pe){At=At.concat(t);return}let e=[],r=new Set,n=new Map,i=new Map;for(let o=0;o<t.length;o++)if(!t[o].target._x_ignoreMutationObserver&&(t[o].type==="childList"&&(t[o].removedNodes.forEach(s=>{s.nodeType===1&&s._x_marker&&r.add(s)}),t[o].addedNodes.forEach(s=>{if(s.nodeType===1){if(r.has(s)){r.delete(s);return}s._x_marker||e.push(s)}})),t[o].type==="attributes")){let s=t[o].target,a=t[o].attributeName,c=t[o].oldValue,l=()=>{n.has(s)||n.set(s,[]),n.get(s).push({name:a,value:s.getAttribute(a)})},u=()=>{i.has(s)||i.set(s,[]),i.get(s).push(a)};s.hasAttribute(a)&&c===null?l():s.hasAttribute(a)?(u(),l()):u()}i.forEach((o,s)=>{le(s,o)}),n.forEach((o,s)=>{tr.forEach(a=>a(s,o))});for(let o of r)e.some(s=>s.contains(o))||er.forEach(s=>s(o));for(let o of e)o.isConnected&&rr.forEach(s=>s(o));e=null,r=null,n=null,i=null}function Tt(t){return P(F(t))}function N(t,e,r){return t._x_dataStack=[e,...F(r||t)],()=>{t._x_dataStack=t._x_dataStack.filter(n=>n!==e)}}function F(t){return t._x_dataStack?t._x_dataStack:typeof ShadowRoot=="function"&&t instanceof ShadowRoot?F(t.host):t.parentNode?F(t.parentNode):[]}function P(t){return new Proxy({objects:t},$n)}function ar(t,e){return t===null||t===Object.prototype?null:Object.prototype.hasOwnProperty.call(t,e)?t:ar(Object.getPrototypeOf(t),e)}var $n={ownKeys({objects:t}){return Array.from(new Set(t.flatMap(e=>Object.keys(e))))},has({objects:t},e){return e==Symbol.unscopables?!1:t.some(r=>Object.prototype.hasOwnProperty.call(r,e)||Reflect.has(r,e))},get({objects:t},e,r){return e=="toJSON"?Ln:Reflect.get(t.find(n=>Reflect.has(n,e))||{},e,r)},set({objects:t},e,r,n){let i;for(let s of t)if(i=ar(s,e),i)break;i||(i=t[t.length-1]);let o=Object.getOwnPropertyDescriptor(i,e);return o?.set&&o?.get?o.set.call(n,r)||!0:Reflect.set(i,e,r)}};function Ln(){return Reflect.ownKeys(this).reduce((e,r)=>(e[r]=Reflect.get(this,r),e),{})}function nt(t,e=()=>{}){let r=i=>typeof i=="object"&&!Array.isArray(i)&&i!==null,n=(i,o="")=>{Object.entries(Object.getOwnPropertyDescriptors(i)).forEach(([s,{value:a,enumerable:c}])=>{if(c===!1||a===void 0||typeof a=="object"&&a!==null&&a.__v_skip)return;let l=o===""?s:`${o}.${s}`;typeof a=="object"&&a!==null&&a._x_interceptor?i[s]=a.initialize(t,l,s,e):r(a)&&a!==i&&!(a instanceof Element)&&n(a,l)})};return n(t)}function Rt(t,e=()=>{}){let r={initialValue:void 0,_x_interceptor:!0,initialize(n,i,o,s){return t(this.initialValue,()=>Fn(n,i),a=>he(n,i,a),i,o,s)}};return e(r),n=>{if(typeof n=="object"&&n!==null&&n._x_interceptor){let i=r.initialize.bind(r);r.initialize=(o,s,a,c)=>{let l=n.initialize(o,s,a,c);return r.initialValue=l,i(o,s,a,c)}}else r.initialValue=n;return r}}function Fn(t,e){return e.split(".").reduce((r,n)=>r[n],t)}function he(t,e,r){if(typeof e=="string"&&(e=e.split(".")),e.length===1)t[e[0]]=r;else{if(e.length===0)throw error;return t[e[0]]||(t[e[0]]={}),he(t[e[0]],e.slice(1),r)}}var cr={};function x(t,e){cr[t]=e}function V(t,e){let r=Bn(e);return Object.entries(cr).forEach(([n,i])=>{Object.defineProperty(t,`$${n}`,{get(){return i(e,r)},enumerable:!1})}),t}function Bn(t){let[e,r]=_e(t),n={interceptor:Rt,...e};return rt(t,r),n}function lr(t,e,r,...n){try{return r(...n)}catch(i){it(i,t,e)}}function it(...t){return ur(...t)}var ur=zn;function fr(t){ur=t}function zn(t,e,r=void 0){t=Object.assign(t??{message:"No error message given."},{el:e,expression:r}),console.warn(`Alpine Expression Error: ${t.message}

${r?'Expression: "'+r+`"

`:""}`,e),setTimeout(()=>{throw t},0)}var ot=!0;function Mt(t){let e=ot;ot=!1;let r=t();return ot=e,r}function T(t,e,r={}){let n;return _(t,e)(i=>n=i,r),n}function _(...t){return dr(...t)}var dr=()=>{};function pr(t){dr=t}var mr;function hr(t){mr=t}function _r(t,e){let r={};V(r,t);let n=[r,...F(t)],i=typeof e=="function"?Hn(n,e):Un(n,e,t);return lr.bind(null,t,e,i)}function Hn(t,e){return(r=()=>{},{scope:n={},params:i=[],context:o}={})=>{if(!ot){dt(r,e,P([n,...t]),i);return}let s=e.apply(P([n,...t]),i);dt(r,s)}}var ge={};function Vn(t,e){if(ge[t])return ge[t];let r=Object.getPrototypeOf(async function(){}).constructor,n=/^[\n\s]*if.*\(.*\)/.test(t.trim())||/^(let|const)\s/.test(t.trim())?`(async()=>{ ${t} })()`:t,o=(()=>{try{let s=new r(["__self","scope"],`with (scope) { __self.result = ${n} }; __self.finished = true; return __self.result;`);return Object.defineProperty(s,"name",{value:`[Alpine] ${t}`}),s}catch(s){return it(s,e,t),Promise.resolve()}})();return ge[t]=o,o}function Un(t,e,r){let n=Vn(e,r);return(i=()=>{},{scope:o={},params:s=[],context:a}={})=>{n.result=void 0,n.finished=!1;let c=P([o,...t]);if(typeof n=="function"){let l=n.call(a,n,c).catch(u=>it(u,r,e));n.finished?(dt(i,n.result,c,s,r),n.result=void 0):l.then(u=>{dt(i,u,c,s,r)}).catch(u=>it(u,r,e)).finally(()=>n.result=void 0)}}}function dt(t,e,r,n,i){if(ot&&typeof e=="function"){let o=e.apply(r,n);o instanceof Promise?o.then(s=>dt(t,s,r,n)).catch(s=>it(s,i,e)):t(o)}else typeof e=="object"&&e instanceof Promise?e.then(o=>t(o)):t(e)}function gr(...t){return mr(...t)}function xr(t,e,r={}){let n={};V(n,t);let i=[n,...F(t)],o=P([r.scope??{},...i]),s=r.params??[];if(e.includes("await")){let a=Object.getPrototypeOf(async function(){}).constructor,c=/^[\n\s]*if.*\(.*\)/.test(e.trim())||/^(let|const)\s/.test(e.trim())?`(async()=>{ ${e} })()`:e;return new a(["scope"],`with (scope) { let __result = ${c}; return __result }`).call(r.context,o)}else{let a=/^[\n\s]*if.*\(.*\)/.test(e.trim())||/^(let|const)\s/.test(e.trim())?`(()=>{ ${e} })()`:e,l=new Function(["scope"],`with (scope) { let __result = ${a}; return __result }`).call(r.context,o);return typeof l=="function"&&ot?l.apply(o,s):l}}var be="x-";function O(t=""){return be+t}function yr(t){be=t}var Nt={};function p(t,e){return Nt[t]=e,{before(r){if(!Nt[r]){console.warn(String.raw`Cannot find directive \`${r}\`. \`${t}\` will use the default order of execution`);return}let n=J.indexOf(r);J.splice(n>=0?n:J.indexOf("DEFAULT"),0,t)}}}function br(t){return Object.keys(Nt).includes(t)}function mt(t,e,r){if(e=Array.from(e),t._x_virtualDirectives){let o=Object.entries(t._x_virtualDirectives).map(([a,c])=>({name:a,value:c})),s=we(o);o=o.map(a=>s.find(c=>c.name===a.name)?{name:`x-bind:${a.name}`,value:`"${a.value}"`}:a),e=e.concat(o)}let n={};return e.map(Sr((o,s)=>n[o]=s)).filter(Ar).map(Kn(n,r)).sort(Wn).map(o=>qn(t,o))}function we(t){return Array.from(t).map(Sr()).filter(e=>!Ar(e))}var xe=!1,pt=new Map,wr=Symbol();function Er(t){xe=!0;let e=Symbol();wr=e,pt.set(e,[]);let r=()=>{for(;pt.get(e).length;)pt.get(e).shift()();pt.delete(e)},n=()=>{xe=!1,r()};t(r),n()}function _e(t){let e=[],r=a=>e.push(a),[n,i]=Ze(t);return e.push(i),[{Alpine:B,effect:n,cleanup:r,evaluateLater:_.bind(_,t),evaluate:T.bind(T,t)},()=>e.forEach(a=>a())]}function qn(t,e){let r=()=>{},n=Nt[e.type]||r,[i,o]=_e(t);Ct(t,e.original,o);let s=()=>{t._x_ignore||t._x_ignoreSelf||(n.inline&&n.inline(t,e,i),n=n.bind(n,t,e,i),xe?pt.get(wr).push(n):n())};return s.runCleanups=o,s}var Pt=(t,e)=>({name:r,value:n})=>(r.startsWith(t)&&(r=r.replace(t,e)),{name:r,value:n}),Dt=t=>t;function Sr(t=()=>{}){return({name:e,value:r})=>{let{name:n,value:i}=vr.reduce((o,s)=>s(o),{name:e,value:r});return n!==e&&t(n,e),{name:n,value:i}}}var vr=[];function st(t){vr.push(t)}function Ar({name:t}){return Or().test(t)}var Or=()=>new RegExp(`^${be}([^:^.]+)\\b`);function Kn(t,e){return({name:r,value:n})=>{r===n&&(n="");let i=r.match(Or()),o=r.match(/:([a-zA-Z0-9\-_:]+)/),s=r.match(/\.[^.\]]+(?=[^\]]*$)/g)||[],a=e||t[r]||r;return{type:i?i[1]:null,value:o?o[1]:null,modifiers:s.map(c=>c.replace(".","")),expression:n,original:a}}}var ye="DEFAULT",J=["ignore","ref","id","data","anchor","bind","init","for","model","modelable","transition","show","if",ye,"teleport"];function Wn(t,e){let r=J.indexOf(t.type)===-1?ye:t.type,n=J.indexOf(e.type)===-1?ye:e.type;return J.indexOf(r)-J.indexOf(n)}function Y(t,e,r={},n={}){return t.dispatchEvent(new CustomEvent(e,{detail:r,bubbles:!0,composed:!0,cancelable:!0,...n}))}function D(t,e){if(typeof ShadowRoot=="function"&&t instanceof ShadowRoot){Array.from(t.children).forEach(i=>D(i,e));return}let r=!1;if(e(t,()=>r=!0),r)return;let n=t.firstElementChild;for(;n;)D(n,e,!1),n=n.nextElementSibling}function E(t,...e){console.warn(`Alpine Warning: ${t}`,...e)}var Cr=!1;function Tr(){Cr&&E("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems."),Cr=!0,document.body||E("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?"),Y(document,"alpine:init"),Y(document,"alpine:initializing"),ft(),nr(e=>S(e,D)),rt(e=>I(e)),Ot((e,r)=>{mt(e,r).forEach(n=>n())});let t=e=>!X(e.parentElement,!0);Array.from(document.querySelectorAll(Nr().join(","))).filter(t).forEach(e=>{S(e)}),Y(document,"alpine:initialized"),setTimeout(()=>{Jn()})}var Ee=[],Rr=[];function Mr(){return Ee.map(t=>t())}function Nr(){return Ee.concat(Rr).map(t=>t())}function It(t){Ee.push(t)}function kt(t){Rr.push(t)}function X(t,e=!1){return A(t,r=>{if((e?Nr():Mr()).some(i=>r.matches(i)))return!0})}function A(t,e){if(t){if(e(t))return t;if(t._x_teleportBack)return A(t._x_teleportBack,e);if(t.parentNode instanceof ShadowRoot)return A(t.parentNode.host,e);if(t.parentElement)return A(t.parentElement,e)}}function Pr(t){return Mr().some(e=>t.matches(e))}var Dr=[];function Ir(t){Dr.push(t)}var Gn=1;function S(t,e=D,r=()=>{}){A(t,n=>n._x_ignore)||Er(()=>{e(t,(n,i)=>{n._x_marker||(r(n,i),Dr.forEach(o=>o(n,i)),mt(n,n.attributes).forEach(o=>o()),n._x_ignore||(n._x_marker=Gn++),n._x_ignore&&i())})})}function I(t,e=D){e(t,r=>{ir(r),le(r),delete r._x_marker})}function Jn(){[["ui","dialog",["[x-dialog], [x-popover]"]],["anchor","anchor",["[x-anchor]"]],["sort","sort",["[x-sort]"]]].forEach(([e,r,n])=>{br(r)||n.some(i=>{if(document.querySelector(i))return E(`found "${i}", but missing ${e} plugin`),!0})})}var Se=[],ve=!1;function at(t=()=>{}){return queueMicrotask(()=>{ve||setTimeout(()=>{jt()})}),new Promise(e=>{Se.push(()=>{t(),e()})})}function jt(){for(ve=!1;Se.length;)Se.shift()()}function kr(){ve=!0}function ht(t,e){return Array.isArray(e)?jr(t,e.join(" ")):typeof e=="object"&&e!==null?Yn(t,e):typeof e=="function"?ht(t,e()):jr(t,e)}function Ae(t){return t.split(/\s/).filter(Boolean)}function jr(t,e){let r=i=>Ae(i).filter(o=>!t.classList.contains(o)).filter(Boolean),n=i=>(t.classList.add(...i),()=>{t.classList.remove(...i)});return e=e===!0?e="":e||"",n(r(e))}function Yn(t,e){let r=Object.entries(e).flatMap(([s,a])=>a?Ae(s):!1).filter(Boolean),n=Object.entries(e).flatMap(([s,a])=>a?!1:Ae(s)).filter(Boolean),i=[],o=[];return n.forEach(s=>{t.classList.contains(s)&&(t.classList.remove(s),o.push(s))}),r.forEach(s=>{t.classList.contains(s)||(t.classList.add(s),i.push(s))}),()=>{o.forEach(s=>t.classList.add(s)),i.forEach(s=>t.classList.remove(s))}}function Z(t,e){return typeof e=="object"&&e!==null?Xn(t,e):Zn(t,e)}function Xn(t,e){let r={};return Object.entries(e).forEach(([n,i])=>{r[n]=t.style[n],n.startsWith("--")||(n=Qn(n)),t.style.setProperty(n,i)}),setTimeout(()=>{t.style.length===0&&t.removeAttribute("style")}),()=>{Z(t,r)}}function Zn(t,e){let r=t.getAttribute("style",e);return t.setAttribute("style",e),()=>{t.setAttribute("style",r||"")}}function Qn(t){return t.replace(/([a-z])([A-Z])/g,"$1-$2").toLowerCase()}function _t(t,e=()=>{}){let r=!1;return function(){r?e.apply(this,arguments):(r=!0,t.apply(this,arguments))}}p("transition",(t,{value:e,modifiers:r,expression:n},{evaluate:i})=>{typeof n=="function"&&(n=i(n)),n!==!1&&(!n||typeof n=="boolean"?ei(t,r,e):ti(t,n,e))});function ti(t,e,r){$r(t,ht,""),{enter:i=>{t._x_transition.enter.during=i},"enter-start":i=>{t._x_transition.enter.start=i},"enter-end":i=>{t._x_transition.enter.end=i},leave:i=>{t._x_transition.leave.during=i},"leave-start":i=>{t._x_transition.leave.start=i},"leave-end":i=>{t._x_transition.leave.end=i}}[r](e)}function ei(t,e,r){$r(t,Z);let n=!e.includes("in")&&!e.includes("out")&&!r,i=n||e.includes("in")||["enter"].includes(r),o=n||e.includes("out")||["leave"].includes(r);e.includes("in")&&!n&&(e=e.filter((w,et)=>et<e.indexOf("out"))),e.includes("out")&&!n&&(e=e.filter((w,et)=>et>e.indexOf("out")));let s=!e.includes("opacity")&&!e.includes("scale"),a=s||e.includes("opacity"),c=s||e.includes("scale"),l=a?0:1,u=c?gt(e,"scale",95)/100:1,d=gt(e,"delay",0)/1e3,b=gt(e,"origin","center"),g="opacity, transform",$=gt(e,"duration",150)/1e3,f=gt(e,"duration",75)/1e3,y="cubic-bezier(0.4, 0.0, 0.2, 1)";i&&(t._x_transition.enter.during={transformOrigin:b,transitionDelay:`${d}s`,transitionProperty:g,transitionDuration:`${$}s`,transitionTimingFunction:y},t._x_transition.enter.start={opacity:l,transform:`scale(${u})`},t._x_transition.enter.end={opacity:1,transform:"scale(1)"}),o&&(t._x_transition.leave.during={transformOrigin:b,transitionDelay:`${d}s`,transitionProperty:g,transitionDuration:`${f}s`,transitionTimingFunction:y},t._x_transition.leave.start={opacity:1,transform:"scale(1)"},t._x_transition.leave.end={opacity:l,transform:`scale(${u})`})}function $r(t,e,r={}){t._x_transition||(t._x_transition={enter:{during:r,start:r,end:r},leave:{during:r,start:r,end:r},in(n=()=>{},i=()=>{}){$t(t,e,{during:this.enter.during,start:this.enter.start,end:this.enter.end},n,i)},out(n=()=>{},i=()=>{}){$t(t,e,{during:this.leave.during,start:this.leave.start,end:this.leave.end},n,i)}})}window.Element.prototype._x_toggleAndCascadeWithTransitions=function(t,e,r,n){let i=document.visibilityState==="visible"?requestAnimationFrame:setTimeout,o=()=>i(r);if(e){t._x_transition&&(t._x_transition.enter||t._x_transition.leave)?t._x_transition.enter&&(Object.entries(t._x_transition.enter.during).length||Object.entries(t._x_transition.enter.start).length||Object.entries(t._x_transition.enter.end).length)?t._x_transition.in(r):o():t._x_transition?t._x_transition.in(r):o();return}t._x_hidePromise=t._x_transition?new Promise((s,a)=>{t._x_transition.out(()=>{},()=>s(n)),t._x_transitioning&&t._x_transitioning.beforeCancel(()=>a({isFromCancelledTransition:!0}))}):Promise.resolve(n),queueMicrotask(()=>{let s=Lr(t);s?(s._x_hideChildren||(s._x_hideChildren=[]),s._x_hideChildren.push(t)):i(()=>{let a=c=>{let l=Promise.all([c._x_hidePromise,...(c._x_hideChildren||[]).map(a)]).then(([u])=>u?.());return delete c._x_hidePromise,delete c._x_hideChildren,l};a(t).catch(c=>{if(!c.isFromCancelledTransition)throw c})})})};function Lr(t){let e=t.parentNode;if(e)return e._x_hidePromise?e:Lr(e)}function $t(t,e,{during:r,start:n,end:i}={},o=()=>{},s=()=>{}){if(t._x_transitioning&&t._x_transitioning.cancel(),Object.keys(r).length===0&&Object.keys(n).length===0&&Object.keys(i).length===0){o(),s();return}let a,c,l;ri(t,{start(){a=e(t,n)},during(){c=e(t,r)},before:o,end(){a(),l=e(t,i)},after:s,cleanup(){c(),l()}})}function ri(t,e){let r,n,i,o=_t(()=>{m(()=>{r=!0,n||e.before(),i||(e.end(),jt()),e.after(),t.isConnected&&e.cleanup(),delete t._x_transitioning})});t._x_transitioning={beforeCancels:[],beforeCancel(s){this.beforeCancels.push(s)},cancel:_t(function(){for(;this.beforeCancels.length;)this.beforeCancels.shift()();o()}),finish:o},m(()=>{e.start(),e.during()}),kr(),requestAnimationFrame(()=>{if(r)return;let s=Number(getComputedStyle(t).transitionDuration.replace(/,.*/,"").replace("s",""))*1e3,a=Number(getComputedStyle(t).transitionDelay.replace(/,.*/,"").replace("s",""))*1e3;s===0&&(s=Number(getComputedStyle(t).animationDuration.replace("s",""))*1e3),m(()=>{e.before()}),n=!0,requestAnimationFrame(()=>{r||(m(()=>{e.end()}),jt(),setTimeout(t._x_transitioning.finish,s+a),i=!0)})})}function gt(t,e,r){if(t.indexOf(e)===-1)return r;let n=t[t.indexOf(e)+1];if(!n||e==="scale"&&isNaN(n))return r;if(e==="duration"||e==="delay"){let i=n.match(/([0-9]+)ms/);if(i)return i[1]}return e==="origin"&&["top","right","left","center","bottom"].includes(t[t.indexOf(e)+2])?[n,t[t.indexOf(e)+2]].join(" "):n}var k=!1;function v(t,e=()=>{}){return(...r)=>k?e(...r):t(...r)}function Fr(t){return(...e)=>k&&t(...e)}var Br=[];function U(t){Br.push(t)}function zr(t,e){Br.forEach(r=>r(t,e)),k=!0,Vr(()=>{S(e,(r,n)=>{n(r,()=>{})})}),k=!1}var Lt=!1;function Hr(t,e){e._x_dataStack||(e._x_dataStack=t._x_dataStack),k=!0,Lt=!0,Vr(()=>{ni(e)}),k=!1,Lt=!1}function ni(t){let e=!1;S(t,(n,i)=>{D(n,(o,s)=>{if(e&&Pr(o))return s();e=!0,i(o,s)})})}function Vr(t){let e=M;ce((r,n)=>{let i=e(r);return L(i),()=>{}}),t(),ce(e)}function xt(t,e,r,n=[]){switch(t._x_bindings||(t._x_bindings=C({})),t._x_bindings[e]=r,e=n.includes("camel")?fi(e):e,e){case"value":ii(t,r);break;case"style":si(t,r);break;case"class":oi(t,r);break;case"selected":case"checked":ai(t,e,r);break;default:Oe(t,e,r);break}}function ii(t,e){if(Ft(t))t.attributes.value===void 0&&(t.value=e);else if(bt(t))Number.isInteger(e)?t.value=e:!Array.isArray(e)&&typeof e!="boolean"&&![null,void 0].includes(e)?t.value=String(e):Array.isArray(e)?t.checked=e.some(r=>di(r,t.value)):t.checked=!!e;else if(t.tagName==="SELECT")ui(t,e);else if(t.tagName==="OPTION")Oe(t,"value",e);else{if(t.value===e&&(typeof e!="object"||e===null))return;t.value=e===void 0?"":e}}function oi(t,e){t._x_undoAddedClasses&&t._x_undoAddedClasses(),t._x_undoAddedClasses=ht(t,e)}function si(t,e){t._x_undoAddedStyles&&t._x_undoAddedStyles(),t._x_undoAddedStyles=Z(t,e)}function ai(t,e,r){Oe(t,e,r),li(t,e,r)}function Oe(t,e,r){[null,void 0,!1].includes(r)&&mi(e)?t.removeAttribute(e):(Ur(e)&&(r=e),hi(r)&&(r=JSON.stringify(r)),ci(t,e,r))}function ci(t,e,r){t.getAttribute(e)!=r&&t.setAttribute(e,r)}function li(t,e,r){t[e]!==r&&(t[e]=r)}function ui(t,e){let r=[].concat(e).map(n=>n+"");Array.from(t.options).forEach(n=>{n.selected=r.includes(n.value)})}function fi(t){return t.toLowerCase().replace(/-(\w)/g,(e,r)=>r.toUpperCase())}function di(t,e){return t==e}function yt(t){return[1,"1","true","on","yes",!0].includes(t)?!0:[0,"0","false","off","no",!1].includes(t)?!1:t?Boolean(t):null}var pi=new Set(["allowfullscreen","async","autofocus","autoplay","checked","controls","default","defer","disabled","formnovalidate","inert","ismap","itemscope","loop","multiple","muted","nomodule","novalidate","open","playsinline","readonly","required","reversed","selected","shadowrootclonable","shadowrootdelegatesfocus","shadowrootserializable"]);function Ur(t){return pi.has(t)}function mi(t){return!["aria-pressed","aria-checked","aria-expanded","aria-selected"].includes(t)}function hi(t){return typeof t=="object"&&t!==null}function qr(t,e,r){return t._x_bindings&&t._x_bindings[e]!==void 0?t._x_bindings[e]:Wr(t,e,r)}function Kr(t,e,r,n=!0){if(t._x_bindings&&t._x_bindings[e]!==void 0)return t._x_bindings[e];if(t._x_inlineBindings&&t._x_inlineBindings[e]!==void 0){let i=t._x_inlineBindings[e];return i.extract=n,Mt(()=>T(t,i.expression))}return Wr(t,e,r)}function Wr(t,e,r){let n=t.getAttribute(e);return n===null?typeof r=="function"?r():r:n===""?!0:Ur(e)?!![e,"true"].includes(n):n}function bt(t){return t.type==="checkbox"||t.localName==="ui-checkbox"||t.localName==="ui-switch"}function Ft(t){return t.type==="radio"||t.localName==="ui-radio"}function Bt(t,e){let r;return function(){let n=this,i=arguments,o=function(){r=null,t.apply(n,i)};clearTimeout(r),r=setTimeout(o,e)}}function zt(t,e){let r;return function(){let n=this,i=arguments;r||(t.apply(n,i),r=!0,setTimeout(()=>r=!1,e))}}function Ht({get:t,set:e},{get:r,set:n}){let i=!0,o,s,a=M(()=>{let c=t(),l=r();if(i)n(Ce(c)),i=!1;else{let u=JSON.stringify(c),d=JSON.stringify(l);u!==o?n(Ce(c)):u!==d&&e(Ce(l))}o=JSON.stringify(t()),s=JSON.stringify(r())});return()=>{L(a)}}function Ce(t){return typeof t=="object"?JSON.parse(JSON.stringify(t)):t}function Gr(t){(Array.isArray(t)?t:[t]).forEach(r=>r(B))}var z={},Jr=!1;function Yr(t,e){if(Jr||(z=C(z),Jr=!0),e===void 0)return z[t];z[t]=e,typeof e=="object"&&e!==null&&e._x_interceptor?z[t]=e.initialize(z,t,t,()=>{}):nt(z[t]),typeof e=="object"&&e!==null&&e.hasOwnProperty("init")&&typeof e.init=="function"&&z[t].init()}function Xr(){return z}var Zr={};function Qr(t,e){let r=typeof e!="function"?()=>e:e;return t instanceof Element?Te(t,r()):(Zr[t]=r,()=>{})}function tn(t){return Object.entries(Zr).forEach(([e,r])=>{Object.defineProperty(t,e,{get(){return(...n)=>r(...n)}})}),t}function Te(t,e,r){let n=[];for(;n.length;)n.pop()();let i=Object.entries(e).map(([s,a])=>({name:s,value:a})),o=we(i);return i=i.map(s=>o.find(a=>a.name===s.name)?{name:`x-bind:${s.name}`,value:`"${s.value}"`}:s),mt(t,i,r).map(s=>{n.push(s.runCleanups),s()}),()=>{for(;n.length;)n.pop()()}}var en={};function rn(t,e){en[t]=e}function nn(t,e){return Object.entries(en).forEach(([r,n])=>{Object.defineProperty(t,r,{get(){return(...i)=>n.bind(e)(...i)},enumerable:!1})}),t}var _i={get reactive(){return C},get release(){return L},get effect(){return M},get raw(){return ae},get transaction(){return Qe},version:"3.16.0",flushAndStopDeferringMutations:sr,dontAutoEvaluateFunctions:Mt,disableEffectScheduling:Ye,startObservingMutations:ft,stopObservingMutations:de,setReactivityEngine:Xe,onAttributeRemoved:Ct,onAttributesAdded:Ot,closestDataStack:F,skipDuringClone:v,onlyDuringClone:Fr,addRootSelector:It,addInitSelector:kt,setErrorHandler:fr,interceptClone:U,addScopeToNode:N,deferMutations:or,mapAttributes:st,evaluateLater:_,interceptInit:Ir,initInterceptors:nt,injectMagics:V,setEvaluator:pr,setRawEvaluator:hr,mergeProxies:P,extractProp:Kr,findClosest:A,onElRemoved:rt,closestRoot:X,destroyTree:I,interceptor:Rt,transition:$t,setStyles:Z,mutateDom:m,directive:p,entangle:Ht,throttle:zt,debounce:Bt,evaluate:T,evaluateRaw:gr,initTree:S,nextTick:at,prefixed:O,prefix:yr,plugin:Gr,magic:x,store:Yr,start:Tr,clone:Hr,cloneNode:zr,bound:qr,$data:Tt,watch:vt,walk:D,data:rn,bind:Qr},B=_i;function Re(t,e){let r=Object.create(null),n=t.split(",");for(let i=0;i<n.length;i++)r[n[i]]=!0;return e?i=>!!r[i.toLowerCase()]:i=>!!r[i]}var gi="itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly";var Gs=Re(gi+",async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected");var on=Object.freeze({}),Js=Object.freeze([]);var xi=Object.prototype.hasOwnProperty,wt=(t,e)=>xi.call(t,e),q=Array.isArray,ct=t=>sn(t)==="[object Map]";var yi=t=>typeof t=="string",Vt=t=>typeof t=="symbol",Et=t=>t!==null&&typeof t=="object";var bi=Object.prototype.toString,sn=t=>bi.call(t),Me=t=>sn(t).slice(8,-1);var Ut=t=>yi(t)&&t!=="NaN"&&t[0]!=="-"&&""+parseInt(t,10)===t;var qt=t=>{let e=Object.create(null);return r=>e[r]||(e[r]=t(r))},wi=/-(\w)/g,Ys=qt(t=>t.replace(wi,(e,r)=>r?r.toUpperCase():"")),Ei=/\B([A-Z])/g,Xs=qt(t=>t.replace(Ei,"-$1").toLowerCase()),Ne=qt(t=>t.charAt(0).toUpperCase()+t.slice(1)),Zs=qt(t=>t?`on${Ne(t)}`:""),Pe=(t,e)=>t!==e&&(t===t||e===e);var De=new WeakMap,St=[],j,Q=Symbol("iterate"),Ie=Symbol("Map key iterate");function Si(t){return t&&t._isEffect===!0}function dn(t,e=on){Si(t)&&(t=t.raw);let r=Ai(t,e);return e.lazy||r(),r}function pn(t){t.active&&(mn(t),t.options.onStop&&t.options.onStop(),t.active=!1)}var vi=0;function Ai(t,e){let r=function(){if(!r.active)return t();if(!St.includes(r)){mn(r);try{return Ci(),St.push(r),j=r,t()}finally{St.pop(),hn(),j=St[St.length-1]}}};return r.id=vi++,r.allowRecurse=!!e.allowRecurse,r._isEffect=!0,r.active=!0,r.raw=t,r.deps=[],r.options=e,r}function mn(t){let{deps:e}=t;if(e.length){for(let r=0;r<e.length;r++)e[r].delete(t);e.length=0}}var lt=!0,je=[];function Oi(){je.push(lt),lt=!1}function Ci(){je.push(lt),lt=!0}function hn(){let t=je.pop();lt=t===void 0?!0:t}function R(t,e,r){if(!lt||j===void 0)return;let n=De.get(t);n||De.set(t,n=new Map);let i=n.get(r);i||n.set(r,i=new Set),i.has(j)||(i.add(j),j.deps.push(i),j.options.onTrack&&j.options.onTrack({effect:j,target:t,type:e,key:r}))}function W(t,e,r,n,i,o){let s=De.get(t);if(!s)return;let a=new Set,c=u=>{u&&u.forEach(d=>{(d!==j||d.allowRecurse)&&a.add(d)})};if(e==="clear")s.forEach(c);else if(r==="length"&&q(t))s.forEach((u,d)=>{(d==="length"||d>=n)&&c(u)});else switch(r!==void 0&&c(s.get(r)),e){case"add":q(t)?Ut(r)&&c(s.get("length")):(c(s.get(Q)),ct(t)&&c(s.get(Ie)));break;case"delete":q(t)||(c(s.get(Q)),ct(t)&&c(s.get(Ie)));break;case"set":ct(t)&&c(s.get(Q));break}let l=u=>{u.options.onTrigger&&u.options.onTrigger({effect:u,target:t,key:r,type:e,newValue:n,oldValue:i,oldTarget:o}),u.options.scheduler?u.options.scheduler(u):u()};a.forEach(l)}var Ti=Re("__proto__,__v_isRef,__isVue"),_n=new Set(Object.getOwnPropertyNames(Symbol).map(t=>Symbol[t]).filter(Vt)),Ri=gn();var Mi=gn(!0);var an=Ni();function Ni(){let t={};return["includes","indexOf","lastIndexOf"].forEach(e=>{t[e]=function(...r){let n=h(this);for(let o=0,s=this.length;o<s;o++)R(n,"get",o+"");let i=n[e](...r);return i===-1||i===!1?n[e](...r.map(h)):i}}),["push","pop","shift","unshift","splice"].forEach(e=>{t[e]=function(...r){Oi();let n=h(this)[e].apply(this,r);return hn(),n}}),t}function gn(t=!1,e=!1){return function(n,i,o){if(i==="__v_isReactive")return!t;if(i==="__v_isReadonly")return t;if(i==="__v_raw"&&o===(t?e?Wi:wn:e?Ki:bn).get(n))return n;let s=q(n);if(!t&&s&&wt(an,i))return Reflect.get(an,i,o);let a=Reflect.get(n,i,o);return(Vt(i)?_n.has(i):Ti(i))||(t||R(n,"get",i),e)?a:ke(a)?!s||!Ut(i)?a.value:a:Et(a)?t?En(a):Zt(a):a}}var Pi=Di();function Di(t=!1){return function(r,n,i,o){let s=r[n];if(!t&&(i=h(i),s=h(s),!q(r)&&ke(s)&&!ke(i)))return s.value=i,!0;let a=q(r)&&Ut(n)?Number(n)<r.length:wt(r,n),c=Reflect.set(r,n,i,o);return r===h(o)&&(a?Pe(i,s)&&W(r,"set",n,i,s):W(r,"add",n,i)),c}}function Ii(t,e){let r=wt(t,e),n=t[e],i=Reflect.deleteProperty(t,e);return i&&r&&W(t,"delete",e,void 0,n),i}function ki(t,e){let r=Reflect.has(t,e);return(!Vt(e)||!_n.has(e))&&R(t,"has",e),r}function ji(t){return R(t,"iterate",q(t)?"length":Q),Reflect.ownKeys(t)}var $i={get:Ri,set:Pi,deleteProperty:Ii,has:ki,ownKeys:ji},Li={get:Mi,set(t,e){return console.warn(`Set operation on key "${String(e)}" failed: target is readonly.`,t),!0},deleteProperty(t,e){return console.warn(`Delete operation on key "${String(e)}" failed: target is readonly.`,t),!0}};var $e=t=>Et(t)?Zt(t):t,Le=t=>Et(t)?En(t):t,Fe=t=>t,Xt=t=>Reflect.getPrototypeOf(t);function Kt(t,e,r=!1,n=!1){t=t.__v_raw;let i=h(t),o=h(e);e!==o&&!r&&R(i,"get",e),!r&&R(i,"get",o);let{has:s}=Xt(i),a=n?Fe:r?Le:$e;if(s.call(i,e))return a(t.get(e));if(s.call(i,o))return a(t.get(o));t!==i&&t.get(e)}function Wt(t,e=!1){let r=this.__v_raw,n=h(r),i=h(t);return t!==i&&!e&&R(n,"has",t),!e&&R(n,"has",i),t===i?r.has(t):r.has(t)||r.has(i)}function Gt(t,e=!1){return t=t.__v_raw,!e&&R(h(t),"iterate",Q),Reflect.get(t,"size",t)}function cn(t){t=h(t);let e=h(this);return Xt(e).has.call(e,t)||(e.add(t),W(e,"add",t,t)),this}function ln(t,e){e=h(e);let r=h(this),{has:n,get:i}=Xt(r),o=n.call(r,t);o?yn(r,n,t):(t=h(t),o=n.call(r,t));let s=i.call(r,t);return r.set(t,e),o?Pe(e,s)&&W(r,"set",t,e,s):W(r,"add",t,e),this}function un(t){let e=h(this),{has:r,get:n}=Xt(e),i=r.call(e,t);i?yn(e,r,t):(t=h(t),i=r.call(e,t));let o=n?n.call(e,t):void 0,s=e.delete(t);return i&&W(e,"delete",t,void 0,o),s}function fn(){let t=h(this),e=t.size!==0,r=ct(t)?new Map(t):new Set(t),n=t.clear();return e&&W(t,"clear",void 0,void 0,r),n}function Jt(t,e){return function(n,i){let o=this,s=o.__v_raw,a=h(s),c=e?Fe:t?Le:$e;return!t&&R(a,"iterate",Q),s.forEach((l,u)=>n.call(i,c(l),c(u),o))}}function Yt(t,e,r){return function(...n){let i=this.__v_raw,o=h(i),s=ct(o),a=t==="entries"||t===Symbol.iterator&&s,c=t==="keys"&&s,l=i[t](...n),u=r?Fe:e?Le:$e;return!e&&R(o,"iterate",c?Ie:Q),{next(){let{value:d,done:b}=l.next();return b?{value:d,done:b}:{value:a?[u(d[0]),u(d[1])]:u(d),done:b}},[Symbol.iterator](){return this}}}}function K(t){return function(...e){{let r=e[0]?`on key "${e[0]}" `:"";console.warn(`${Ne(t)} operation ${r}failed: target is readonly.`,h(this))}return t==="delete"?!1:this}}function Fi(){let t={get(o){return Kt(this,o)},get size(){return Gt(this)},has:Wt,add:cn,set:ln,delete:un,clear:fn,forEach:Jt(!1,!1)},e={get(o){return Kt(this,o,!1,!0)},get size(){return Gt(this)},has:Wt,add:cn,set:ln,delete:un,clear:fn,forEach:Jt(!1,!0)},r={get(o){return Kt(this,o,!0)},get size(){return Gt(this,!0)},has(o){return Wt.call(this,o,!0)},add:K("add"),set:K("set"),delete:K("delete"),clear:K("clear"),forEach:Jt(!0,!1)},n={get(o){return Kt(this,o,!0,!0)},get size(){return Gt(this,!0)},has(o){return Wt.call(this,o,!0)},add:K("add"),set:K("set"),delete:K("delete"),clear:K("clear"),forEach:Jt(!0,!0)};return["keys","values","entries",Symbol.iterator].forEach(o=>{t[o]=Yt(o,!1,!1),r[o]=Yt(o,!0,!1),e[o]=Yt(o,!1,!0),n[o]=Yt(o,!0,!0)}),[t,r,e,n]}var[Bi,zi,Hi,Vi]=Fi();function xn(t,e){let r=e?t?Vi:Hi:t?zi:Bi;return(n,i,o)=>i==="__v_isReactive"?!t:i==="__v_isReadonly"?t:i==="__v_raw"?n:Reflect.get(wt(r,i)&&i in n?r:n,i,o)}var Ui={get:xn(!1,!1)};var qi={get:xn(!0,!1)};function yn(t,e,r){let n=h(r);if(n!==r&&e.call(t,n)){let i=Me(t);console.warn(`Reactive ${i} contains both the raw and reactive versions of the same object${i==="Map"?" as keys":""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`)}}var bn=new WeakMap,Ki=new WeakMap,wn=new WeakMap,Wi=new WeakMap;function Gi(t){switch(t){case"Object":case"Array":return 1;case"Map":case"Set":case"WeakMap":case"WeakSet":return 2;default:return 0}}function Ji(t){return t.__v_skip||!Object.isExtensible(t)?0:Gi(Me(t))}function Zt(t){return t&&t.__v_isReadonly?t:Sn(t,!1,$i,Ui,bn)}function En(t){return Sn(t,!0,Li,qi,wn)}function Sn(t,e,r,n,i){if(!Et(t))return console.warn(`value cannot be made reactive: ${String(t)}`),t;if(t.__v_raw&&!(e&&t.__v_isReactive))return t;let o=i.get(t);if(o)return o;let s=Ji(t);if(s===0)return t;let a=new Proxy(t,s===2?n:r);return i.set(t,a),a}function h(t){return t&&h(t.__v_raw)||t}function ke(t){return Boolean(t&&t.__v_isRef===!0)}x("nextTick",()=>at);x("dispatch",t=>Y.bind(Y,t));x("watch",(t,{evaluateLater:e,cleanup:r})=>(n,i)=>{let o=e(n),a=vt(()=>{let c;return o(l=>c=l),c},i);r(a)});x("store",Xr);x("data",t=>Tt(t));x("root",t=>X(t));x("refs",t=>(t._x_refs_proxy||(t._x_refs_proxy=P(Yi(t))),t._x_refs_proxy));function Yi(t){let e=[];return A(t,r=>{r._x_refs&&e.push(r._x_refs)}),e}var Be={};function ze(t){return Be[t]||(Be[t]=0),++Be[t]}function vn(t,e){return A(t,r=>{if(r._x_ids&&r._x_ids[e])return!0})}function An(t,e){t._x_ids||(t._x_ids={}),t._x_ids[e]||(t._x_ids[e]=ze(e))}x("id",(t,{cleanup:e})=>(r,n=null)=>{let i=`${r}${n?`-${n}`:""}`;return Xi(t,i,e,()=>{let o=vn(t,r),s=o?o._x_ids[r]:ze(r);return n?`${r}-${s}-${n}`:`${r}-${s}`})});U((t,e)=>{t._x_id&&(e._x_id=t._x_id)});function Xi(t,e,r,n){if(t._x_id||(t._x_id={}),t._x_id[e])return t._x_id[e];let i=n();return t._x_id[e]=i,r(()=>{delete t._x_id[e]}),i}x("el",t=>t);On("Focus","focus","focus");On("Persist","persist","persist");function On(t,e,r){x(e,n=>E(`You can't use [$${e}] without first installing the "${t}" plugin here: https://alpinejs.dev/plugins/${r}`,n))}p("modelable",(t,{expression:e},{effect:r,evaluateLater:n,cleanup:i})=>{let o=n(e),s=()=>{let u;return o(d=>u=d),u},a=n(`${e} = __placeholder`),c=u=>a(()=>{},{scope:{__placeholder:u}}),l=s();c(l),queueMicrotask(()=>{if(!t._x_model)return;t._x_removeModelListeners.default();let u=t._x_model.get,d=t._x_model.setWithModifiers,b=Ht({get(){return u()},set(g){d(g)}},{get(){return s()},set(g){c(g)}});i(b)})});p("teleport",(t,{modifiers:e,expression:r},{cleanup:n})=>{t.tagName.toLowerCase()!=="template"&&E("x-teleport can only be used on a <template> tag",t);let i=Cn(r),o=t.content.cloneNode(!0).firstElementChild;t._x_teleport=o,o._x_teleportBack=t,t.setAttribute("data-teleport-template",!0),o.setAttribute("data-teleport-target",!0),t._x_forwardEvents&&t._x_forwardEvents.forEach(a=>{o.addEventListener(a,c=>{c.stopPropagation(),t.dispatchEvent(new c.constructor(c.type,c))})}),N(o,{},t);let s=(a,c,l)=>{l.includes("prepend")?c.parentNode.insertBefore(a,c):l.includes("append")?c.parentNode.insertBefore(a,c.nextSibling):c.appendChild(a)};m(()=>{v(()=>{s(o,i,e),S(o)})()}),t._x_teleportPutBack=()=>{let a=Cn(r);m(()=>{s(t._x_teleport,a,e)})},n(()=>m(()=>{o.remove(),I(o)}))});var Zi=document.createElement("div");function Cn(t){let e=v(()=>document.querySelector(t),()=>Zi)();return e||E(`Cannot find x-teleport element for selector: "${t}"`),e}var Tn=()=>{};Tn.inline=(t,{modifiers:e},{cleanup:r})=>{e.includes("self")?t._x_ignoreSelf=!0:t._x_ignore=!0,r(()=>{e.includes("self")?delete t._x_ignoreSelf:delete t._x_ignore})};p("ignore",Tn);p("effect",v((t,{expression:e},{effect:r})=>{r(_(t,e))}));function H(t,e,r,n){let i=t,o=c=>n(c),s={},a=(c,l)=>u=>l(c,u);return r.includes("dot")&&(e=Qi(e)),r.includes("camel")&&(e=to(e)),r.includes("capture")&&(s.capture=!0),r.includes("window")&&(i=window),r.includes("document")&&(i=document),r.includes("passive")&&(s.passive=r[r.indexOf("passive")+1]!=="false"),o=He(r,o),r.includes("prevent")&&(o=a(o,(c,l)=>{l.preventDefault(),c(l)})),r.includes("stop")&&(o=a(o,(c,l)=>{l.stopPropagation(),c(l)})),r.includes("once")&&(o=a(o,(c,l)=>{c(l),i.removeEventListener(e,o,s)})),(r.includes("away")||r.includes("outside"))&&(i=document,o=a(o,(c,l)=>{t.contains(l.target)||l.target.isConnected!==!1&&(t.offsetWidth<1&&t.offsetHeight<1||t._x_isShown!==!1&&c(l))})),r.includes("self")&&(o=a(o,(c,l)=>{l.target===t&&c(l)})),e==="submit"&&(o=a(o,(c,l)=>{l.target._x_pendingModelUpdates&&l.target._x_pendingModelUpdates.forEach(u=>u()),c(l)})),(ro(e)||Mn(e))&&(o=a(o,(c,l)=>{no(l,r)||c(l)})),i.addEventListener(e,o,s),()=>{i.removeEventListener(e,o,s)}}function He(t,e){if(t.includes("debounce")){let r=t[t.indexOf("debounce")+1]||"invalid-wait",n=Qt(r.split("ms")[0])?Number(r.split("ms")[0]):250;e=Bt(e,n)}if(t.includes("throttle")){let r=t[t.indexOf("throttle")+1]||"invalid-wait",n=Qt(r.split("ms")[0])?Number(r.split("ms")[0]):250;e=zt(e,n)}return e}function Qi(t){return t.replace(/-/g,".")}function to(t){return t.toLowerCase().replace(/-(\w)/g,(e,r)=>r.toUpperCase())}function Qt(t){return!Array.isArray(t)&&!isNaN(t)}function eo(t){return[" ","_"].includes(t)?t:t.replace(/([a-z])([A-Z])/g,"$1-$2").replace(/[_\s]/,"-").toLowerCase()}function ro(t){return["keydown","keyup"].includes(t)}function Mn(t){return["contextmenu","click","mouse"].some(e=>t.includes(e))}function no(t,e){let r=e.filter(o=>!["window","document","prevent","stop","once","capture","self","away","outside","passive","preserve-scroll","blur","change","lazy"].includes(o));if(r.includes("debounce")){let o=r.indexOf("debounce");r.splice(o,Qt((r[o+1]||"invalid-wait").split("ms")[0])?2:1)}if(r.includes("throttle")){let o=r.indexOf("throttle");r.splice(o,Qt((r[o+1]||"invalid-wait").split("ms")[0])?2:1)}if(r.length===0||r.length===1&&Rn(t.key).includes(r[0]))return!1;let i=["ctrl","shift","alt","meta","cmd","super"].filter(o=>r.includes(o));return r=r.filter(o=>!i.includes(o)),!(i.length>0&&i.filter(s=>((s==="cmd"||s==="super")&&(s="meta"),t[`${s}Key`])).length===i.length&&(Mn(t.type)||Rn(t.key).includes(r[0])))}function Rn(t){if(!t)return[];t=eo(t);let e={ctrl:"control",slash:"/",space:" ",spacebar:" ",cmd:"meta",esc:"escape",up:"arrow-up",down:"arrow-down",left:"arrow-left",right:"arrow-right",period:".",comma:",",equal:"=",minus:"-",underscore:"_"};return e[t]=t,Object.keys(e).map(r=>{if(e[r]===t)return r}).filter(r=>r)}p("model",(t,{modifiers:e,expression:r},{effect:n,cleanup:i})=>{let o=t;e.includes("parent")&&(o=A(t,f=>f!==t));let s=_(o,r),a;typeof r=="string"?a=_(o,`${r} = __placeholder`):typeof r=="function"&&typeof r()=="string"?a=_(o,`${r()} = __placeholder`):a=()=>{};let c=()=>{let f;return s(y=>f=y),Nn(f)?f.get():f},l=f=>{let y;s(w=>y=w),Nn(y)?y.set(f):a(()=>{},{scope:{__placeholder:f}})};typeof r=="string"&&t.type==="radio"&&m(()=>{t.hasAttribute("name")||t.setAttribute("name",r)});let u=e.includes("change")||e.includes("lazy"),d=e.includes("blur"),b=e.includes("enter"),g=u||d||b,$;if(k)$=()=>{};else if(g){let f=[],y=w=>l(te(t,e,w,c()));if(u&&f.push(H(t,"change",e,y)),d&&(f.push(H(t,"blur",e,y)),t.form)){let w=t.form,et=()=>y({target:t});w._x_pendingModelUpdates||(w._x_pendingModelUpdates=[]),w._x_pendingModelUpdates.push(et),i(()=>{w._x_pendingModelUpdates&&w._x_pendingModelUpdates.splice(w._x_pendingModelUpdates.indexOf(et),1)})}b&&f.push(H(t,"keydown",e,w=>{w.key==="Enter"&&y(w)})),$=()=>f.forEach(w=>w())}else{let f=t.tagName.toLowerCase()==="select"||["checkbox","radio"].includes(t.type)?"change":"input";$=H(t,f,e,y=>{l(te(t,e,y,c()))})}if(e.includes("fill")&&([void 0,null,""].includes(c())||bt(t)&&Array.isArray(c())||t.tagName.toLowerCase()==="select"&&t.multiple)&&l(te(t,e,{target:t},c())),t._x_removeModelListeners||(t._x_removeModelListeners={}),t._x_removeModelListeners.default=$,i(()=>t._x_removeModelListeners.default()),t.form){let f=H(t.form,"reset",[],y=>{at(()=>t._x_model&&t._x_model.set(te(t,e,{target:t},c())))});i(()=>f())}if(t._x_model={get(){return c()},set(f){l(f)},setWithModifiers:He(e,l)},t._x_forceModelUpdate=f=>{f===void 0&&typeof r=="string"&&r.match(/\./)&&(f=""),m(()=>{bt(t)?Array.isArray(f)?t.checked=f.some(y=>y==t.value):t.checked=!!f:Ft(t)?typeof f=="boolean"?t.checked=yt(t.value)===f:t.checked=t.value==f:xt(t,"value",f)})},t.tagName==="SELECT"){let f=new MutationObserver(()=>{t._x_forceModelUpdate(c())});f.observe(t,{childList:!0}),i(()=>f.disconnect())}n(()=>{let f=c();e.includes("unintrusive")&&document.activeElement.isSameNode(t)||t._x_forceModelUpdate(f)})});function te(t,e,r,n){return m(()=>{if(r instanceof CustomEvent&&r.detail!==void 0)return r.detail!==null&&r.detail!==void 0?r.detail:r.target.value;if(bt(t))if(Array.isArray(n)){let i=null;return e.includes("number")?i=Ve(r.target.value):e.includes("boolean")?i=yt(r.target.value):i=r.target.value,r.target.checked?n.includes(i)?n:n.concat([i]):n.filter(o=>!io(o,i))}else return r.target.checked;else{if(t.tagName.toLowerCase()==="select"&&t.multiple)return e.includes("number")?Array.from(r.target.selectedOptions).map(i=>{let o=i.value||i.text;return Ve(o)}):e.includes("boolean")?Array.from(r.target.selectedOptions).map(i=>{let o=i.value||i.text;return yt(o)}):Array.from(r.target.selectedOptions).map(i=>i.value||i.text);{let i;return Ft(t)?r.target.checked?i=r.target.value:i=n:i=r.target.value,e.includes("number")?Ve(i):e.includes("boolean")?yt(i):e.includes("trim")?i.trim():i}}})}function Ve(t){let e=t?parseFloat(t):null;return oo(e)?e:t}function io(t,e){return t==e}function oo(t){return!Array.isArray(t)&&!isNaN(t)}function Nn(t){return t!==null&&typeof t=="object"&&typeof t.get=="function"&&typeof t.set=="function"}p("cloak",t=>queueMicrotask(()=>m(()=>t.removeAttribute(O("cloak")))));kt(()=>`[${O("init")}]`);p("init",v((t,{expression:e},{evaluate:r})=>typeof e=="string"?!!e.trim()&&r(e,{},!1):r(e,{},!1)));p("text",(t,{expression:e},{effect:r,evaluateLater:n})=>{let i=n(e);r(()=>{i(o=>{m(()=>{t.textContent=o})})})});p("html",(t,{expression:e},{effect:r,evaluateLater:n})=>{let i=n(e);r(()=>{i(o=>{m(()=>{t.innerHTML=o??"",t._x_ignoreSelf=!0,S(t),delete t._x_ignoreSelf})})})});st(Pt(":",Dt(O("bind:"))));var Pn=(t,{value:e,modifiers:r,expression:n,original:i},{effect:o,cleanup:s})=>{if(!e){let c={};tn(c),_(t,n)(u=>{Te(t,u,i)},{scope:c});return}if(e==="key")return so(t,n);if(t._x_inlineBindings&&t._x_inlineBindings[e]&&t._x_inlineBindings[e].extract)return;let a=_(t,n);o(()=>a(c=>{c===void 0&&typeof n=="string"&&n.match(/\./)&&(c=""),m(()=>xt(t,e,c,r))})),s(()=>{t._x_undoAddedClasses&&t._x_undoAddedClasses(),t._x_undoAddedStyles&&t._x_undoAddedStyles()})};Pn.inline=(t,{value:e,modifiers:r,expression:n})=>{e&&(t._x_inlineBindings||(t._x_inlineBindings={}),t._x_inlineBindings[e]={expression:n,extract:!1})};p("bind",Pn);function so(t,e){t._x_keyExpression=e}It(()=>`[${O("data")}]`);var tt=Symbol();p("data",(t,{expression:e},{cleanup:r})=>{if(co(t))return;let n=t[tt];if(n?.expression===e)return;e=e===""?"{}":e;let i={};V(i,t);let o={};nn(o,i);let s=T(t,e,{scope:o});(s===void 0||s===!0)&&(s={}),V(s,t);let a;if(n?.reactiveData){a=n.reactiveData,ao(a,s);let l={expression:e};t[tt]=l,queueMicrotask(()=>{t[tt]===l&&delete t[tt]})}else a=C(s);nt(a,r);let c=N(t,a);a.init&&T(t,a.init),r(()=>{a.destroy&&T(t,a.destroy),c();let l={reactiveData:a};t[tt]=l,queueMicrotask(()=>{t[tt]===l&&delete t[tt]})})});function ao(t,e){Object.keys(e).forEach(r=>{let n=Object.getOwnPropertyDescriptor(e,r),i=Object.getOwnPropertyDescriptor(t,r);n.get||n.set||i?.get||i?.set?(i&&delete t[r],i||(t[r]=void 0),n.get||n.set?Object.defineProperty(t,r,n):t[r]=e[r]):t[r]=e[r]}),Object.keys(t).filter(r=>!Object.prototype.hasOwnProperty.call(e,r)).forEach(r=>delete t[r])}U((t,e)=>{t._x_dataStack&&(e._x_dataStack=t._x_dataStack,e.setAttribute("data-has-alpine-state",!0))});function co(t){return k?Lt?!0:t.hasAttribute("data-has-alpine-state"):!1}p("show",(t,{modifiers:e,expression:r},{effect:n})=>{let i=_(t,r);t._x_doHide||(t._x_doHide=()=>{m(()=>{t.style.setProperty("display","none",e.includes("important")?"important":void 0)})}),t._x_doShow||(t._x_doShow=()=>{m(()=>{t.style.length===1&&t.style.display==="none"?t.removeAttribute("style"):t.style.removeProperty("display")})});let o=()=>{t._x_doHide(),t._x_isShown=!1},s=()=>{t._x_doShow(),t._x_isShown=!0},a=()=>setTimeout(s),c=_t(d=>d?s():o(),d=>{typeof t._x_toggleAndCascadeWithTransitions=="function"?t._x_toggleAndCascadeWithTransitions(t,d,s,o):d?a():o()}),l,u=!0;n(()=>i(d=>{!u&&d===l||(e.includes("immediate")&&(d?a():o()),c(d),l=d,u=!1)}))});p("for",v((t,{expression:e},{effect:r,cleanup:n})=>{let i=fo(e),o=_(t,i.items),s=_(t,t._x_keyExpression||"index");t._x_lookup=new Map,r(()=>uo(t,i,o,s)),n(()=>{t._x_lookup.forEach(a=>m(()=>{I(a),a.remove()})),delete t._x_lookup,delete t._x_lastRenderedEl})}));function lo(t){return e=>{Object.entries(e).forEach(([r,n])=>{t[r]=n})}}function uo(t,e,r,n){r(i=>{mo(i)&&(i=Array.from({length:i},(l,u)=>u+1)),i==null&&(i=[]),i instanceof Set&&(i=Array.from(i)),i instanceof Map&&(i=Array.from(i));let o=t._x_lookup,s=new Map;t._x_lookup=s;let a=ho(i),c=Object.entries(i).map(([l,u])=>{a||(l=parseInt(l));let d=po(e,u,l,i),b;return n(g=>{typeof g=="object"&&E("x-for key cannot be an object, it must be a string or an integer",t),o.has(g)&&(s.set(g,o.get(g)),o.delete(g)),b=g},{scope:{index:l,...d}}),[b,d]});m(()=>{o.forEach(d=>{I(d),d.remove()});let l=new Set,u=t;c.forEach(([d,b])=>{if(s.has(d)){let f=s.get(d);f._x_refreshXForScope(b),u.nextElementSibling!==f&&(u.nextElementSibling&&f.replaceWith(u.nextElementSibling),u.after(f)),u=f,f._x_currentIfEl&&(f.nextElementSibling!==f._x_currentIfEl&&u.after(f._x_currentIfEl),u=f._x_currentIfEl);return}t.content.children.length>1&&E("x-for templates require a single root element, additional elements will be ignored.",t);let g=document.importNode(t.content,!0).firstElementChild,$=C(b);N(g,$,t),g._x_refreshXForScope=lo($),s.set(d,g),l.add(g),u.after(g),u=g}),l.forEach(d=>S(d)),u!==t?t._x_lastRenderedEl=u:delete t._x_lastRenderedEl})})}function fo(t){let e=/,([^,\}\]]*)(?:,([^,\}\]]*))?$/,r=/^\s*\(|\)\s*$/g,n=/([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/,i=t.match(n);if(!i)return;let o={};o.items=i[2].trim();let s=i[1].replace(r,"").trim(),a=s.match(e);return a?(o.item=s.replace(e,"").trim(),o.index=a[1].trim(),a[2]&&(o.collection=a[2].trim())):o.item=s,o}function po(t,e,r,n){let i={};return/^\[.*\]$/.test(t.item)&&Array.isArray(e)?t.item.replace("[","").replace("]","").split(",").map(s=>s.trim()).forEach((s,a)=>{i[s]=e[a]}):/^\{.*\}$/.test(t.item)&&!Array.isArray(e)&&typeof e=="object"?t.item.replace("{","").replace("}","").split(",").map(s=>s.trim()).forEach(s=>{i[s]=e[s]}):i[t.item]=e,t.index&&(i[t.index]=r),t.collection&&(i[t.collection]=n),i}function mo(t){return typeof t!="object"&&!isNaN(t)}function ho(t){return typeof t=="object"&&!Array.isArray(t)}function Dn(){}Dn.inline=(t,{expression:e},{cleanup:r})=>{let n=X(t);n&&(n._x_refs||(n._x_refs={}),n._x_refs[e]=t,r(()=>delete n._x_refs[e]))};p("ref",Dn);p("if",v((t,{expression:e},{effect:r,cleanup:n})=>{t.tagName.toLowerCase()!=="template"&&E("x-if can only be used on a <template> tag",t);let i=_(t,e),o=()=>{if(t._x_currentIfEl)return t._x_currentIfEl;let a=t.content.cloneNode(!0).firstElementChild;return N(a,{},t),m(()=>{t.after(a),S(a)}),t._x_currentIfEl=a,t._x_lastRenderedEl=a,t._x_undoIf=()=>{m(()=>{I(a),a.remove()}),delete t._x_currentIfEl,delete t._x_lastRenderedEl},a},s=()=>{t._x_undoIf&&(t._x_undoIf(),delete t._x_undoIf)};r(()=>i(a=>{a?o():s()})),n(()=>t._x_undoIf&&t._x_undoIf())}));p("id",(t,{expression:e},{evaluate:r})=>{r(e).forEach(i=>An(t,i))});U((t,e)=>{t._x_ids&&(e._x_ids=t._x_ids)});st(Pt("@",Dt(O("on:"))));p("on",v((t,{value:e,modifiers:r,expression:n},{cleanup:i})=>{let o=n?_(t,n):()=>{};t.tagName.toLowerCase()==="template"&&(t._x_forwardEvents||(t._x_forwardEvents=[]),t._x_forwardEvents.includes(e)||t._x_forwardEvents.push(e));let s=H(t,e,r,a=>{o(()=>{},{scope:{$event:a},params:[a]})});i(()=>s())}));ee("Collapse","collapse","collapse");ee("Intersect","intersect","intersect");ee("Focus","trap","focus");ee("Mask","mask","mask");function ee(t,e,r){p(e,n=>E(`You can't use [x-${e}] without first installing the "${t}" plugin here: https://alpinejs.dev/plugins/${r}`,n))}B.setEvaluator(_r);B.setRawEvaluator(xr);B.setReactivityEngine({reactive:Zt,effect:dn,release:pn,raw:h});var Ue=B;window.Alpine=Ue;queueMicrotask(()=>{Ue.start()});})();
;
